/* tslint:disable */
/* eslint-disable */
/**
 * OsintFooting
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1761215701941
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ADIDCreateRequest
 */
export interface ADIDCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ADIDCreateRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDCreateRequest
     */
    'adid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDCreateRequest
     */
    'country'?: string;
    /**
     * 
     * @type {number}
     * @memberof ADIDCreateRequest
     */
    'requestItemId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDCreateRequest
     */
    'targetName'?: string;
    /**
     * 
     * @type {ADIDGeoDTO}
     * @memberof ADIDCreateRequest
     */
    'geoRequest'?: ADIDGeoDTO;
    /**
     * 
     * @type {string}
     * @memberof ADIDCreateRequest
     */
    'type'?: ADIDCreateRequestTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ADIDCreateRequestTypeEnum {
    Phone = 'PHONE',
    Adid = 'ADID',
    RequestId = 'REQUEST_ID',
    Geo = 'GEO'
}

/**
 * 
 * @export
 * @interface ADIDEntityDto
 */
export interface ADIDEntityDto {
    /**
     * 
     * @type {number}
     * @memberof ADIDEntityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDEntityDto
     */
    'adid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDEntityDto
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDEntityDto
     */
    'osName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDEntityDto
     */
    'osVersion'?: string;
}
/**
 * 
 * @export
 * @interface ADIDGeoDTO
 */
export interface ADIDGeoDTO {
    /**
     * 
     * @type {number}
     * @memberof ADIDGeoDTO
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ADIDGeoDTO
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ADIDGeoDTO
     */
    'radius'?: number;
}
/**
 * 
 * @export
 * @interface ADIDLocationEntityDto
 */
export interface ADIDLocationEntityDto {
    /**
     * 
     * @type {number}
     * @memberof ADIDLocationEntityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDLocationEntityDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDLocationEntityDto
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDLocationEntityDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDLocationEntityDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDLocationEntityDto
     */
    'ts'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDLocationEntityDto
     */
    'ip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDLocationEntityDto
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDLocationEntityDto
     */
    'carrier'?: string;
    /**
     * 
     * @type {number}
     * @memberof ADIDLocationEntityDto
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ADIDLocationEntityDto
     */
    'lng'?: number;
}
/**
 * 
 * @export
 * @interface ADIDProfileEntityDto
 */
export interface ADIDProfileEntityDto {
    /**
     * 
     * @type {number}
     * @memberof ADIDProfileEntityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto
     */
    'adid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto
     */
    'profileStatus'?: string;
    /**
     * 
     * @type {Set<ADIDLocationEntityDto>}
     * @memberof ADIDProfileEntityDto
     */
    'locations'?: Set<ADIDLocationEntityDto>;
    /**
     * 
     * @type {Set<ADIDEntityDto>}
     * @memberof ADIDProfileEntityDto
     */
    'adids'?: Set<ADIDEntityDto>;
    /**
     * 
     * @type {Set<ADIDRequestEntityDto>}
     * @memberof ADIDProfileEntityDto
     */
    'lookupRequests'?: Set<ADIDRequestEntityDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ADIDProfileEntityDto
     */
    'isFavorite'?: boolean;
}
/**
 * 
 * @export
 * @interface ADIDProfileEntityDto2
 */
export interface ADIDProfileEntityDto2 {
    /**
     * 
     * @type {number}
     * @memberof ADIDProfileEntityDto2
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto2
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto2
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto2
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto2
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDProfileEntityDto2
     */
    'profileStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ADIDProfileEntityDto2
     */
    'isFavorite'?: boolean;
}
/**
 * 
 * @export
 * @interface ADIDRequestEntityDto
 */
export interface ADIDRequestEntityDto {
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestEntityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto
     */
    'adid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {Set<ADIDRequestItemEntityDto>}
     * @memberof ADIDRequestEntityDto
     */
    'lookupRequestItems'?: Set<ADIDRequestItemEntityDto>;
    /**
     * 
     * @type {ADIDRequestEntityDto3}
     * @memberof ADIDRequestEntityDto
     */
    'rootRequest'?: ADIDRequestEntityDto3;
    /**
     * 
     * @type {Set<ADIDRequestEntityDto3>}
     * @memberof ADIDRequestEntityDto
     */
    'childRequests'?: Set<ADIDRequestEntityDto3>;
}
/**
 * 
 * @export
 * @interface ADIDRequestEntityDto2
 */
export interface ADIDRequestEntityDto2 {
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestEntityDto2
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto2
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto2
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto2
     */
    'adid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto2
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto2
     */
    'createdDate'?: string;
    /**
     * 
     * @type {Set<ADIDRequestItemEntityDto2>}
     * @memberof ADIDRequestEntityDto2
     */
    'lookupRequestItems'?: Set<ADIDRequestItemEntityDto2>;
    /**
     * 
     * @type {ADIDProfileEntityDto2}
     * @memberof ADIDRequestEntityDto2
     */
    'profile'?: ADIDProfileEntityDto2;
    /**
     * 
     * @type {ADIDRequestEntityDto3}
     * @memberof ADIDRequestEntityDto2
     */
    'rootRequest'?: ADIDRequestEntityDto3;
    /**
     * 
     * @type {Set<ADIDRequestEntityDto3>}
     * @memberof ADIDRequestEntityDto2
     */
    'childRequests'?: Set<ADIDRequestEntityDto3>;
}
/**
 * 
 * @export
 * @interface ADIDRequestEntityDto3
 */
export interface ADIDRequestEntityDto3 {
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestEntityDto3
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto3
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto3
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto3
     */
    'adid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto3
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestEntityDto3
     */
    'createdDate'?: string;
}
/**
 * 
 * @export
 * @interface ADIDRequestItemEntityDto
 */
export interface ADIDRequestItemEntityDto {
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestItemEntityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'dataStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'errorReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'rawResponse'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'serviceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestItemEntityDto
     */
    'progress'?: number;
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestItemEntityDto
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestItemEntityDto
     */
    'callBackRequestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto
     */
    'details'?: string;
    /**
     * 
     * @type {Set<ADIDResponseItemEntityDto>}
     * @memberof ADIDRequestItemEntityDto
     */
    'responseItems'?: Set<ADIDResponseItemEntityDto>;
}
/**
 * 
 * @export
 * @interface ADIDRequestItemEntityDto2
 */
export interface ADIDRequestItemEntityDto2 {
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestItemEntityDto2
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'dataStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'errorReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'rawResponse'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'serviceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestItemEntityDto2
     */
    'progress'?: number;
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestItemEntityDto2
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ADIDRequestItemEntityDto2
     */
    'callBackRequestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDRequestItemEntityDto2
     */
    'details'?: string;
    /**
     * 
     * @type {Set<ADIDResponseItemEntityDto2>}
     * @memberof ADIDRequestItemEntityDto2
     */
    'responseItems'?: Set<ADIDResponseItemEntityDto2>;
}
/**
 * 
 * @export
 * @interface ADIDResponseItemEntityDto
 */
export interface ADIDResponseItemEntityDto {
    /**
     * 
     * @type {number}
     * @memberof ADIDResponseItemEntityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDResponseItemEntityDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDResponseItemEntityDto
     */
    'source'?: ADIDResponseItemEntityDtoSourceEnum;
    /**
     * 
     * @type {Array<ADIDEntityDto>}
     * @memberof ADIDResponseItemEntityDto
     */
    'adids'?: Array<ADIDEntityDto>;
    /**
     * 
     * @type {Set<ADIDLocationEntityDto>}
     * @memberof ADIDResponseItemEntityDto
     */
    'locations'?: Set<ADIDLocationEntityDto>;
}

/**
    * @export
    * @enum {string}
    */
export enum ADIDResponseItemEntityDtoSourceEnum {
    CreatingTarget = 'CREATING_TARGET',
    ManualAdded = 'MANUAL_ADDED',
    WebCollection = 'WEB_COLLECTION',
    Adid = 'ADID',
    AdidGeo = 'ADID_GEO',
    Luna = 'LUNA',
    Pipl = 'PIPL',
    PiplPerson = 'PIPL_PERSON',
    PiplPossible = 'PIPL_POSSIBLE',
    PiplSource = 'PIPL_SOURCE',
    Pluto = 'PLUTO',
    Botim = 'BOTIM',
    Skype = 'SKYPE',
    Whatsapp = 'WHATSAPP',
    Callapp = 'CALLAPP',
    Tamtam = 'TAMTAM',
    Imo = 'IMO',
    Tc = 'TC',
    Telegram = 'TELEGRAM',
    Drupe = 'DRUPE',
    Getcontact = 'GETCONTACT',
    Viber = 'VIBER',
    Eyecon = 'EYECON',
    Hiya = 'HIYA',
    Viewcaller = 'VIEWCALLER',
    Kraken = 'KRAKEN',
    Hydra = 'HYDRA',
    Syncme = 'SYNCME',
    Line = 'LINE',
    Wechat = 'WECHAT',
    Vkontakte = 'VKONTAKTE',
    Zalo = 'ZALO',
    Showcaller = 'SHOWCALLER',
    Swarmapp = 'SWARMAPP',
    Numbuster = 'NUMBUSTER',
    Me = 'ME',
    Deepweb = 'DEEPWEB',
    MmImage = 'MM_IMAGE',
    ProfileImage = 'PROFILE_IMAGE',
    FindCloneImage = 'FIND_CLONE_IMAGE',
    Search4FaceImage = 'SEARCH_4_FACE_IMAGE',
    SniperImage = 'SNIPER_IMAGE',
    PsychoProfile = 'PSYCHO_PROFILE',
    Crawler = 'CRAWLER'
}

/**
 * 
 * @export
 * @interface ADIDResponseItemEntityDto2
 */
export interface ADIDResponseItemEntityDto2 {
    /**
     * 
     * @type {number}
     * @memberof ADIDResponseItemEntityDto2
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ADIDResponseItemEntityDto2
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ADIDResponseItemEntityDto2
     */
    'source'?: ADIDResponseItemEntityDto2SourceEnum;
    /**
     * 
     * @type {Array<ADIDEntityDto>}
     * @memberof ADIDResponseItemEntityDto2
     */
    'adids'?: Array<ADIDEntityDto>;
}

/**
    * @export
    * @enum {string}
    */
export enum ADIDResponseItemEntityDto2SourceEnum {
    CreatingTarget = 'CREATING_TARGET',
    ManualAdded = 'MANUAL_ADDED',
    WebCollection = 'WEB_COLLECTION',
    Adid = 'ADID',
    AdidGeo = 'ADID_GEO',
    Luna = 'LUNA',
    Pipl = 'PIPL',
    PiplPerson = 'PIPL_PERSON',
    PiplPossible = 'PIPL_POSSIBLE',
    PiplSource = 'PIPL_SOURCE',
    Pluto = 'PLUTO',
    Botim = 'BOTIM',
    Skype = 'SKYPE',
    Whatsapp = 'WHATSAPP',
    Callapp = 'CALLAPP',
    Tamtam = 'TAMTAM',
    Imo = 'IMO',
    Tc = 'TC',
    Telegram = 'TELEGRAM',
    Drupe = 'DRUPE',
    Getcontact = 'GETCONTACT',
    Viber = 'VIBER',
    Eyecon = 'EYECON',
    Hiya = 'HIYA',
    Viewcaller = 'VIEWCALLER',
    Kraken = 'KRAKEN',
    Hydra = 'HYDRA',
    Syncme = 'SYNCME',
    Line = 'LINE',
    Wechat = 'WECHAT',
    Vkontakte = 'VKONTAKTE',
    Zalo = 'ZALO',
    Showcaller = 'SHOWCALLER',
    Swarmapp = 'SWARMAPP',
    Numbuster = 'NUMBUSTER',
    Me = 'ME',
    Deepweb = 'DEEPWEB',
    MmImage = 'MM_IMAGE',
    ProfileImage = 'PROFILE_IMAGE',
    FindCloneImage = 'FIND_CLONE_IMAGE',
    Search4FaceImage = 'SEARCH_4_FACE_IMAGE',
    SniperImage = 'SNIPER_IMAGE',
    PsychoProfile = 'PSYCHO_PROFILE',
    Crawler = 'CRAWLER'
}

/**
 * 
 * @export
 * @interface AIAction
 */
export interface AIAction {
    /**
     * 
     * @type {Array<Action>}
     * @memberof AIAction
     */
    'content'?: Array<Action>;
}
/**
 * 
 * @export
 * @interface AIResult
 */
export interface AIResult {
    /**
     * 
     * @type {number}
     * @memberof AIResult
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof AIResult
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof AIResult
     */
    'trend'?: string;
    /**
     * 
     * @type {string}
     * @memberof AIResult
     */
    'suggestion'?: string;
    /**
     * 
     * @type {number}
     * @memberof AIResult
     */
    'threshold'?: number;
}
/**
 * 
 * @export
 * @interface APAProfileDTO
 */
export interface APAProfileDTO {
    /**
     * 
     * @type {string}
     * @memberof APAProfileDTO
     */
    'caseName'?: string;
    /**
     * 
     * @type {string}
     * @memberof APAProfileDTO
     */
    'investigationName'?: string;
    /**
     * 
     * @type {Array<SocialProfileData>}
     * @memberof APAProfileDTO
     */
    'profiles'?: Array<SocialProfileData>;
}
/**
 * 
 * @export
 * @interface APAWebintDTO
 */
export interface APAWebintDTO {
    /**
     * 
     * @type {string}
     * @memberof APAWebintDTO
     */
    'caseName'?: string;
    /**
     * 
     * @type {string}
     * @memberof APAWebintDTO
     */
    'investigationName'?: string;
    /**
     * 
     * @type {WebIntEntity}
     * @memberof APAWebintDTO
     */
    'webintEntity'?: WebIntEntity;
}
/**
 * 
 * @export
 * @interface Action
 */
export interface Action {
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'content'?: string;
    /**
     * 
     * @type {number}
     * @memberof Action
     */
    'timestamp'?: number;
}
/**
 * 
 * @export
 * @interface ActionCreateRequest
 */
export interface ActionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'socialProfileId': string;
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'activity': ActionCreateRequestActivityEnum;
    /**
     * 
     * @type {number}
     * @memberof ActionCreateRequest
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'base64photo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'postId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'source'?: ActionCreateRequestSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'parentActionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionCreateRequest
     */
    'requestId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ActionCreateRequestActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}
/**
    * @export
    * @enum {string}
    */
export enum ActionCreateRequestSourceEnum {
    Manual = 'MANUAL',
    Ai = 'AI',
    Url = 'URL',
    Update = 'UPDATE',
    File = 'FILE'
}

/**
 * 
 * @export
 * @interface ActionDto
 */
export interface ActionDto {
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'id'?: string;
    /**
     * 
     * @type {AvatarCampaignDto}
     * @memberof ActionDto
     */
    'avatar'?: AvatarCampaignDto;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'activity'?: ActionDtoActivityEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'socialProfileId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionDto
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'base64photo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'postId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'source'?: ActionDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'stepId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'campaignId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'parentActionId'?: string;
    /**
     * 
     * @type {ActionDto}
     * @memberof ActionDto
     */
    'parentAction'?: ActionDto;
    /**
     * 
     * @type {Array<ActionDto>}
     * @memberof ActionDto
     */
    'childAction'?: Array<ActionDto>;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'requestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'state'?: ActionDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionDto
     */
    'resolvedAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'info'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActionDto
     */
    'originalLikeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActionDto
     */
    'originalCommentCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'msg'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ActionDto
     */
    'actionStat'?: { [key: string]: number; };
}

/**
    * @export
    * @enum {string}
    */
export enum ActionDtoActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}
/**
    * @export
    * @enum {string}
    */
export enum ActionDtoSourceEnum {
    Manual = 'MANUAL',
    Ai = 'AI',
    Url = 'URL',
    Update = 'UPDATE',
    File = 'FILE'
}
/**
    * @export
    * @enum {string}
    */
export enum ActionDtoStateEnum {
    Scheduled = 'SCHEDULED',
    Sent = 'SENT',
    InProgress = 'IN_PROGRESS',
    Failed = 'FAILED',
    Error = 'ERROR',
    Success = 'SUCCESS'
}

/**
 * 
 * @export
 * @interface ActionGenerateRequest
 */
export interface ActionGenerateRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateRequest
     */
    'activity': ActionGenerateRequestActivityEnum;
    /**
     * 
     * @type {number}
     * @memberof ActionGenerateRequest
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActionGenerateRequest
     */
    'countPreviousAction'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateRequest
     */
    'sortDirectionPreviousAction'?: ActionGenerateRequestSortDirectionPreviousActionEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateRequest
     */
    'parentActionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateRequest
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateRequest
     */
    'userMessage'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ActionGenerateRequestActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}
/**
    * @export
    * @enum {string}
    */
export enum ActionGenerateRequestSortDirectionPreviousActionEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}

/**
 * 
 * @export
 * @interface ActionGenerateResponseDto
 */
export interface ActionGenerateResponseDto {
    /**
     * 
     * @type {AIAction}
     * @memberof ActionGenerateResponseDto
     */
    'actions'?: AIAction;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateResponseDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateResponseDto
     */
    'requestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateResponseDto
     */
    'activity'?: ActionGenerateResponseDtoActivityEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateResponseDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateResponseDto
     */
    'stepId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionGenerateResponseDto
     */
    'campaignId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ActionGenerateResponseDtoActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}

/**
 * 
 * @export
 * @interface ActionGetRequest
 */
export interface ActionGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionGetRequest
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ActionGetRequest
     */
    'displayAllChildAction'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ActionGetRequest
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActionGetRequest
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface ActionPageRequest
 */
export interface ActionPageRequest {
    /**
     * 
     * @type {number}
     * @memberof ActionPageRequest
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActionPageRequest
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionPageRequest
     */
    'activity'?: ActionPageRequestActivityEnum;
    /**
     * 
     * @type {number}
     * @memberof ActionPageRequest
     */
    'startPeriod'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActionPageRequest
     */
    'endPeriod'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ActionPageRequestActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}

/**
 * 
 * @export
 * @interface ActionUpdateRequest
 */
export interface ActionUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    'socialProfileId': string;
    /**
     * 
     * @type {number}
     * @memberof ActionUpdateRequest
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    'base64photo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    'postId'?: string;
}
/**
 * 
 * @export
 * @interface AdditionalFriendStatistic
 */
export interface AdditionalFriendStatistic {
    /**
     * 
     * @type {string}
     * @memberof AdditionalFriendStatistic
     */
    'socialNetwork'?: AdditionalFriendStatisticSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof AdditionalFriendStatistic
     */
    'socialProfileId'?: string;
    /**
     * 
     * @type {Set<LookupRequestItemStat>}
     * @memberof AdditionalFriendStatistic
     */
    'stat'?: Set<LookupRequestItemStat>;
}

/**
    * @export
    * @enum {string}
    */
export enum AdditionalFriendStatisticSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface AdditionalFriendsResp
 */
export interface AdditionalFriendsResp {
    /**
     * 
     * @type {Set<CrawlerResponseDTO>}
     * @memberof AdditionalFriendsResp
     */
    'content'?: Set<CrawlerResponseDTO>;
    /**
     * 
     * @type {Array<AdditionalFriendStatistic>}
     * @memberof AdditionalFriendsResp
     */
    'statistics'?: Array<AdditionalFriendStatistic>;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'poBox'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'house'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'apartment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'raw'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'display'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'validCountry'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'validState'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'viableAddressSearch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface Age
 */
export interface Age {
    /**
     * 
     * @type {string}
     * @memberof Age
     */
    'profileCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Age
     */
    'currentDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof Age
     */
    'threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof Age
     */
    'age'?: number;
}
/**
 * 
 * @export
 * @interface Alert
 */
export interface Alert {
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'targetId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    'createdTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    'contentDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'content'?: string;
    /**
     * 
     * @type {AlertCriteria}
     * @memberof Alert
     */
    'alertCriteria'?: AlertCriteria;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'socialNetwork'?: AlertSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'module'?: AlertModuleEnum;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'alertType'?: AlertAlertTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'subType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'referenceUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'postIdItem'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    'postUrl'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AlertSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}
/**
    * @export
    * @enum {string}
    */
export enum AlertModuleEnum {
    Profiler = 'PROFILER',
    Webint = 'WEBINT'
}
/**
    * @export
    * @enum {string}
    */
export enum AlertAlertTypeEnum {
    Keyword = 'KEYWORD',
    FaceImage = 'FACE_IMAGE',
    PostAuditoryInGroup = 'POST_AUDITORY_IN_GROUP',
    GroupMembers = 'GROUP_MEMBERS',
    UserActivityInGroup = 'USER_ACTIVITY_IN_GROUP',
    GroupPublicationsBurst = 'GROUP_PUBLICATIONS_BURST',
    GroupCommentsBurst = 'GROUP_COMMENTS_BURST',
    SystemAlert = 'SYSTEM_ALERT'
}

/**
 * 
 * @export
 * @interface AlertCriteria
 */
export interface AlertCriteria {
    /**
     * 
     * @type {string}
     * @memberof AlertCriteria
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertCriteria
     */
    'alertType': AlertCriteriaAlertTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AlertCriteria
     */
    'ownedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertCriteria
     */
    'keyword'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertCriteria
     */
    'faceImageURL'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlertCriteria
     */
    'faceImageMatchScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertCriteria
     */
    'targetID'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlertCriteria
     */
    'membersThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertCriteria
     */
    'auditoryThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertCriteria
     */
    'publicationBurstThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertCriteria
     */
    'commentsBurstThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertCriteria
     */
    'userActivityInGroupThreshold'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertCriteria
     */
    'userSocialNetworkID'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertCriteria
     */
    'activeForProfiler': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlertCriteria
     */
    'activeForWebint': boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertCriteria
     */
    'userSocialNetworkType'?: string;
    /**
     * 
     * @type {TelegramIntegration}
     * @memberof AlertCriteria
     */
    'telegramIntegration'?: TelegramIntegration;
}

/**
    * @export
    * @enum {string}
    */
export enum AlertCriteriaAlertTypeEnum {
    Keyword = 'KEYWORD',
    FaceImage = 'FACE_IMAGE',
    PostAuditoryInGroup = 'POST_AUDITORY_IN_GROUP',
    GroupMembers = 'GROUP_MEMBERS',
    UserActivityInGroup = 'USER_ACTIVITY_IN_GROUP',
    GroupPublicationsBurst = 'GROUP_PUBLICATIONS_BURST',
    GroupCommentsBurst = 'GROUP_COMMENTS_BURST',
    SystemAlert = 'SYSTEM_ALERT'
}

/**
 * 
 * @export
 * @interface AlertFilter
 */
export interface AlertFilter {
    /**
     * 
     * @type {number}
     * @memberof AlertFilter
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertFilter
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertFilter
     */
    'startTimestamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertFilter
     */
    'endTimestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertFilter
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertFilter
     */
    'targetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertFilter
     */
    'alertContent'?: string;
    /**
     * 
     * @type {AlertCriteria}
     * @memberof AlertFilter
     */
    'alertCriteria'?: AlertCriteria;
    /**
     * 
     * @type {string}
     * @memberof AlertFilter
     */
    'alertType'?: AlertFilterAlertTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AlertFilterAlertTypeEnum {
    Keyword = 'KEYWORD',
    FaceImage = 'FACE_IMAGE',
    PostAuditoryInGroup = 'POST_AUDITORY_IN_GROUP',
    GroupMembers = 'GROUP_MEMBERS',
    UserActivityInGroup = 'USER_ACTIVITY_IN_GROUP',
    GroupPublicationsBurst = 'GROUP_PUBLICATIONS_BURST',
    GroupCommentsBurst = 'GROUP_COMMENTS_BURST',
    SystemAlert = 'SYSTEM_ALERT'
}

/**
 * 
 * @export
 * @interface AnalyticItemsRequest
 */
export interface AnalyticItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticItemsRequest
     */
    'items'?: AnalyticItemsRequestItemsEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnalyticItemsRequest
     */
    'itemsIds'?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum AnalyticItemsRequestItemsEnum {
    Targets = 'targets',
    Cases = 'cases',
    Investigations = 'investigations'
}

/**
 * 
 * @export
 * @interface AnalyticItemsResponse
 */
export interface AnalyticItemsResponse {
    /**
     * 
     * @type {Set<FriendNode | GameNode | GroupNode | ProfileNode>}
     * @memberof AnalyticItemsResponse
     */
    'nodes'?: Set<FriendNode | GameNode | GroupNode | ProfileNode>;
    /**
     * 
     * @type {Set<Link>}
     * @memberof AnalyticItemsResponse
     */
    'links'?: Set<Link>;
}
/**
 * 
 * @export
 * @interface AssistantResponseDTO
 */
export interface AssistantResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssistantResponseDTO
     */
    'profileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'requestEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'assistantMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'threadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'errorReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'failedResponse'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssistantResponseDTO
     */
    'completionTokens'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssistantResponseDTO
     */
    'assistantProviderMessageID'?: string;
}
/**
 * 
 * @export
 * @interface AsyncTaskDTO
 */
export interface AsyncTaskDTO {
    /**
     * 
     * @type {string}
     * @memberof AsyncTaskDTO
     */
    'asyncTaskID'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsyncTaskDTO
     */
    'status'?: AsyncTaskDTOStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AsyncTaskDTOStatusEnum {
    InProgress = 'IN_PROGRESS',
    Completed = 'COMPLETED',
    Failed = 'FAILED'
}

/**
 * 
 * @export
 * @interface AuditActionDTO
 */
export interface AuditActionDTO {
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'actionType'?: AuditActionDTOActionTypeEnum;
    /**
     * 
     * @type {Array<object>}
     * @memberof AuditActionDTO
     */
    'args'?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof AuditActionDTO
     */
    'createdTimestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'status'?: AuditActionDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'activityType'?: AuditActionDTOActivityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDTO
     */
    'domain'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AuditActionDTOActionTypeEnum {
    Login = 'LOGIN',
    Logout = 'LOGOUT',
    CreateJob = 'CREATE_JOB',
    CreateRangeJob = 'CREATE_RANGE_JOB',
    Job = 'JOB',
    Ping = 'PING',
    Image = 'IMAGE',
    ImageClearStorage = 'IMAGE_CLEAR_STORAGE',
    Audit = 'AUDIT',
    User = 'USER',
    Profile = 'PROFILE',
    HealthStatus = 'HEALTH_STATUS',
    Delete = 'DELETE',
    Search4Faces = 'SEARCH_4_FACES',
    System = 'SYSTEM',
    Alerts = 'ALERTS',
    Profiler = 'PROFILER',
    Webint = 'WEBINT',
    Avatars = 'AVATARS',
    Activities = 'ACTIVITIES',
    AuditEp = 'AUDIT_EP',
    Adid = 'ADID',
    Campaign = 'CAMPAIGN'
}
/**
    * @export
    * @enum {string}
    */
export enum AuditActionDTOStatusEnum {
    Scheduled = 'SCHEDULED',
    Sent = 'SENT',
    InProgress = 'IN_PROGRESS',
    Failed = 'FAILED',
    Error = 'ERROR',
    Success = 'SUCCESS'
}
/**
    * @export
    * @enum {string}
    */
export enum AuditActionDTOActivityTypeEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}

/**
 * 
 * @export
 * @interface AuditCreationReq
 */
export interface AuditCreationReq {
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'details'?: AuditCreationReqDetailsEnum;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'actionType'?: AuditCreationReqActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'logType'?: AuditCreationReqLogTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'fileName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuditCreationReq
     */
    'phoneNumbers'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditCreationReq
     */
    'role'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AuditCreationReqDetailsEnum {
    UserNotFound = 'USER_NOT_FOUND',
    GetAuditsLog = 'GET_AUDITS_LOG',
    SuccessLogin = 'SUCCESS_LOGIN',
    SuccessLogout = 'SUCCESS_LOGOUT',
    Ping = 'PING',
    GetAllStatuses = 'GET_ALL_STATUSES',
    GetServiceStatus = 'GET_SERVICE_STATUS',
    GetImage = 'GET_IMAGE',
    ClearStorageInRekognition = 'CLEAR_STORAGE_IN_REKOGNITION',
    CreateAdditionalJob = 'CREATE_ADDITIONAL_JOB',
    ChangeJobStatus = 'CHANGE_JOB_STATUS',
    GetMainJob = 'GET_MAIN_JOB',
    SearchProfiles = 'SEARCH_PROFILES',
    ExportProfiles = 'EXPORT_PROFILES',
    ExportProfilesJson = 'EXPORT_PROFILES_JSON',
    SearchProfileByImage = 'SEARCH_PROFILE_BY_IMAGE',
    SearchProfilesByPhone = 'SEARCH_PROFILES_BY_PHONE',
    GetProfileByImageIds = 'GET_PROFILE_BY_IMAGE_IDS',
    RegisterNewUser = 'REGISTER_NEW_USER',
    SearchUsers = 'SEARCH_USERS',
    CouldNotFindPhone = 'COULD_NOT_FIND_PHONE',
    CouldNotFindIteration = 'COULD_NOT_FIND_ITERATION',
    CouldNotFindBatch = 'COULD_NOT_FIND_BATCH',
    CouldNotFindJob = 'COULD_NOT_FIND_JOB',
    UserDoesNotExist = 'USER_DOES_NOT_EXIST',
    GroupDoesNotExist = 'GROUP_DOES_NOT_EXIST',
    MaturityEnabledEntityDoesNotExist = 'MATURITY_ENABLED_ENTITY_DOES_NOT_EXIST',
    GroupIdNotFound = 'GROUP_ID_NOT_FOUND',
    UsernameAddressAlreadyInUse = 'USERNAME_ADDRESS_ALREADY_IN_USE',
    GroupnameAddressAlreadyInUse = 'GROUPNAME_ADDRESS_ALREADY_IN_USE',
    CouldNotDeleteItself = 'COULD_NOT_DELETE_ITSELF',
    CouldNotDeleteUserAnotherGroup = 'COULD_NOT_DELETE_USER_ANOTHER_GROUP',
    JobDoesNotExist = 'JOB_DOES_NOT_EXIST',
    InappropriateJobStatus = 'INAPPROPRIATE_JOB_STATUS',
    JobSentAllPhonesToLookup = 'JOB_SENT_ALL_PHONES_TO_LOOKUP',
    MainJobCouldNotBeCanceled = 'MAIN_JOB_COULD_NOT_BE_CANCELED',
    ImportProfile = 'IMPORT_PROFILE',
    DetectFaces = 'DETECT_FACES',
    SearchFace = 'SEARCH_FACE',
    JobList = 'JOB_LIST',
    JobProfiles = 'JOB_PROFILES',
    Update = 'UPDATE',
    GetCaseProfiles = 'GET_CASE_PROFILES',
    QuotaObjectNotSet = 'QUOTA_OBJECT_NOT_SET',
    QuotaPeriodObjectNotSet = 'QUOTA_PERIOD_OBJECT_NOT_SET',
    PermissionsObjectNotSet = 'PERMISSIONS_OBJECT_NOT_SET',
    QuotaMaxCrawlerPerUserInvalid = 'QUOTA_MAX_CRAWLER_PER_USER_INVALID',
    QuotaMaxCasesPerUserInvalid = 'QUOTA_MAX_CASES_PER_USER_INVALID',
    QuotaMaxLookupPerUserInvalid = 'QUOTA_MAX_LOOKUP_PER_USER_INVALID',
    QuotaMaxPeriodicalopsPerUserInvalid = 'QUOTA_MAX_PERIODICALOPS_PER_USER_INVALID',
    UndefinedCaseType = 'UNDEFINED_CASE_TYPE',
    InsufficientQuotaToPerformOperation = 'INSUFFICIENT_QUOTA_TO_PERFORM_OPERATION',
    InsufficientDailyQuotaToPerformOperation = 'INSUFFICIENT_DAILY_QUOTA_TO_PERFORM_OPERATION',
    QuotaIsExpired = 'QUOTA_IS_EXPIRED',
    QuotaIsNotStartedYet = 'QUOTA_IS_NOT_STARTED_YET',
    SendAvatarActivityToCrawler = 'SEND_AVATAR_ACTIVITY_TO_CRAWLER',
    InvalidOrForbiddenUsername = 'INVALID_OR_FORBIDDEN_USERNAME',
    AddTargetInformation = 'ADD_TARGET_INFORMATION',
    Status = 'STATUS',
    WebintTargetMonitoringLimitExceeded = 'WEBINT_TARGET_MONITORING_LIMIT_EXCEEDED',
    Login = 'LOGIN',
    Logout = 'LOGOUT',
    AddUser = 'ADD_USER',
    AddGroup = 'ADD_GROUP',
    GetGroups = 'GET_GROUPS',
    GetGroupQuota = 'GET_GROUP_QUOTA',
    UpdateGroup = 'UPDATE_GROUP',
    MaturityEnable = 'MATURITY_ENABLE',
    ApiAaControl = 'API_AA_CONTROL',
    MaturityDisable = 'MATURITY_DISABLE',
    ManualRunMaturity = 'MANUAL_RUN_MATURITY',
    GetChecklist = 'GET_CHECKLIST',
    UpdateChecklist = 'UPDATE_CHECKLIST',
    DeleteGroup = 'DELETE_GROUP',
    DeleteFullGroup = 'DELETE_FULL_GROUP',
    RecoveryGroup = 'RECOVERY_GROUP',
    GetAllPermission = 'GET_ALL_PERMISSION',
    GetGroupPermission = 'GET_GROUP_PERMISSION',
    GetUserPermission = 'GET_USER_PERMISSION',
    DeleteUser = 'DELETE_USER',
    UpdateUser = 'UPDATE_USER',
    RenameUser = 'RENAME_USER',
    Export = 'EXPORT',
    Import = 'IMPORT',
    MonitoringOn = 'MONITORING_ON',
    MonitoringOff = 'MONITORING_OFF',
    Audit = 'AUDIT',
    CreateCase = 'CREATE_CASE',
    UpdateCase = 'UPDATE_CASE',
    DeleteCase = 'DELETE_CASE',
    ArchivedCase = 'ARCHIVED_CASE',
    UnarchivedCase = 'UNARCHIVED_CASE',
    CreateInvestigation = 'CREATE_INVESTIGATION',
    UpdateInvestigation = 'UPDATE_INVESTIGATION',
    ArchivedInvestigation = 'ARCHIVED_INVESTIGATION',
    UnarchivedInvestigation = 'UNARCHIVED_INVESTIGATION',
    DeleteInvestigation = 'DELETE_INVESTIGATION',
    MonitoringIterationComplete = 'MONITORING_ITERATION_COMPLETE',
    AvatarNotFound = 'AVATAR_NOT_FOUND',
    MonitoringEnded = 'MONITORING_ENDED',
    AvatarBlocked = 'AVATAR_BLOCKED',
    AvatarAutoQuarantined = 'AVATAR_AUTO_QUARANTINED',
    AvatarInProgressLongTime = 'AVATAR_IN_PROGRESS_LONG_TIME',
    CreateAlert = 'CREATE_ALERT',
    DeleteAlert = 'DELETE_ALERT',
    SetFavoriteTarget = 'SET_FAVORITE_TARGET',
    CreateProfile = 'CREATE_PROFILE',
    CreateAdidProfile = 'CREATE_ADID_PROFILE',
    DeleteProfile = 'DELETE_PROFILE',
    DeleteRequest = 'DELETE_REQUEST',
    GetProfile = 'GET_PROFILE',
    GetAdidProfile = 'GET_ADID_PROFILE',
    GetAdidPhoneRequests = 'GET_ADID_PHONE_REQUESTS',
    SetDisplayNameProfile = 'SET_DISPLAY_NAME_PROFILE',
    GetFullProfile = 'GET_FULL_PROFILE',
    GetFullProfiles = 'GET_FULL_PROFILES',
    UpdateProfile = 'UPDATE_PROFILE',
    CrawlProfile = 'CRAWL_PROFILE',
    FaceRecognition = 'FACE_RECOGNITION',
    DeleteSource = 'DELETE_SOURCE',
    DeleteLookuprequest = 'DELETE_LOOKUPREQUEST',
    LinkAnalysis = 'LINK_ANALYSIS',
    AssistantProfileAnalyze = 'ASSISTANT_PROFILE_ANALYZE',
    AssistantChat = 'ASSISTANT_CHAT',
    AiProfileAnalyze = 'AI_PROFILE_ANALYZE',
    AiProfilePostAnalyze = 'AI_PROFILE_POST_ANALYZE',
    ImageInSize = 'IMAGE_IN_SIZE',
    CreateTask = 'CREATE_TASK',
    DeleteTask = 'DELETE_TASK',
    GetTask = 'GET_TASK',
    UpdateTask = 'UPDATE_TASK',
    CrawlTask = 'CRAWL_TASK',
    AiWebintAnalyze = 'AI_WEBINT_ANALYZE',
    AiWebintPostAnalyze = 'AI_WEBINT_POST_ANALYZE',
    CreateAvatar = 'CREATE_AVATAR',
    DeleteAvatar = 'DELETE_AVATAR',
    GetAvatar = 'GET_AVATAR',
    UpdateAvatar = 'UPDATE_AVATAR',
    EditAvatar = 'EDIT_AVATAR',
    ManualQuarantine = 'MANUAL_QUARANTINE',
    AutoQuarantine = 'AUTO_QUARANTINE',
    TemporalQuarantine = 'TEMPORAL_QUARANTINE',
    EditQuarantineScheme = 'EDIT_QUARANTINE_SCHEME',
    MaturityResponse = 'MATURITY_RESPONSE',
    MaturityRequest = 'MATURITY_REQUEST',
    UpdateAvatarModule = 'UPDATE_AVATAR_MODULE',
    TaskLinkUpdate = 'TASK_LINK_UPDATE',
    ExportLogs = 'EXPORT_LOGS',
    CreateProxy = 'CREATE_PROXY',
    EditProxy = 'EDIT_PROXY',
    AddProfile = 'ADD_PROFILE',
    EditProfile = 'EDIT_PROFILE',
    ControlMaturity = 'CONTROL_MATURITY',
    ApaAvatarInteraction = 'APA_AVATAR_INTERACTION',
    CreateActivity = 'CREATE_ACTIVITY',
    UpdateActivity = 'UPDATE_ACTIVITY',
    DeleteActivity = 'DELETE_ACTIVITY',
    Autologin = 'AUTOLOGIN',
    Url = 'URL',
    UserPost = 'USER_POST',
    GroupPost = 'GROUP_POST',
    Like = 'LIKE',
    Comment = 'COMMENT',
    CreateCampaign = 'CREATE_CAMPAIGN',
    CreateActivityError = 'CREATE_ACTIVITY_ERROR',
    UpdateCampaign = 'UPDATE_CAMPAIGN',
    AssignUserCampaign = 'ASSIGN_USER_CAMPAIGN'
}
/**
    * @export
    * @enum {string}
    */
export enum AuditCreationReqActionTypeEnum {
    Login = 'LOGIN',
    Logout = 'LOGOUT',
    CreateJob = 'CREATE_JOB',
    CreateRangeJob = 'CREATE_RANGE_JOB',
    Job = 'JOB',
    Ping = 'PING',
    Image = 'IMAGE',
    ImageClearStorage = 'IMAGE_CLEAR_STORAGE',
    Audit = 'AUDIT',
    User = 'USER',
    Profile = 'PROFILE',
    HealthStatus = 'HEALTH_STATUS',
    Delete = 'DELETE',
    Search4Faces = 'SEARCH_4_FACES',
    System = 'SYSTEM',
    Alerts = 'ALERTS',
    Profiler = 'PROFILER',
    Webint = 'WEBINT',
    Avatars = 'AVATARS',
    Activities = 'ACTIVITIES',
    AuditEp = 'AUDIT_EP',
    Adid = 'ADID',
    Campaign = 'CAMPAIGN'
}
/**
    * @export
    * @enum {string}
    */
export enum AuditCreationReqLogTypeEnum {
    Logs = 'Logs',
    Activities = 'Activities',
    BlockedAvatars = 'Blocked_avatars'
}

/**
 * 
 * @export
 * @interface AuditFilter
 */
export interface AuditFilter {
    /**
     * 
     * @type {number}
     * @memberof AuditFilter
     */
    'pagenum'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditFilter
     */
    'pagesize'?: number;
    /**
     * 
     * @type {Filter}
     * @memberof AuditFilter
     */
    'filter'?: Filter;
}
/**
 * 
 * @export
 * @interface AuditSearchFilter
 */
export interface AuditSearchFilter {
    /**
     * 
     * @type {string}
     * @memberof AuditSearchFilter
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditSearchFilter
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditSearchFilter
     */
    'actionType'?: AuditSearchFilterActionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AuditSearchFilter
     */
    'timestampFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditSearchFilter
     */
    'timestampTo'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditSearchFilter
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditSearchFilter
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuditSearchFilter
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditSearchFilter
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditSearchFilter
     */
    'groupId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AuditSearchFilterActionTypeEnum {
    Login = 'LOGIN',
    Logout = 'LOGOUT',
    CreateJob = 'CREATE_JOB',
    CreateRangeJob = 'CREATE_RANGE_JOB',
    Job = 'JOB',
    Ping = 'PING',
    Image = 'IMAGE',
    ImageClearStorage = 'IMAGE_CLEAR_STORAGE',
    Audit = 'AUDIT',
    User = 'USER',
    Profile = 'PROFILE',
    HealthStatus = 'HEALTH_STATUS',
    Delete = 'DELETE',
    Search4Faces = 'SEARCH_4_FACES',
    System = 'SYSTEM',
    Alerts = 'ALERTS',
    Profiler = 'PROFILER',
    Webint = 'WEBINT',
    Avatars = 'AVATARS',
    Activities = 'ACTIVITIES',
    AuditEp = 'AUDIT_EP',
    Adid = 'ADID',
    Campaign = 'CAMPAIGN'
}

/**
 * 
 * @export
 * @interface AvatarActivityDTO
 */
export interface AvatarActivityDTO {
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'activity'?: AvatarActivityDTOActivityEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'cron'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'base64photo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarActivityDTO
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'postId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDTO
     */
    'role'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarActivityDTOActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}

/**
 * 
 * @export
 * @interface AvatarActivityDeleteResponse
 */
export interface AvatarActivityDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AvatarActivityDeleteResponse
     */
    'isDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AvatarActivityDeleteResponse
     */
    'message'?: string;
    /**
     * 
     * @type {AvatarDto}
     * @memberof AvatarActivityDeleteResponse
     */
    'avatar'?: AvatarDto;
}
/**
 * 
 * @export
 * @interface AvatarAdditionalInfo
 */
export interface AvatarAdditionalInfo {
    /**
     * 
     * @type {string}
     * @memberof AvatarAdditionalInfo
     */
    'apiKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAdditionalInfo
     */
    'apiSecret'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAdditionalInfo
     */
    'apiAccessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAdditionalInfo
     */
    'apiAccessTokenSecret'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAdditionalInfo
     */
    'apiAppId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAdditionalInfo
     */
    'apiRefreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAdditionalInfo
     */
    'apiSecretKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarAdditionalInfo
     */
    'apiAgentKey'?: number;
}
/**
 * 
 * @export
 * @interface AvatarAlertDTO
 */
export interface AvatarAlertDTO {
    /**
     * 
     * @type {string}
     * @memberof AvatarAlertDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAlertDTO
     */
    'status'?: AvatarAlertDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarAlertDTO
     */
    'metaAvatarId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAlertDTO
     */
    'domain'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarAlertDTO
     */
    'timestamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarAlertDTO
     */
    'isResolved'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarAlertDTOStatusEnum {
    Scheduled = 'SCHEDULED',
    Sent = 'SENT',
    InProgress = 'IN_PROGRESS',
    Failed = 'FAILED',
    Error = 'ERROR',
    Success = 'SUCCESS'
}

/**
 * 
 * @export
 * @interface AvatarAuditDTO
 */
export interface AvatarAuditDTO {
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'avatarId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarAuditDTO
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'domain'?: AvatarAuditDTODomainEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'auditType'?: AvatarAuditDTOAuditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'activity'?: AvatarAuditDTOActivityEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarAuditDTO
     */
    'scheduledTimestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof AvatarAuditDTO
     */
    'failedMessage'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarAuditDTODomainEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}
/**
    * @export
    * @enum {string}
    */
export enum AvatarAuditDTOAuditTypeEnum {
    AvatarInteraction = 'AVATAR_INTERACTION',
    AvatarCreated = 'AVATAR_CREATED',
    AvatarCreating = 'AVATAR_CREATING',
    AvatarScheduleInteraction = 'AVATAR_SCHEDULE_INTERACTION',
    AvatarDeleted = 'AVATAR_DELETED',
    AvatarScheduleSuccess = 'AVATAR_SCHEDULE_SUCCESS',
    AvatarScheduleFailed = 'AVATAR_SCHEDULE_FAILED',
    AvatarBlocked = 'AVATAR_BLOCKED',
    AvatarStatusUpdated = 'AVATAR_STATUS_UPDATED',
    Undefinded = 'UNDEFINDED'
}
/**
    * @export
    * @enum {string}
    */
export enum AvatarAuditDTOActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}

/**
 * 
 * @export
 * @interface AvatarCampaignDto
 */
export interface AvatarCampaignDto {
    /**
     * 
     * @type {string}
     * @memberof AvatarCampaignDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCampaignDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCampaignDto
     */
    'domain'?: AvatarCampaignDtoDomainEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarCampaignDto
     */
    'status'?: AvatarCampaignDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarCampaignDtoDomainEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}
/**
    * @export
    * @enum {string}
    */
export enum AvatarCampaignDtoStatusEnum {
    Valid = 'VALID',
    Blocked = 'BLOCKED',
    RequiresValidation = 'REQUIRES_VALIDATION',
    Disabled = 'DISABLED',
    Quarantine = 'QUARANTINE',
    AvatarNotExists = 'AVATAR_NOT_EXISTS',
    InProgress = 'IN_PROGRESS',
    TemporaryQuarantine = 'TEMPORARY_QUARANTINE'
}

/**
 * 
 * @export
 * @interface AvatarCreationMessageDTO
 */
export interface AvatarCreationMessageDTO {
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'base64Photo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'bDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'gender'?: AvatarCreationMessageDTOGenderEnum;
    /**
     * 
     * @type {ProxyServer}
     * @memberof AvatarCreationMessageDTO
     */
    'proxy'?: ProxyServer;
    /**
     * 
     * @type {Email}
     * @memberof AvatarCreationMessageDTO
     */
    'email'?: Email;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'usedByUser'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarCreationMessageDTO
     */
    'createdAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof AvatarCreationMessageDTO
     */
    'bday'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarCreationMessageDTOGenderEnum {
    Male = 'MALE',
    Female = 'FEMALE',
    Unknown = 'UNKNOWN'
}

/**
 * 
 * @export
 * @interface AvatarDTOResponse
 */
export interface AvatarDTOResponse {
    /**
     * 
     * @type {AvatarDto}
     * @memberof AvatarDTOResponse
     */
    'avatar'?: AvatarDto;
    /**
     * 
     * @type {string}
     * @memberof AvatarDTOResponse
     */
    'status'?: AvatarDTOResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarDTOResponse
     */
    'domain'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarDTOResponseStatusEnum {
    Created = 'CREATED',
    AvatarAlreadyExists = 'AVATAR_ALREADY_EXISTS',
    Updated = 'UPDATED',
    Error = 'ERROR',
    PartialSuccess = 'PARTIAL_SUCCESS',
    Success = 'SUCCESS'
}

/**
 * 
 * @export
 * @interface AvatarDeleteResponse
 */
export interface AvatarDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AvatarDeleteResponse
     */
    'isDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AvatarDeleteResponse
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ScheduleInfoDTO>}
     * @memberof AvatarDeleteResponse
     */
    'schedules'?: Array<ScheduleInfoDTO>;
    /**
     * 
     * @type {AvatarDto}
     * @memberof AvatarDeleteResponse
     */
    'avatar'?: AvatarDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvatarDeleteResponse
     */
    'webintIDs'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AvatarDto
 */
export interface AvatarDto {
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'domain'?: AvatarDtoDomainEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'status'?: AvatarDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'statusMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'blockedReason'?: string;
    /**
     * 
     * @type {ProxyServer}
     * @memberof AvatarDto
     */
    'proxy'?: ProxyServer;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'mobileUserAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'desktopUserAgent'?: string;
    /**
     * 
     * @type {AvatarAdditionalInfo}
     * @memberof AvatarDto
     */
    'additionalInfo'?: AvatarAdditionalInfo;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarDto
     */
    'useAlerts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarDto
     */
    'useQuarantine'?: boolean;
    /**
     * 
     * @type {QuarantineInfo}
     * @memberof AvatarDto
     */
    'quarantineInfo'?: QuarantineInfo;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'updatedStatus'?: AvatarDtoUpdatedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'module'?: AvatarDtoModuleEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvatarDto
     */
    'assignedTaskIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvatarDto
     */
    'assignedUsers'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'startQuarantineDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'endQuarantineDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'startUseDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarDto
     */
    'temporaryQuarantine'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarDto
     */
    'disableMonitoring'?: boolean;
    /**
     * 
     * @type {MaturityResultDTO}
     * @memberof AvatarDto
     */
    'matureScore'?: MaturityResultDTO;
    /**
     * 
     * @type {MonitorRequestDTO}
     * @memberof AvatarDto
     */
    'monitorRequest'?: MonitorRequestDTO;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarDto
     */
    'forbiddenCAA'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AvatarDto
     */
    'snID'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarDto
     */
    'agentNotReady'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvatarDto
     */
    'agentTips'?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarDtoDomainEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}
/**
    * @export
    * @enum {string}
    */
export enum AvatarDtoStatusEnum {
    Valid = 'VALID',
    Blocked = 'BLOCKED',
    RequiresValidation = 'REQUIRES_VALIDATION',
    Disabled = 'DISABLED',
    Quarantine = 'QUARANTINE',
    AvatarNotExists = 'AVATAR_NOT_EXISTS',
    InProgress = 'IN_PROGRESS',
    TemporaryQuarantine = 'TEMPORARY_QUARANTINE'
}
/**
    * @export
    * @enum {string}
    */
export enum AvatarDtoUpdatedStatusEnum {
    Auto = 'AUTO',
    Manual = 'MANUAL'
}
/**
    * @export
    * @enum {string}
    */
export enum AvatarDtoModuleEnum {
    Profiler = 'PROFILER',
    Webint = 'WEBINT'
}

/**
 * 
 * @export
 * @interface AvatarInfo
 */
export interface AvatarInfo {
    /**
     * 
     * @type {string}
     * @memberof AvatarInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarInfo
     */
    'profileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarInfo
     */
    'socialNetwork'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarInfo
     */
    'status'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvatarInfo
     */
    'assignedTasks'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AvatarInfo
     */
    'metaAvatarId'?: string;
}
/**
 * 
 * @export
 * @interface AvatarRequest
 */
export interface AvatarRequest {
    /**
     * 
     * @type {string}
     * @memberof AvatarRequest
     */
    'socialNetwork': AvatarRequestSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarRequest
     */
    'instanceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarRequest
     */
    'targetId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarRequestSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface AvatarResponse
 */
export interface AvatarResponse {
    /**
     * 
     * @type {AvatarDto}
     * @memberof AvatarResponse
     */
    'avatar'?: AvatarDto;
    /**
     * 
     * @type {string}
     * @memberof AvatarResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface AvatarReturnRequest
 */
export interface AvatarReturnRequest {
    /**
     * 
     * @type {string}
     * @memberof AvatarReturnRequest
     */
    'status': AvatarReturnRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarReturnRequest
     */
    'avatarId': string;
    /**
     * 
     * @type {string}
     * @memberof AvatarReturnRequest
     */
    'message'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarReturnRequestStatusEnum {
    Success = 'SUCCESS',
    Failed = 'FAILED'
}

/**
 * 
 * @export
 * @interface AvatarReturnResponse
 */
export interface AvatarReturnResponse {
    /**
     * 
     * @type {string}
     * @memberof AvatarReturnResponse
     */
    'status'?: AvatarReturnResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarReturnResponse
     */
    'message'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarReturnResponseStatusEnum {
    Success = 'SUCCESS',
    Failed = 'FAILED'
}

/**
 * 
 * @export
 * @interface AvatarStatisticDTO
 */
export interface AvatarStatisticDTO {
    /**
     * 
     * @type {string}
     * @memberof AvatarStatisticDTO
     */
    'avatarId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarStatisticDTO
     */
    'posts'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvatarStatisticDTO
     */
    'likes'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvatarStatisticDTO
     */
    'lastActivity'?: number;
}
/**
 * 
 * @export
 * @interface AvatarStatusDTO
 */
export interface AvatarStatusDTO {
    /**
     * 
     * @type {string}
     * @memberof AvatarStatusDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarStatusDTO
     */
    'status'?: AvatarStatusDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AvatarStatusDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarStatusDTO
     */
    'targetId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AvatarStatusDTO
     */
    'onlyStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AvatarStatusDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarStatusDTO
     */
    'requestId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarStatusDTOStatusEnum {
    Valid = 'VALID',
    Blocked = 'BLOCKED',
    RequiresValidation = 'REQUIRES_VALIDATION',
    Disabled = 'DISABLED',
    Quarantine = 'QUARANTINE',
    AvatarNotExists = 'AVATAR_NOT_EXISTS',
    InProgress = 'IN_PROGRESS',
    TemporaryQuarantine = 'TEMPORARY_QUARANTINE'
}

/**
 * 
 * @export
 * @interface AvatarUsageDTO
 */
export interface AvatarUsageDTO {
    /**
     * 
     * @type {AvatarDto}
     * @memberof AvatarUsageDTO
     */
    'avatarDto'?: AvatarDto;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof AvatarUsageDTO
     */
    'dailyUsage'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof AvatarUsageDTO
     */
    'moduleUsage'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface AvatarVerificationDTO
 */
export interface AvatarVerificationDTO {
    /**
     * 
     * @type {string}
     * @memberof AvatarVerificationDTO
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarVerificationDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarVerificationDTO
     */
    'sn'?: string;
}
/**
 * 
 * @export
 * @interface BlockedAvatarDTO
 */
export interface BlockedAvatarDTO {
    /**
     * 
     * @type {number}
     * @memberof BlockedAvatarDTO
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof BlockedAvatarDTO
     */
    'socialNetwork'?: BlockedAvatarDTOSocialNetworkEnum;
    /**
     * 
     * @type {AvatarDto}
     * @memberof BlockedAvatarDTO
     */
    'avatar'?: AvatarDto;
    /**
     * 
     * @type {string}
     * @memberof BlockedAvatarDTO
     */
    'user'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockedAvatarDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockedAvatarDTO
     */
    'activity'?: BlockedAvatarDTOActivityEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BlockedAvatarDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}
/**
    * @export
    * @enum {string}
    */
export enum BlockedAvatarDTOActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}

/**
 * 
 * @export
 * @interface CampaignCreateRequest
 */
export interface CampaignCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignCreateRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignCreateRequest
     */
    'socialProfileIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'endTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'socialNetwork'?: CampaignCreateRequestSocialNetworkEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CampaignCreateRequestSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface CampaignDto
 */
export interface CampaignDto {
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'status'?: CampaignDtoStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignDto
     */
    'socialProfileIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'socialNetwork'?: CampaignDtoSocialNetworkEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignDto
     */
    'assignUsers'?: Array<string>;
    /**
     * 
     * @type {Array<StepDto>}
     * @memberof CampaignDto
     */
    'steps'?: Array<StepDto>;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    'updatedAt'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CampaignDtoStatusEnum {
    Draft = 'DRAFT',
    Active = 'ACTIVE',
    Paused = 'PAUSED',
    Completed = 'COMPLETED',
    Archived = 'ARCHIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum CampaignDtoSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface CampaignGeneralStatRequest
 */
export interface CampaignGeneralStatRequest {
    /**
     * 
     * @type {number}
     * @memberof CampaignGeneralStatRequest
     */
    'startPeriod'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignGeneralStatRequest
     */
    'endPeriod'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignGeneralStatRequest
     */
    'activities'?: Array<CampaignGeneralStatRequestActivitiesEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum CampaignGeneralStatRequestActivitiesEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}

/**
 * 
 * @export
 * @interface CampaignPageRequest
 */
export interface CampaignPageRequest {
    /**
     * 
     * @type {number}
     * @memberof CampaignPageRequest
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignPageRequest
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignPageRequest
     */
    'status'?: CampaignPageRequestStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CampaignPageRequestStatusEnum {
    Draft = 'DRAFT',
    Active = 'ACTIVE',
    Paused = 'PAUSED',
    Completed = 'COMPLETED',
    Archived = 'ARCHIVED'
}

/**
 * 
 * @export
 * @interface CampaignStatsDto
 */
export interface CampaignStatsDto {
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'totalActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'completedActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'failedActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'pendingActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'inProgressActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'pausedActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'totalPosts'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'totalComments'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'totalLikes'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'completionPercentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignStatsDto
     */
    'calculatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsDto
     */
    'avatars'?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignStatsDto
     */
    'lastUpdated'?: string;
}
/**
 * 
 * @export
 * @interface CampaignStatsResponse
 */
export interface CampaignStatsResponse {
    /**
     * 
     * @type {string}
     * @memberof CampaignStatsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {Array<DailyStats>}
     * @memberof CampaignStatsResponse
     */
    'dailyStats'?: Array<DailyStats>;
    /**
     * 
     * @type {number}
     * @memberof CampaignStatsResponse
     */
    'avatars'?: number;
}
/**
 * 
 * @export
 * @interface CampaignUpdateRequest
 */
export interface CampaignUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignUpdateRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'endTime'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignUpdateRequest
     */
    'socialProfileIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CampaignWithStatsDto
 */
export interface CampaignWithStatsDto {
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'status'?: CampaignWithStatsDtoStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignWithStatsDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignWithStatsDto
     */
    'socialProfileIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'socialNetwork'?: CampaignWithStatsDtoSocialNetworkEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignWithStatsDto
     */
    'assignUsers'?: Array<string>;
    /**
     * 
     * @type {Array<StepDto>}
     * @memberof CampaignWithStatsDto
     */
    'steps'?: Array<StepDto>;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignWithStatsDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {CampaignStatsDto}
     * @memberof CampaignWithStatsDto
     */
    'stats'?: CampaignStatsDto;
    /**
     * 
     * @type {Array<StepWithStatsDto>}
     * @memberof CampaignWithStatsDto
     */
    'stepWithStatsDto'?: Array<StepWithStatsDto>;
}

/**
    * @export
    * @enum {string}
    */
export enum CampaignWithStatsDtoStatusEnum {
    Draft = 'DRAFT',
    Active = 'ACTIVE',
    Paused = 'PAUSED',
    Completed = 'COMPLETED',
    Archived = 'ARCHIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum CampaignWithStatsDtoSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface Case
 */
export interface Case {
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'caseName': string;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'caseNumber': number;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'caseType': CaseCaseTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'targetCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'status'?: CaseStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseCaseTypeEnum {
    Profiler = 'PROFILER',
    Webint = 'WEBINT',
    Geomc = 'GEOMC',
    Darkweb = 'DARKWEB',
    Ship = 'SHIP',
    Container = 'CONTAINER',
    Adid = 'ADID'
}
/**
    * @export
    * @enum {string}
    */
export enum CaseStatusEnum {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

/**
 * 
 * @export
 * @interface CaseCreateDTO
 */
export interface CaseCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof CaseCreateDTO
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseCreateDTO
     */
    'invID'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseCreateDTO
     */
    'caseType'?: CaseCreateDTOCaseTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseCreateDTOCaseTypeEnum {
    Profiler = 'PROFILER',
    Webint = 'WEBINT',
    Geomc = 'GEOMC',
    Darkweb = 'DARKWEB',
    Ship = 'SHIP',
    Container = 'CONTAINER',
    Adid = 'ADID'
}

/**
 * 
 * @export
 * @interface CaseResponseDTO
 */
export interface CaseResponseDTO {
    /**
     * 
     * @type {Case}
     * @memberof CaseResponseDTO
     */
    'caze'?: Case;
    /**
     * 
     * @type {number}
     * @memberof CaseResponseDTO
     */
    'invID'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseResponseDTO
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface CategoryScore
 */
export interface CategoryScore {
    /**
     * 
     * @type {number}
     * @memberof CategoryScore
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryScore
     */
    'maxPossibleScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryScore
     */
    'percentage'?: number;
}
/**
 * 
 * @export
 * @interface ChatMessageAssistDTO
 */
export interface ChatMessageAssistDTO {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'requestEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'threadId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAssistDTO
     */
    'profileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAssistDTO
     */
    'completionTokens'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'providerMessageID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'errorReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistDTO
     */
    'failedResponse'?: string;
    /**
     * 
     * @type {Array<FunctionAssistantResponseDTO>}
     * @memberof ChatMessageAssistDTO
     */
    'functionResponse'?: Array<FunctionAssistantResponseDTO>;
}
/**
 * 
 * @export
 * @interface ChatMessageAssistantReqDTO
 */
export interface ChatMessageAssistantReqDTO {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistantReqDTO
     */
    'userMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAssistantReqDTO
     */
    'userMessageId'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageUserDTO
 */
export interface ChatMessageUserDTO {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'threadId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageUserDTO
     */
    'profileId'?: number;
    /**
     * 
     * @type {ChatMessageAssistDTO}
     * @memberof ChatMessageUserDTO
     */
    'response'?: ChatMessageAssistDTO;
    /**
     * 
     * @type {ChatMessageUserDTO}
     * @memberof ChatMessageUserDTO
     */
    'prevRequest'?: ChatMessageUserDTO;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageUserDTO
     */
    'promptTokens'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'providerMessageID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'errorReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'failedResponse'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'comment'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageUserDTO
     */
    'isRerun'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUserDTO
     */
    'nextRequestEntityId'?: string;
}
/**
 * 
 * @export
 * @interface CheckListDTO
 */
export interface CheckListDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckListDTO
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckListDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckListDTO
     */
    'threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckListDTO
     */
    'aiThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckListDTO
     */
    'ageThreshold'?: number;
    /**
     * 
     * @type {Array<ChecklistCriteriaDTO>}
     * @memberof CheckListDTO
     */
    'criteria'?: Array<ChecklistCriteriaDTO>;
}
/**
 * 
 * @export
 * @interface CheckListUpdateRequest
 */
export interface CheckListUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof CheckListUpdateRequest
     */
    'threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckListUpdateRequest
     */
    'aiThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckListUpdateRequest
     */
    'ageThreshold'?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckListUpdateRequest
     */
    'groupId'?: string;
    /**
     * 
     * @type {Array<MaturityCriteriaRequestDTO>}
     * @memberof CheckListUpdateRequest
     */
    'criteria'?: Array<MaturityCriteriaRequestDTO>;
}
/**
 * 
 * @export
 * @interface ChecklistCriteriaDTO
 */
export interface ChecklistCriteriaDTO {
    /**
     * 
     * @type {MaturityCriteriaDTO}
     * @memberof ChecklistCriteriaDTO
     */
    'criteria'?: MaturityCriteriaDTO;
    /**
     * 
     * @type {number}
     * @memberof ChecklistCriteriaDTO
     */
    'customMaxScore'?: number;
}
/**
 * 
 * @export
 * @interface ConflictInfo
 */
export interface ConflictInfo {
    /**
     * 
     * @type {string}
     * @memberof ConflictInfo
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConflictInfo
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConflictInfo
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'other'?: string;
}
/**
 * 
 * @export
 * @interface CrawlerItemFilterDTO
 */
export interface CrawlerItemFilterDTO {
    /**
     * 
     * @type {Set<string>}
     * @memberof CrawlerItemFilterDTO
     */
    'socialNetwork'?: Set<CrawlerItemFilterDTOSocialNetworkEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof CrawlerItemFilterDTO
     */
    'type'?: Set<CrawlerItemFilterDTOTypeEnum>;
    /**
     * 
     * @type {number}
     * @memberof CrawlerItemFilterDTO
     */
    'skip'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerItemFilterDTO
     */
    'batch'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CrawlerItemFilterDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}
/**
    * @export
    * @enum {string}
    */
export enum CrawlerItemFilterDTOTypeEnum {
    GroupOwnerItem = 'GROUP_OWNER_ITEM',
    GroupMostCommentedProfileItem = 'GROUP_MOST_COMMENTED_PROFILE_ITEM',
    GroupMostPostedProfileItem = 'GROUP_MOST_POSTED_PROFILE_ITEM',
    GroupMostInfluencingProfileItem = 'GROUP_MOST_INFLUENCING_PROFILE_ITEM',
    GroupBotProfileItem = 'GROUP_BOT_PROFILE_ITEM',
    SearchEngineResultsItem = 'SEARCH_ENGINE_RESULTS_ITEM',
    GroupProfileItem = 'GROUP_PROFILE_ITEM',
    PageAlbumItem = 'PAGE_ALBUM_ITEM',
    LocationItem = 'LOCATION_ITEM',
    PostItem = 'POST_ITEM',
    MostActiveProfileItem = 'MOST_ACTIVE_PROFILE_ITEM',
    GroupNewMemberProfileItem = 'GROUP_NEW_MEMBER_PROFILE_ITEM',
    ProfileItem = 'PROFILE_ITEM',
    FriendItem = 'FRIEND_ITEM',
    GroupMostActiveProfileItem = 'GROUP_MOST_ACTIVE_PROFILE_ITEM',
    SearchEngineVideosItem = 'SEARCH_ENGINE_VIDEOS_ITEM',
    GroupAdminProfileItem = 'GROUP_ADMIN_PROFILE_ITEM',
    SearchEngineImagesItem = 'SEARCH_ENGINE_IMAGES_ITEM',
    PagePostItem = 'PAGE_POST_ITEM',
    GoogleMapsItem = 'GOOGLE_MAPS_ITEM',
    GroupMostLikedProfileItem = 'GROUP_MOST_LIKED_PROFILE_ITEM',
    PageMostActiveProfileItem = 'PAGE_MOST_ACTIVE_PROFILE_ITEM',
    PageMostLikedProfileItem = 'PAGE_MOST_LIKED_PROFILE_ITEM',
    GroupPostItem = 'GROUP_POST_ITEM',
    GroupAlbumItem = 'GROUP_ALBUM_ITEM',
    PageProfileItem = 'PAGE_PROFILE_ITEM',
    ProfileAlbumItem = 'PROFILE_ALBUM_ITEM',
    PageMostCommentedProfileItem = 'PAGE_MOST_COMMENTED_PROFILE_ITEM',
    StolenCarItem = 'STOLEN_CAR_ITEM',
    AvatarValidatorItem = 'AVATAR_VALIDATOR_ITEM',
    GroupModeratorProfileItem = 'GROUP_MODERATOR_PROFILE_ITEM',
    GroupMembersItem = 'GROUP_MEMBERS_ITEM',
    GroupBannedItem = 'GROUP_BANNED_ITEM',
    GroupCreatorItem = 'GROUP_CREATOR_ITEM',
    GroupLeftItem = 'GROUP_LEFT_ITEM',
    GroupRestrictedItem = 'GROUP_RESTRICTED_ITEM',
    GroupUnknownItem = 'GROUP_UNKNOWN_ITEM',
    HydraProfileItem = 'HYDRA_PROFILE_ITEM',
    Sniper = 'SNIPER',
    PostCursorItem = 'POST_CURSOR_ITEM',
    FriendCursorItem = 'FRIEND_CURSOR_ITEM',
    AiAnalyseItem = 'AI_ANALYSE_ITEM'
}

/**
 * 
 * @export
 * @interface CrawlerProgressDTO
 */
export interface CrawlerProgressDTO {
    /**
     * 
     * @type {number}
     * @memberof CrawlerProgressDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'socialNetwork'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'serviceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'socialId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'keyword'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'imageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrawlerProgressDTO
     */
    'progress'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'errorReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'status'?: CrawlerProgressDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerProgressDTO
     */
    'password'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CrawlerProgressDTOStatusEnum {
    Started = 'STARTED',
    InProgress = 'IN_PROGRESS',
    Completed = 'COMPLETED',
    Schedule = 'SCHEDULE',
    Added = 'ADDED',
    Failed = 'FAILED',
    TimeoutError = 'TIMEOUT_ERROR'
}

/**
 * 
 * @export
 * @interface CrawlerResponseDTO
 */
export interface CrawlerResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'assignedEntityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'socialNetwork'?: CrawlerResponseDTOSocialNetworkEnum;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'resonanceScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'relatedEntityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'relatedLookupRequestItemId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CrawlerResponseDTO
     */
    'isProfileDataAdded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CrawlerResponseDTO
     */
    'hasHistory'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'type'?: CrawlerResponseDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'customRequestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'confidence'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'friendName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'friendProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'friendOf'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'friendImageUrl'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'fullSizeImageUrl'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'imageUrls'?: Array<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof CrawlerResponseDTO
     */
    'imagesUrlIds'?: Set<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'imagesUrl'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'actualMainUrl'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'thumbnailUrls'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'places'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'cities'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'recent'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'albumName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'externalLinkUrl'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'videosUrl'?: Array<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof CrawlerResponseDTO
     */
    'imageIds'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileCoverPhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileEducation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileBirthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileAge'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileSex'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileWork'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'originalPostUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'referenceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'referenceUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'originalPostUserImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'postedByProfileUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'originalPostUserName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'totalReactionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'likeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'niceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'hahaCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'loveCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'wowCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'sadCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'angryCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'sharesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'careCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'celebrateCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'curiousCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'insightfulCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'appreciationCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'postId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'postUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'postLikeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'referenceUserName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'referenceUserImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'referenceContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'groupImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'groupCoverPhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CrawlerResponseDTO
     */
    'isSharedPost'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'keyword'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'targetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'pageImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'resultPreview'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'transactions'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'phoneOwnerEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'resultTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'totalSent'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'phoneCarrier'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'phoneOwnerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'phoneOwnerUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'noTransactions'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'finalBalance'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'phoneSearchEngine'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'phoneOwnerAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'searchEngine'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'hashAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'linkedinUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'linkedinProfileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'contextUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'resultLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'qrcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'pageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'pageCoverPhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'totalReceived'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'phoneType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'pageName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'resultType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'gmailResponse'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CrawlerResponseDTO
     */
    'lookupDataNewFormat'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'carid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileImageBase64'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'internalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'internalMessageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'bio'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'profileType'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'lastSeenTimestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'sharedText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'likedText'?: string;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'love'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'like'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'likes'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'nice'?: Array<Interaction>;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'text'?: string;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'wow'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'haha'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'comments'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'sad'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'angry'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'care'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'celebrate'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'curious'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'appreciation'?: Array<Interaction>;
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof CrawlerResponseDTO
     */
    'insightful'?: Array<Interaction>;
    /**
     * 
     * @type {ProfileData}
     * @memberof CrawlerResponseDTO
     */
    'profileData'?: ProfileData;
    /**
     * 
     * @type {Sentiment}
     * @memberof CrawlerResponseDTO
     */
    'sentiment'?: Sentiment;
    /**
     * 
     * @type {SentimentStat}
     * @memberof CrawlerResponseDTO
     */
    'sentimentStat'?: SentimentStat;
    /**
     * 
     * @type {GroupData}
     * @memberof CrawlerResponseDTO
     */
    'groupData'?: GroupData;
    /**
     * 
     * @type {Array<CrawlerResponseDTO>}
     * @memberof CrawlerResponseDTO
     */
    'posts'?: Array<CrawlerResponseDTO>;
    /**
     * 
     * @type {PageData}
     * @memberof CrawlerResponseDTO
     */
    'pageData'?: PageData;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CrawlerResponseDTO
     */
    'postStats'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CrawlerResponseDTO
     */
    'ageStats'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CrawlerResponseDTO
     */
    'locationStats'?: { [key: string]: number; };
    /**
     * 
     * @type {Array<InteractionGiven>}
     * @memberof CrawlerResponseDTO
     */
    'likesGiven'?: Array<InteractionGiven>;
    /**
     * 
     * @type {Array<InteractionGiven>}
     * @memberof CrawlerResponseDTO
     */
    'commentsGiven'?: Array<InteractionGiven>;
    /**
     * 
     * @type {Array<InteractionGiven>}
     * @memberof CrawlerResponseDTO
     */
    'likesReceived'?: Array<InteractionGiven>;
    /**
     * 
     * @type {Array<InteractionGiven>}
     * @memberof CrawlerResponseDTO
     */
    'commentsReceived'?: Array<InteractionGiven>;
    /**
     * 
     * @type {object}
     * @memberof CrawlerResponseDTO
     */
    'location'?: object;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'messageId'?: number;
    /**
     * 
     * @type {PostAnalyze}
     * @memberof CrawlerResponseDTO
     */
    'postAnalyze'?: PostAnalyze;
    /**
     * 
     * @type {object}
     * @memberof CrawlerResponseDTO
     */
    'albums'?: object;
    /**
     * 
     * @type {object}
     * @memberof CrawlerResponseDTO
     */
    'friends'?: object;
    /**
     * 
     * @type {object}
     * @memberof CrawlerResponseDTO
     */
    'locations'?: object;
    /**
     * 
     * @type {object}
     * @memberof CrawlerResponseDTO
     */
    'postsLiked'?: object;
    /**
     * 
     * @type {object}
     * @memberof CrawlerResponseDTO
     */
    'postsCommented'?: object;
    /**
     * 
     * @type {object}
     * @memberof CrawlerResponseDTO
     */
    'youtubeResultsItem'?: object;
    /**
     * 
     * @type {object}
     * @memberof CrawlerResponseDTO
     */
    'youtubeVideoDetails'?: object;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'videoCommentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'videoViewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'videoPublishedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'videoDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'videoDislikesCount'?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof CrawlerResponseDTO
     */
    'videoCommentsDetails'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'thumbnailLink'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'videoLikesCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {Replies}
     * @memberof CrawlerResponseDTO
     */
    'replies'?: Replies;
    /**
     * 
     * @type {number}
     * @memberof CrawlerResponseDTO
     */
    'postAuditory'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'lastNameT'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'firstNameT'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerResponseDTO
     */
    'previousType'?: CrawlerResponseDTOPreviousTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'sharedImagesUrl'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'sharedVideosUrl'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrawlerResponseDTO
     */
    'sharedExternalLinkUrl'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CrawlerResponseDTO
     */
    'isLastPost'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CrawlerResponseDTO
     */
    'isLastIteration'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum CrawlerResponseDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}
/**
    * @export
    * @enum {string}
    */
export enum CrawlerResponseDTOTypeEnum {
    GroupOwnerItem = 'GROUP_OWNER_ITEM',
    GroupMostCommentedProfileItem = 'GROUP_MOST_COMMENTED_PROFILE_ITEM',
    GroupMostPostedProfileItem = 'GROUP_MOST_POSTED_PROFILE_ITEM',
    GroupMostInfluencingProfileItem = 'GROUP_MOST_INFLUENCING_PROFILE_ITEM',
    GroupBotProfileItem = 'GROUP_BOT_PROFILE_ITEM',
    SearchEngineResultsItem = 'SEARCH_ENGINE_RESULTS_ITEM',
    GroupProfileItem = 'GROUP_PROFILE_ITEM',
    PageAlbumItem = 'PAGE_ALBUM_ITEM',
    LocationItem = 'LOCATION_ITEM',
    PostItem = 'POST_ITEM',
    MostActiveProfileItem = 'MOST_ACTIVE_PROFILE_ITEM',
    GroupNewMemberProfileItem = 'GROUP_NEW_MEMBER_PROFILE_ITEM',
    ProfileItem = 'PROFILE_ITEM',
    FriendItem = 'FRIEND_ITEM',
    GroupMostActiveProfileItem = 'GROUP_MOST_ACTIVE_PROFILE_ITEM',
    SearchEngineVideosItem = 'SEARCH_ENGINE_VIDEOS_ITEM',
    GroupAdminProfileItem = 'GROUP_ADMIN_PROFILE_ITEM',
    SearchEngineImagesItem = 'SEARCH_ENGINE_IMAGES_ITEM',
    PagePostItem = 'PAGE_POST_ITEM',
    GoogleMapsItem = 'GOOGLE_MAPS_ITEM',
    GroupMostLikedProfileItem = 'GROUP_MOST_LIKED_PROFILE_ITEM',
    PageMostActiveProfileItem = 'PAGE_MOST_ACTIVE_PROFILE_ITEM',
    PageMostLikedProfileItem = 'PAGE_MOST_LIKED_PROFILE_ITEM',
    GroupPostItem = 'GROUP_POST_ITEM',
    GroupAlbumItem = 'GROUP_ALBUM_ITEM',
    PageProfileItem = 'PAGE_PROFILE_ITEM',
    ProfileAlbumItem = 'PROFILE_ALBUM_ITEM',
    PageMostCommentedProfileItem = 'PAGE_MOST_COMMENTED_PROFILE_ITEM',
    StolenCarItem = 'STOLEN_CAR_ITEM',
    AvatarValidatorItem = 'AVATAR_VALIDATOR_ITEM',
    GroupModeratorProfileItem = 'GROUP_MODERATOR_PROFILE_ITEM',
    GroupMembersItem = 'GROUP_MEMBERS_ITEM',
    GroupBannedItem = 'GROUP_BANNED_ITEM',
    GroupCreatorItem = 'GROUP_CREATOR_ITEM',
    GroupLeftItem = 'GROUP_LEFT_ITEM',
    GroupRestrictedItem = 'GROUP_RESTRICTED_ITEM',
    GroupUnknownItem = 'GROUP_UNKNOWN_ITEM',
    HydraProfileItem = 'HYDRA_PROFILE_ITEM',
    Sniper = 'SNIPER',
    PostCursorItem = 'POST_CURSOR_ITEM',
    FriendCursorItem = 'FRIEND_CURSOR_ITEM',
    AiAnalyseItem = 'AI_ANALYSE_ITEM'
}
/**
    * @export
    * @enum {string}
    */
export enum CrawlerResponseDTOPreviousTypeEnum {
    GroupOwnerItem = 'GROUP_OWNER_ITEM',
    GroupMostCommentedProfileItem = 'GROUP_MOST_COMMENTED_PROFILE_ITEM',
    GroupMostPostedProfileItem = 'GROUP_MOST_POSTED_PROFILE_ITEM',
    GroupMostInfluencingProfileItem = 'GROUP_MOST_INFLUENCING_PROFILE_ITEM',
    GroupBotProfileItem = 'GROUP_BOT_PROFILE_ITEM',
    SearchEngineResultsItem = 'SEARCH_ENGINE_RESULTS_ITEM',
    GroupProfileItem = 'GROUP_PROFILE_ITEM',
    PageAlbumItem = 'PAGE_ALBUM_ITEM',
    LocationItem = 'LOCATION_ITEM',
    PostItem = 'POST_ITEM',
    MostActiveProfileItem = 'MOST_ACTIVE_PROFILE_ITEM',
    GroupNewMemberProfileItem = 'GROUP_NEW_MEMBER_PROFILE_ITEM',
    ProfileItem = 'PROFILE_ITEM',
    FriendItem = 'FRIEND_ITEM',
    GroupMostActiveProfileItem = 'GROUP_MOST_ACTIVE_PROFILE_ITEM',
    SearchEngineVideosItem = 'SEARCH_ENGINE_VIDEOS_ITEM',
    GroupAdminProfileItem = 'GROUP_ADMIN_PROFILE_ITEM',
    SearchEngineImagesItem = 'SEARCH_ENGINE_IMAGES_ITEM',
    PagePostItem = 'PAGE_POST_ITEM',
    GoogleMapsItem = 'GOOGLE_MAPS_ITEM',
    GroupMostLikedProfileItem = 'GROUP_MOST_LIKED_PROFILE_ITEM',
    PageMostActiveProfileItem = 'PAGE_MOST_ACTIVE_PROFILE_ITEM',
    PageMostLikedProfileItem = 'PAGE_MOST_LIKED_PROFILE_ITEM',
    GroupPostItem = 'GROUP_POST_ITEM',
    GroupAlbumItem = 'GROUP_ALBUM_ITEM',
    PageProfileItem = 'PAGE_PROFILE_ITEM',
    ProfileAlbumItem = 'PROFILE_ALBUM_ITEM',
    PageMostCommentedProfileItem = 'PAGE_MOST_COMMENTED_PROFILE_ITEM',
    StolenCarItem = 'STOLEN_CAR_ITEM',
    AvatarValidatorItem = 'AVATAR_VALIDATOR_ITEM',
    GroupModeratorProfileItem = 'GROUP_MODERATOR_PROFILE_ITEM',
    GroupMembersItem = 'GROUP_MEMBERS_ITEM',
    GroupBannedItem = 'GROUP_BANNED_ITEM',
    GroupCreatorItem = 'GROUP_CREATOR_ITEM',
    GroupLeftItem = 'GROUP_LEFT_ITEM',
    GroupRestrictedItem = 'GROUP_RESTRICTED_ITEM',
    GroupUnknownItem = 'GROUP_UNKNOWN_ITEM',
    HydraProfileItem = 'HYDRA_PROFILE_ITEM',
    Sniper = 'SNIPER',
    PostCursorItem = 'POST_CURSOR_ITEM',
    FriendCursorItem = 'FRIEND_CURSOR_ITEM',
    AiAnalyseItem = 'AI_ANALYSE_ITEM'
}

/**
 * 
 * @export
 * @interface CrawlerSearchResultDTO
 */
export interface CrawlerSearchResultDTO {
    /**
     * 
     * @type {string}
     * @memberof CrawlerSearchResultDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerSearchResultDTO
     */
    'profileId'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof CrawlerSearchResultDTO
     */
    'imageIds'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof CrawlerSearchResultDTO
     */
    'profileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrawlerSearchResultDTO
     */
    'socialNetwork'?: CrawlerSearchResultDTOSocialNetworkEnum;
    /**
     * 
     * @type {number}
     * @memberof CrawlerSearchResultDTO
     */
    'confidence'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrawlerSearchResultDTO
     */
    'relatedLookupRequestItemId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CrawlerSearchResultDTO
     */
    'isProfileDataAdded'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum CrawlerSearchResultDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface CriterionResult
 */
export interface CriterionResult {
    /**
     * 
     * @type {string}
     * @memberof CriterionResult
     */
    'criterionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CriterionResult
     */
    'category'?: CriterionResultCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof CriterionResult
     */
    'criterionName'?: CriterionResultCriterionNameEnum;
    /**
     * 
     * @type {number}
     * @memberof CriterionResult
     */
    'awardedScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof CriterionResult
     */
    'maxPossibleScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof CriterionResult
     */
    'advice'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CriterionResultCategoryEnum {
    ProfileCompleteness = 'PROFILE_COMPLETENESS',
    Activity = 'ACTIVITY',
    Engagement = 'ENGAGEMENT',
    NetworkGrowth = 'NETWORK_GROWTH',
    Custom = 'CUSTOM'
}
/**
    * @export
    * @enum {string}
    */
export enum CriterionResultCriterionNameEnum {
    ProfilePicture = 'PROFILE_PICTURE',
    ProfileCoverPhoto = 'PROFILE_COVER_PHOTO',
    ProfileDescription = 'PROFILE_DESCRIPTION',
    Location = 'LOCATION',
    WebsiteLink = 'WEBSITE_LINK',
    TotalPosts = 'TOTAL_POSTS',
    PostingFrequency = 'POSTING_FREQUENCY',
    ContentDiversity = 'CONTENT_DIVERSITY',
    PostingConsistency = 'POSTING_CONSISTENCY',
    LikesReceived = 'LIKES_RECEIVED',
    CommentsReceived = 'COMMENTS_RECEIVED',
    RetweetsReceived = 'RETWEETS_RECEIVED',
    TotalEngagement = 'TOTAL_ENGAGEMENT',
    FollowersCount = 'FOLLOWERS_COUNT',
    FollowingCount = 'FOLLOWING_COUNT',
    FollowerFollowingRatio = 'FOLLOWER_FOLLOWING_RATIO',
    Custom = 'CUSTOM'
}

/**
 * 
 * @export
 * @interface DOB
 */
export interface DOB {
    /**
     * 
     * @type {string}
     * @memberof DOB
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof DOB
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DOB
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DOB
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {DateRange}
     * @memberof DOB
     */
    'dateDange'?: DateRange;
    /**
     * 
     * @type {string}
     * @memberof DOB
     */
    'display'?: string;
    /**
     * 
     * @type {DateRange}
     * @memberof DOB
     */
    'dateRange'?: DateRange;
    /**
     * 
     * @type {boolean}
     * @memberof DOB
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface DailyStats
 */
export interface DailyStats {
    /**
     * 
     * @type {string}
     * @memberof DailyStats
     */
    'd'?: string;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: number; }; }}
     * @memberof DailyStats
     */
    's'?: { [key: string]: { [key: string]: number; }; };
}
/**
 * 
 * @export
 * @interface DataWithSource
 */
export interface DataWithSource {
    /**
     * 
     * @type {string}
     * @memberof DataWithSource
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataWithSource
     */
    'data'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DataWithSource
     */
    'deletable'?: boolean;
}
/**
 * 
 * @export
 * @interface DataWithSourceAndLRID
 */
export interface DataWithSourceAndLRID {
    /**
     * 
     * @type {string}
     * @memberof DataWithSourceAndLRID
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataWithSourceAndLRID
     */
    'data'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataWithSourceAndLRID
     */
    'lookupRequestId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataWithSourceAndLRID
     */
    'deletable'?: boolean;
}
/**
 * 
 * @export
 * @interface DataWithSourceAndLRIID
 */
export interface DataWithSourceAndLRIID {
    /**
     * 
     * @type {string}
     * @memberof DataWithSourceAndLRIID
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataWithSourceAndLRIID
     */
    'data'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataWithSourceAndLRIID
     */
    'lookupRequestItemId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataWithSourceAndLRIID
     */
    'deletable'?: boolean;
}
/**
 * 
 * @export
 * @interface DataWithSourceAndSNLRID
 */
export interface DataWithSourceAndSNLRID {
    /**
     * 
     * @type {string}
     * @memberof DataWithSourceAndSNLRID
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataWithSourceAndSNLRID
     */
    'data'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataWithSourceAndSNLRID
     */
    'socialNetwork'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataWithSourceAndSNLRID
     */
    'lookupRequestId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataWithSourceAndSNLRID
     */
    'deletable'?: boolean;
}
/**
 * 
 * @export
 * @interface DataWithSources
 */
export interface DataWithSources {
    /**
     * 
     * @type {Set<string>}
     * @memberof DataWithSources
     */
    'sources'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof DataWithSources
     */
    'data'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataWithSources
     */
    'socialNetwork'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataWithSources
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface DateFilter
 */
export interface DateFilter {
    /**
     * 
     * @type {number}
     * @memberof DateFilter
     */
    'dateFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof DateFilter
     */
    'dateTo'?: number;
    /**
     * 
     * @type {string}
     * @memberof DateFilter
     */
    'auditType'?: DateFilterAuditTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DateFilterAuditTypeEnum {
    AvatarInteraction = 'AVATAR_INTERACTION',
    AvatarCreated = 'AVATAR_CREATED',
    AvatarCreating = 'AVATAR_CREATING',
    AvatarScheduleInteraction = 'AVATAR_SCHEDULE_INTERACTION',
    AvatarDeleted = 'AVATAR_DELETED',
    AvatarScheduleSuccess = 'AVATAR_SCHEDULE_SUCCESS',
    AvatarScheduleFailed = 'AVATAR_SCHEDULE_FAILED',
    AvatarBlocked = 'AVATAR_BLOCKED',
    AvatarStatusUpdated = 'AVATAR_STATUS_UPDATED',
    Undefinded = 'UNDEFINDED'
}

/**
 * 
 * @export
 * @interface DateRange
 */
export interface DateRange {
    /**
     * 
     * @type {string}
     * @memberof DateRange
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateRange
     */
    'end'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DateRange
     */
    'exact'?: boolean;
}
/**
 * 
 * @export
 * @interface DateRangeDTO
 */
export interface DateRangeDTO {
    /**
     * 
     * @type {number}
     * @memberof DateRangeDTO
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeDTO
     */
    'end'?: number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeDTO
     */
    'offset'?: number;
    /**
     * 
     * @type {DateRangeDTOZoneId}
     * @memberof DateRangeDTO
     */
    'zoneId'?: DateRangeDTOZoneId;
}
/**
 * 
 * @export
 * @interface DateRangeDTOZoneId
 */
export interface DateRangeDTOZoneId {
    /**
     * 
     * @type {string}
     * @memberof DateRangeDTOZoneId
     */
    'id'?: string;
    /**
     * 
     * @type {DateRangeDTOZoneIdRules}
     * @memberof DateRangeDTOZoneId
     */
    'rules'?: DateRangeDTOZoneIdRules;
}
/**
 * 
 * @export
 * @interface DateRangeDTOZoneIdRules
 */
export interface DateRangeDTOZoneIdRules {
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRules
     */
    'fixedOffset'?: boolean;
    /**
     * 
     * @type {Array<DateRangeDTOZoneIdRulesTransitions>}
     * @memberof DateRangeDTOZoneIdRules
     */
    'transitions'?: Array<DateRangeDTOZoneIdRulesTransitions>;
    /**
     * 
     * @type {Array<DateRangeDTOZoneIdRulesTransitionRules>}
     * @memberof DateRangeDTOZoneIdRules
     */
    'transitionRules'?: Array<DateRangeDTOZoneIdRulesTransitionRules>;
}
/**
 * 
 * @export
 * @interface DateRangeDTOZoneIdRulesDuration
 */
export interface DateRangeDTOZoneIdRulesDuration {
    /**
     * 
     * @type {number}
     * @memberof DateRangeDTOZoneIdRulesDuration
     */
    'seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeDTOZoneIdRulesDuration
     */
    'nano'?: number;
    /**
     * 
     * @type {Array<DateRangeDTOZoneIdRulesDurationUnits>}
     * @memberof DateRangeDTOZoneIdRulesDuration
     */
    'units'?: Array<DateRangeDTOZoneIdRulesDurationUnits>;
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRulesDuration
     */
    'zero'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRulesDuration
     */
    'negative'?: boolean;
}
/**
 * 
 * @export
 * @interface DateRangeDTOZoneIdRulesDurationUnits
 */
export interface DateRangeDTOZoneIdRulesDurationUnits {
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRulesDurationUnits
     */
    'dateBased'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRulesDurationUnits
     */
    'timeBased'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRulesDurationUnits
     */
    'durationEstimated'?: boolean;
}
/**
 * 
 * @export
 * @interface DateRangeDTOZoneIdRulesOffsetBefore
 */
export interface DateRangeDTOZoneIdRulesOffsetBefore {
    /**
     * 
     * @type {number}
     * @memberof DateRangeDTOZoneIdRulesOffsetBefore
     */
    'totalSeconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof DateRangeDTOZoneIdRulesOffsetBefore
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DateRangeDTOZoneIdRulesTransitionRules
 */
export interface DateRangeDTOZoneIdRulesTransitionRules {
    /**
     * 
     * @type {string}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'month'?: DateRangeDTOZoneIdRulesTransitionRulesMonthEnum;
    /**
     * 
     * @type {string}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'timeDefinition'?: DateRangeDTOZoneIdRulesTransitionRulesTimeDefinitionEnum;
    /**
     * 
     * @type {DateRangeDTOZoneIdRulesOffsetBefore}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'standardOffset'?: DateRangeDTOZoneIdRulesOffsetBefore;
    /**
     * 
     * @type {DateRangeDTOZoneIdRulesOffsetBefore}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'offsetBefore'?: DateRangeDTOZoneIdRulesOffsetBefore;
    /**
     * 
     * @type {DateRangeDTOZoneIdRulesOffsetBefore}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'offsetAfter'?: DateRangeDTOZoneIdRulesOffsetBefore;
    /**
     * 
     * @type {string}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'dayOfWeek'?: DateRangeDTOZoneIdRulesTransitionRulesDayOfWeekEnum;
    /**
     * 
     * @type {number}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'dayOfMonthIndicator'?: number;
    /**
     * 
     * @type {LocalTime}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'localTime'?: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRulesTransitionRules
     */
    'midnightEndOfDay'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum DateRangeDTOZoneIdRulesTransitionRulesMonthEnum {
    January = 'JANUARY',
    February = 'FEBRUARY',
    March = 'MARCH',
    April = 'APRIL',
    May = 'MAY',
    June = 'JUNE',
    July = 'JULY',
    August = 'AUGUST',
    September = 'SEPTEMBER',
    October = 'OCTOBER',
    November = 'NOVEMBER',
    December = 'DECEMBER'
}
/**
    * @export
    * @enum {string}
    */
export enum DateRangeDTOZoneIdRulesTransitionRulesTimeDefinitionEnum {
    Utc = 'UTC',
    Wall = 'WALL',
    Standard = 'STANDARD'
}
/**
    * @export
    * @enum {string}
    */
export enum DateRangeDTOZoneIdRulesTransitionRulesDayOfWeekEnum {
    Monday = 'MONDAY',
    Tuesday = 'TUESDAY',
    Wednesday = 'WEDNESDAY',
    Thursday = 'THURSDAY',
    Friday = 'FRIDAY',
    Saturday = 'SATURDAY',
    Sunday = 'SUNDAY'
}

/**
 * 
 * @export
 * @interface DateRangeDTOZoneIdRulesTransitions
 */
export interface DateRangeDTOZoneIdRulesTransitions {
    /**
     * 
     * @type {DateRangeDTOZoneIdRulesOffsetBefore}
     * @memberof DateRangeDTOZoneIdRulesTransitions
     */
    'offsetBefore'?: DateRangeDTOZoneIdRulesOffsetBefore;
    /**
     * 
     * @type {DateRangeDTOZoneIdRulesOffsetBefore}
     * @memberof DateRangeDTOZoneIdRulesTransitions
     */
    'offsetAfter'?: DateRangeDTOZoneIdRulesOffsetBefore;
    /**
     * 
     * @type {DateRangeDTOZoneIdRulesDuration}
     * @memberof DateRangeDTOZoneIdRulesTransitions
     */
    'duration'?: DateRangeDTOZoneIdRulesDuration;
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRulesTransitions
     */
    'gap'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DateRangeDTOZoneIdRulesTransitions
     */
    'dateTimeBefore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateRangeDTOZoneIdRulesTransitions
     */
    'dateTimeAfter'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateRangeDTOZoneIdRulesTransitions
     */
    'instant'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DateRangeDTOZoneIdRulesTransitions
     */
    'overlap'?: boolean;
}
/**
 * 
 * @export
 * @interface DateWithSourceAndSN
 */
export interface DateWithSourceAndSN {
    /**
     * 
     * @type {string}
     * @memberof DateWithSourceAndSN
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateWithSourceAndSN
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateWithSourceAndSN
     */
    'socialNetwork'?: string;
}
/**
 * 
 * @export
 * @interface DeepWebDTOView
 */
export interface DeepWebDTOView {
    /**
     * 
     * @type {Array<Person>}
     * @memberof DeepWebDTOView
     */
    'persons'?: Array<Person>;
    /**
     * 
     * @type {Array<Person>}
     * @memberof DeepWebDTOView
     */
    'possiblePersons'?: Array<Person>;
    /**
     * 
     * @type {Array<Source>}
     * @memberof DeepWebDTOView
     */
    'sources'?: Array<Source>;
    /**
     * 
     * @type {Array<HydraItemDTOView>}
     * @memberof DeepWebDTOView
     */
    'hydraItems'?: Array<HydraItemDTOView>;
}
/**
 * 
 * @export
 * @interface DeleteLookupRequestDTO
 */
export interface DeleteLookupRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof DeleteLookupRequestDTO
     */
    'lrID'?: number;
}
/**
 * 
 * @export
 * @interface DisplayName
 */
export interface DisplayName {
    /**
     * 
     * @type {string}
     * @memberof DisplayName
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplayName
     */
    'source'?: DisplayNameSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof DisplayName
     */
    'type'?: DisplayNameTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DisplayNameSourceEnum {
    CreatingTarget = 'CREATING_TARGET',
    ManualAdded = 'MANUAL_ADDED',
    WebCollection = 'WEB_COLLECTION',
    Adid = 'ADID',
    AdidGeo = 'ADID_GEO',
    Luna = 'LUNA',
    Pipl = 'PIPL',
    PiplPerson = 'PIPL_PERSON',
    PiplPossible = 'PIPL_POSSIBLE',
    PiplSource = 'PIPL_SOURCE',
    Pluto = 'PLUTO',
    Botim = 'BOTIM',
    Skype = 'SKYPE',
    Whatsapp = 'WHATSAPP',
    Callapp = 'CALLAPP',
    Tamtam = 'TAMTAM',
    Imo = 'IMO',
    Tc = 'TC',
    Telegram = 'TELEGRAM',
    Drupe = 'DRUPE',
    Getcontact = 'GETCONTACT',
    Viber = 'VIBER',
    Eyecon = 'EYECON',
    Hiya = 'HIYA',
    Viewcaller = 'VIEWCALLER',
    Kraken = 'KRAKEN',
    Hydra = 'HYDRA',
    Syncme = 'SYNCME',
    Line = 'LINE',
    Wechat = 'WECHAT',
    Vkontakte = 'VKONTAKTE',
    Zalo = 'ZALO',
    Showcaller = 'SHOWCALLER',
    Swarmapp = 'SWARMAPP',
    Numbuster = 'NUMBUSTER',
    Me = 'ME',
    Deepweb = 'DEEPWEB',
    MmImage = 'MM_IMAGE',
    ProfileImage = 'PROFILE_IMAGE',
    FindCloneImage = 'FIND_CLONE_IMAGE',
    Search4FaceImage = 'SEARCH_4_FACE_IMAGE',
    SniperImage = 'SNIPER_IMAGE',
    PsychoProfile = 'PSYCHO_PROFILE',
    Crawler = 'CRAWLER'
}
/**
    * @export
    * @enum {string}
    */
export enum DisplayNameTypeEnum {
    Name = 'NAME',
    Email = 'EMAIL'
}

/**
 * 
 * @export
 * @interface Education
 */
export interface Education {
    /**
     * 
     * @type {Array<string>}
     * @memberof Education
     */
    'otherInfo'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Education
     */
    'schoolImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Education
     */
    'schoolName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Education
     */
    'educationLevel'?: string;
}
/**
 * 
 * @export
 * @interface Email
 */
export interface Email {
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'incomingServer'?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'outgoingServer'?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'emailProtocol'?: EmailEmailProtocolEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EmailEmailProtocolEnum {
    Undefined = 'UNDEFINED',
    Pop3 = 'POP3',
    Imap = 'IMAP'
}

/**
 * 
 * @export
 * @interface ErrorInfo
 */
export interface ErrorInfo {
    /**
     * 
     * @type {string}
     * @memberof ErrorInfo
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorInfo
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorInfo
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface Ethnicity
 */
export interface Ethnicity {
    /**
     * 
     * @type {string}
     * @memberof Ethnicity
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ethnicity
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Ethnicity
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Ethnicity
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Ethnicity
     */
    'content'?: EthnicityContentEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Ethnicity
     */
    'searchable'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum EthnicityContentEnum {
    White = 'white',
    Black = 'black',
    AmericanIndian = 'american_indian',
    AlaskaNative = 'alaska_native',
    AsianIndian = 'asian_indian',
    Chinese = 'chinese',
    Filipino = 'filipino',
    OtherAsian = 'other_asian',
    Japanese = 'japanese',
    Korean = 'korean',
    Viatnamese = 'viatnamese',
    NativeHawaiian = 'native_hawaiian',
    Guamanian = 'guamanian',
    Chamorro = 'chamorro',
    Samoan = 'samoan',
    OtherPacificIslander = 'other_pacific_islander',
    Other = 'other'
}

/**
 * 
 * @export
 * @interface FamilyMember
 */
export interface FamilyMember {
    /**
     * 
     * @type {string}
     * @memberof FamilyMember
     */
    'linkUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyMember
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyMember
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyMember
     */
    'relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyMember
     */
    'fbId'?: string;
}
/**
 * 
 * @export
 * @interface FavoriteCreateReqDTO
 */
export interface FavoriteCreateReqDTO {
    /**
     * 
     * @type {number}
     * @memberof FavoriteCreateReqDTO
     */
    'targetId': number;
    /**
     * 
     * @type {boolean}
     * @memberof FavoriteCreateReqDTO
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof FavoriteCreateReqDTO
     */
    'module': FavoriteCreateReqDTOModuleEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FavoriteCreateReqDTOModuleEnum {
    Profiler = 'PROFILER',
    Webint = 'WEBINT',
    Geomc = 'GEOMC',
    Darkweb = 'DARKWEB',
    Ship = 'SHIP',
    Container = 'CONTAINER',
    Adid = 'ADID'
}

/**
 * 
 * @export
 * @interface FetchMoreReq
 */
export interface FetchMoreReq {
    /**
     * 
     * @type {number}
     * @memberof FetchMoreReq
     */
    'profileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchMoreReq
     */
    'socialNetwork'?: FetchMoreReqSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof FetchMoreReq
     */
    'socialProfileId'?: string;
    /**
     * 
     * @type {number}
     * @memberof FetchMoreReq
     */
    'size'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum FetchMoreReqSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'username'?: string;
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'dateFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof Filter
     */
    'dateTo'?: number;
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'sn'?: FilterSnEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FilterSnEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface FilterTreeInv
 */
export interface FilterTreeInv {
    /**
     * 
     * @type {string}
     * @memberof FilterTreeInv
     */
    'keyword'?: string;
    /**
     * 
     * @type {number}
     * @memberof FilterTreeInv
     */
    'from'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterTreeInv
     */
    'to'?: number;
}
/**
 * 
 * @export
 * @interface FindCloneResponseData
 */
export interface FindCloneResponseData {
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseData
     */
    'city'?: string;
    /**
     * 
     * @type {Array<FindCloneResponseDetails>}
     * @memberof FindCloneResponseData
     */
    'details'?: Array<FindCloneResponseDetails>;
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseData
     */
    'firstname'?: string;
    /**
     * 
     * @type {number}
     * @memberof FindCloneResponseData
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseData
     */
    'thumbnail'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseData
     */
    'userid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseData
     */
    'item_id'?: string;
}
/**
 * 
 * @export
 * @interface FindCloneResponseDetails
 */
export interface FindCloneResponseDetails {
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseDetails
     */
    'photoid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseDetails
     */
    'size'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseDetails
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindCloneResponseDetails
     */
    'userid'?: string;
    /**
     * 
     * @type {number}
     * @memberof FindCloneResponseDetails
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof FindCloneResponseDetails
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface FriendNode
 */
export interface FriendNode extends Node {
    /**
     * 
     * @type {string}
     * @memberof FriendNode
     */
    'socialNetwork'?: FriendNodeSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof FriendNode
     */
    'profileId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FriendNodeSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface FriendNodeAllOf
 */
export interface FriendNodeAllOf {
    /**
     * 
     * @type {string}
     * @memberof FriendNodeAllOf
     */
    'socialNetwork'?: FriendNodeAllOfSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof FriendNodeAllOf
     */
    'profileId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FriendNodeAllOfSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface FullProfilesRequest
 */
export interface FullProfilesRequest {
    /**
     * 
     * @type {number}
     * @memberof FullProfilesRequest
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof FullProfilesRequest
     */
    'size'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FullProfilesRequest
     */
    'profileIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface FunctionAssistantResponseDTO
 */
export interface FunctionAssistantResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof FunctionAssistantResponseDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionAssistantResponseDTO
     */
    'arguments'?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionAssistantResponseDTO
     */
    'output'?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionAssistantResponseDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionAssistantResponseDTO
     */
    'errorReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionAssistantResponseDTO
     */
    'failedResponse'?: string;
    /**
     * 
     * @type {number}
     * @memberof FunctionAssistantResponseDTO
     */
    'promptTokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionAssistantResponseDTO
     */
    'completionTokens'?: number;
}
/**
 * 
 * @export
 * @interface GameNode
 */
export interface GameNode extends Node {
    /**
     * 
     * @type {string}
     * @memberof GameNode
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GameNode
     */
    'socialNetwork'?: GameNodeSocialNetworkEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GameNodeSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface GameNodeAllOf
 */
export interface GameNodeAllOf {
    /**
     * 
     * @type {string}
     * @memberof GameNodeAllOf
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GameNodeAllOf
     */
    'socialNetwork'?: GameNodeAllOfSocialNetworkEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GameNodeAllOfSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface Gender
 */
export interface Gender {
    /**
     * 
     * @type {string}
     * @memberof Gender
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Gender
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Gender
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Gender
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Gender
     */
    'content'?: GenderContentEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Gender
     */
    'searchable'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum GenderContentEnum {
    Male = 'male',
    Female = 'female'
}

/**
 * 
 * @export
 * @interface GlobalStatisticFilter
 */
export interface GlobalStatisticFilter {
    /**
     * 
     * @type {string}
     * @memberof GlobalStatisticFilter
     */
    'month'?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalStatisticFilter
     */
    'year'?: string;
}
/**
 * 
 * @export
 * @interface GroupActivityFilterDTO
 */
export interface GroupActivityFilterDTO {
    /**
     * 
     * @type {Set<number>}
     * @memberof GroupActivityFilterDTO
     */
    'webintIds'?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof GroupActivityFilterDTO
     */
    'startTimestamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupActivityFilterDTO
     */
    'endTimestamp'?: number;
}
/**
 * 
 * @export
 * @interface GroupCreateDTO
 */
export interface GroupCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupCreateDTO
     */
    'groupName': string;
    /**
     * 
     * @type {number}
     * @memberof GroupCreateDTO
     */
    'maxUsersLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupCreateDTO
     */
    'concurrentUsersLimit'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupCreateDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupCreateDTO
     */
    'customer'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupCreateDTO
     */
    'license'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupCreateDTO
     */
    'type'?: GroupCreateDTOTypeEnum;
    /**
     * 
     * @type {QuotaGroupDTO}
     * @memberof GroupCreateDTO
     */
    'quota'?: QuotaGroupDTO;
    /**
     * 
     * @type {Set<string>}
     * @memberof GroupCreateDTO
     */
    'permissions': Set<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GroupCreateDTO
     */
    'ammCroloEnabled'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum GroupCreateDTOTypeEnum {
    License = 'License',
    General = 'General'
}

/**
 * 
 * @export
 * @interface GroupDTO
 */
export interface GroupDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'socialNetwork'?: GroupDTOSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'avatarId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GroupDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface GroupData
 */
export interface GroupData {
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupData
     */
    'membersCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'history'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'groupType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'activity'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupData
     */
    'wikiPage'?: string;
    /**
     * 
     * @type {Array<GroupMember>}
     * @memberof GroupData
     */
    'members'?: Array<GroupMember>;
}
/**
 * 
 * @export
 * @interface GroupFilter
 */
export interface GroupFilter {
    /**
     * 
     * @type {string}
     * @memberof GroupFilter
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupFilter
     */
    'groupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupFilter
     */
    'null'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupMember
 */
export interface GroupMember {
    /**
     * 
     * @type {string}
     * @memberof GroupMember
     */
    'memberLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMember
     */
    'memberImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMember
     */
    'memberName'?: string;
}
/**
 * 
 * @export
 * @interface GroupNode
 */
export interface GroupNode extends Node {
    /**
     * 
     * @type {string}
     * @memberof GroupNode
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupNode
     */
    'socialNetwork'?: GroupNodeSocialNetworkEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GroupNodeSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface GroupResponseDTO
 */
export interface GroupResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupResponseDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupResponseDTO
     */
    'maxUsersLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupResponseDTO
     */
    'concurrentUsersLimit'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupResponseDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupResponseDTO
     */
    'customer'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupResponseDTO
     */
    'license'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupResponseDTO
     */
    'description'?: string;
    /**
     * 
     * @type {QuotaResponseDTO}
     * @memberof GroupResponseDTO
     */
    'quota'?: QuotaResponseDTO;
    /**
     * 
     * @type {Set<Permission>}
     * @memberof GroupResponseDTO
     */
    'permissions'?: Set<Permission>;
    /**
     * 
     * @type {string}
     * @memberof GroupResponseDTO
     */
    'type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupResponseDTO
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupResponseDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupResponseDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupResponseDTO
     */
    'matureEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupResponseDTO
     */
    'ammCroloEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface HydraItemDTOView
 */
export interface HydraItemDTOView {
    /**
     * 
     * @type {string}
     * @memberof HydraItemDTOView
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraItemDTOView
     */
    'prId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraItemDTOView
     */
    'customRequestId'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraItemDTOView
     */
    'relatedEntityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydraItemDTOView
     */
    'relatedLookupRequestItemId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraItemDTOView
     */
    'socialNetwork'?: HydraItemDTOViewSocialNetworkEnum;
    /**
     * 
     * @type {boolean}
     * @memberof HydraItemDTOView
     */
    'isProfileDataAdded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HydraItemDTOView
     */
    'type'?: HydraItemDTOViewTypeEnum;
    /**
     * 
     * @type {Set<string>}
     * @memberof HydraItemDTOView
     */
    'imageIds'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof HydraItemDTOView
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraItemDTOView
     */
    'createdDate'?: string;
    /**
     * 
     * @type {Array<SocialUrl>}
     * @memberof HydraItemDTOView
     */
    'socialUrls'?: Array<SocialUrl>;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof HydraItemDTOView
     */
    'socialNetworks'?: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof HydraItemDTOView
     */
    'properties'?: { [key: string]: object; };
}

/**
    * @export
    * @enum {string}
    */
export enum HydraItemDTOViewSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}
/**
    * @export
    * @enum {string}
    */
export enum HydraItemDTOViewTypeEnum {
    GroupOwnerItem = 'GROUP_OWNER_ITEM',
    GroupMostCommentedProfileItem = 'GROUP_MOST_COMMENTED_PROFILE_ITEM',
    GroupMostPostedProfileItem = 'GROUP_MOST_POSTED_PROFILE_ITEM',
    GroupMostInfluencingProfileItem = 'GROUP_MOST_INFLUENCING_PROFILE_ITEM',
    GroupBotProfileItem = 'GROUP_BOT_PROFILE_ITEM',
    SearchEngineResultsItem = 'SEARCH_ENGINE_RESULTS_ITEM',
    GroupProfileItem = 'GROUP_PROFILE_ITEM',
    PageAlbumItem = 'PAGE_ALBUM_ITEM',
    LocationItem = 'LOCATION_ITEM',
    PostItem = 'POST_ITEM',
    MostActiveProfileItem = 'MOST_ACTIVE_PROFILE_ITEM',
    GroupNewMemberProfileItem = 'GROUP_NEW_MEMBER_PROFILE_ITEM',
    ProfileItem = 'PROFILE_ITEM',
    FriendItem = 'FRIEND_ITEM',
    GroupMostActiveProfileItem = 'GROUP_MOST_ACTIVE_PROFILE_ITEM',
    SearchEngineVideosItem = 'SEARCH_ENGINE_VIDEOS_ITEM',
    GroupAdminProfileItem = 'GROUP_ADMIN_PROFILE_ITEM',
    SearchEngineImagesItem = 'SEARCH_ENGINE_IMAGES_ITEM',
    PagePostItem = 'PAGE_POST_ITEM',
    GoogleMapsItem = 'GOOGLE_MAPS_ITEM',
    GroupMostLikedProfileItem = 'GROUP_MOST_LIKED_PROFILE_ITEM',
    PageMostActiveProfileItem = 'PAGE_MOST_ACTIVE_PROFILE_ITEM',
    PageMostLikedProfileItem = 'PAGE_MOST_LIKED_PROFILE_ITEM',
    GroupPostItem = 'GROUP_POST_ITEM',
    GroupAlbumItem = 'GROUP_ALBUM_ITEM',
    PageProfileItem = 'PAGE_PROFILE_ITEM',
    ProfileAlbumItem = 'PROFILE_ALBUM_ITEM',
    PageMostCommentedProfileItem = 'PAGE_MOST_COMMENTED_PROFILE_ITEM',
    StolenCarItem = 'STOLEN_CAR_ITEM',
    AvatarValidatorItem = 'AVATAR_VALIDATOR_ITEM',
    GroupModeratorProfileItem = 'GROUP_MODERATOR_PROFILE_ITEM',
    GroupMembersItem = 'GROUP_MEMBERS_ITEM',
    GroupBannedItem = 'GROUP_BANNED_ITEM',
    GroupCreatorItem = 'GROUP_CREATOR_ITEM',
    GroupLeftItem = 'GROUP_LEFT_ITEM',
    GroupRestrictedItem = 'GROUP_RESTRICTED_ITEM',
    GroupUnknownItem = 'GROUP_UNKNOWN_ITEM',
    HydraProfileItem = 'HYDRA_PROFILE_ITEM',
    Sniper = 'SNIPER',
    PostCursorItem = 'POST_CURSOR_ITEM',
    FriendCursorItem = 'FRIEND_CURSOR_ITEM',
    AiAnalyseItem = 'AI_ANALYSE_ITEM'
}

/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface ImageInSizeItem
 */
export interface ImageInSizeItem {
    /**
     * 
     * @type {Location}
     * @memberof ImageInSizeItem
     */
    'location'?: Location;
    /**
     * 
     * @type {Time}
     * @memberof ImageInSizeItem
     */
    'time'?: Time;
    /**
     * 
     * @type {Array<Person>}
     * @memberof ImageInSizeItem
     */
    'people'?: Array<Person>;
    /**
     * 
     * @type {TextsAndSymbols}
     * @memberof ImageInSizeItem
     */
    'textsAndSymbols'?: TextsAndSymbols;
    /**
     * 
     * @type {ThreatAssessment}
     * @memberof ImageInSizeItem
     */
    'threatAssessment'?: ThreatAssessment;
    /**
     * 
     * @type {ObjectsAndScene}
     * @memberof ImageInSizeItem
     */
    'objectsAndScene'?: ObjectsAndScene;
    /**
     * 
     * @type {Reflections}
     * @memberof ImageInSizeItem
     */
    'reflections'?: Reflections;
    /**
     * 
     * @type {VericityScore}
     * @memberof ImageInSizeItem
     */
    'vericityScore'?: VericityScore;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImageInSizeItem
     */
    'Entities'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ImageSearchResultDTO
 */
export interface ImageSearchResultDTO {
    /**
     * 
     * @type {number}
     * @memberof ImageSearchResultDTO
     */
    'id'?: number;
    /**
     * 
     * @type {MMImageResponseDTO}
     * @memberof ImageSearchResultDTO
     */
    'mmData'?: MMImageResponseDTO;
    /**
     * 
     * @type {FindCloneResponseData}
     * @memberof ImageSearchResultDTO
     */
    'findCloneData'?: FindCloneResponseData;
    /**
     * 
     * @type {Search4FaceDTO}
     * @memberof ImageSearchResultDTO
     */
    'search4Face'?: Search4FaceDTO;
    /**
     * 
     * @type {Array<SniperItemDTO>}
     * @memberof ImageSearchResultDTO
     */
    'sniper'?: Array<SniperItemDTO>;
    /**
     * 
     * @type {object}
     * @memberof ImageSearchResultDTO
     */
    'profileDTO'?: object;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {any}
     * @memberof InlineObject
     */
    'file'?: any;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'lang'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject1
     */
    'data'?: string;
    /**
     * 
     * @type {any}
     * @memberof InlineObject1
     */
    'image'?: any;
    /**
     * 
     * @type {any}
     * @memberof InlineObject1
     */
    'userImage'?: any;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * 
     * @type {any}
     * @memberof InlineObject2
     */
    'file'?: any;
}
/**
 * 
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
    /**
     * 
     * @type {any}
     * @memberof InlineObject3
     */
    'image'?: any;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject4
     */
    'data'?: string;
    /**
     * 
     * @type {any}
     * @memberof InlineObject4
     */
    'image'?: any;
}
/**
 * 
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject5
     */
    'data'?: string;
    /**
     * 
     * @type {any}
     * @memberof InlineObject5
     */
    'image'?: any;
}
/**
 * 
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
    /**
     * 
     * @type {any}
     * @memberof InlineObject6
     */
    'file'?: any;
    /**
     * 
     * @type {string}
     * @memberof InlineObject6
     */
    'lang'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject6
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject6
     */
    'gPoint'?: string;
}
/**
 * 
 * @export
 * @interface Interaction
 */
export interface Interaction {
    /**
     * 
     * @type {number}
     * @memberof Interaction
     */
    'resonanceScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'originalPostUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'socialNetwork'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'referenceUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'referenceContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'referenceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'postUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'referenceUserName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'referenceUserImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    'customrequestid'?: string;
    /**
     * 
     * @type {number}
     * @memberof Interaction
     */
    'postLikeCount'?: number;
}
/**
 * 
 * @export
 * @interface InteractionGiven
 */
export interface InteractionGiven {
    /**
     * 
     * @type {string}
     * @memberof InteractionGiven
     */
    'profileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InteractionGiven
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof InteractionGiven
     */
    'likesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InteractionGiven
     */
    'commentsCount'?: number;
}
/**
 * 
 * @export
 * @interface Investigation
 */
export interface Investigation {
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Investigation
     */
    'invNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'invName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'modifiedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Investigation
     */
    'status'?: InvestigationStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestigationStatusEnum {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

/**
 * 
 * @export
 * @interface InvestigationDTO
 */
export interface InvestigationDTO {
    /**
     * 
     * @type {string}
     * @memberof InvestigationDTO
     */
    'invName'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationInfoDTO
 */
export interface InvestigationInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof InvestigationInfoDTO
     */
    'invNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInfoDTO
     */
    'invName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInfoDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInfoDTO
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInfoDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInfoDTO
     */
    'modifiedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationInfoDTO
     */
    'status'?: InvestigationInfoDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof InvestigationInfoDTO
     */
    'casesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationInfoDTO
     */
    'isArchived'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestigationInfoDTOStatusEnum {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

/**
 * 
 * @export
 * @interface InvestigationResponseDTO
 */
export interface InvestigationResponseDTO {
    /**
     * 
     * @type {Investigation}
     * @memberof InvestigationResponseDTO
     */
    'investigation'?: Investigation;
    /**
     * 
     * @type {string}
     * @memberof InvestigationResponseDTO
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface InvestigationTreeNodeDTO
 */
export interface InvestigationTreeNodeDTO {
    /**
     * 
     * @type {UserInfoDTO}
     * @memberof InvestigationTreeNodeDTO
     */
    'userInfo'?: UserInfoDTO;
    /**
     * 
     * @type {Array<InvestigationInfoDTO>}
     * @memberof InvestigationTreeNodeDTO
     */
    'invList'?: Array<InvestigationInfoDTO>;
}
/**
 * 
 * @export
 * @interface InvestigationUserNameReq
 */
export interface InvestigationUserNameReq {
    /**
     * 
     * @type {Array<number>}
     * @memberof InvestigationUserNameReq
     */
    'invIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof InvestigationUserNameReq
     */
    'userName'?: string;
}
/**
 * 
 * @export
 * @interface IrbisSceneCheckResponse
 */
export interface IrbisSceneCheckResponse {
    /**
     * 
     * @type {number}
     * @memberof IrbisSceneCheckResponse
     */
    'requestId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IrbisSceneCheckResponse
     */
    'profileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IrbisSceneCheckResponse
     */
    'imageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IrbisSceneCheckResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof IrbisSceneCheckResponse
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ImageInSizeItem>}
     * @memberof IrbisSceneCheckResponse
     */
    'json'?: Array<ImageInSizeItem>;
    /**
     * 
     * @type {number}
     * @memberof IrbisSceneCheckResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof IrbisSceneCheckResponse
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof IrbisSceneCheckResponse
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof IrbisSceneCheckResponse
     */
    'totalWaitTimeMs'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IrbisSceneCheckResponse
     */
    'maxAttemptsReached'?: boolean;
}
/**
 * 
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Job
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Job
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'industry'?: string;
    /**
     * 
     * @type {DateRange}
     * @memberof Job
     */
    'dateRange'?: DateRange;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'display'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Job
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface JwtAuthenticationDto
 */
export interface JwtAuthenticationDto {
    /**
     * 
     * @type {string}
     * @memberof JwtAuthenticationDto
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof JwtAuthenticationDto
     */
    'tokenType'?: string;
}
/**
 * 
 * @export
 * @interface KeywordDTO
 */
export interface KeywordDTO {
    /**
     * 
     * @type {string}
     * @memberof KeywordDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof KeywordDTO
     */
    'keywordJoin'?: KeywordDTOKeywordJoinEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum KeywordDTOKeywordJoinEnum {
    Or = 'OR',
    And = 'AND'
}

/**
 * 
 * @export
 * @interface Language
 */
export interface Language {
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Language
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Language
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    'display'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Language
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface LanguageDTO
 */
export interface LanguageDTO {
    /**
     * 
     * @type {string}
     * @memberof LanguageDTO
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageDTO
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageDTO
     */
    'dialect'?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageDTO
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'href'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'hreflang'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'deprecation'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Link
     */
    'templated'?: boolean;
}
/**
 * 
 * @export
 * @interface LocalTime
 */
export interface LocalTime {
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'minute'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'second'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'nano'?: number;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'continent'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'landmark'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'latitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'longitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'regionType'?: string;
}
/**
 * 
 * @export
 * @interface LocationDTO
 */
export interface LocationDTO {
    /**
     * 
     * @type {number}
     * @memberof LocationDTO
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationDTO
     */
    'longitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    'address'?: string;
}
/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LookupRequestItemStat
 */
export interface LookupRequestItemStat {
    /**
     * 
     * @type {number}
     * @memberof LookupRequestItemStat
     */
    'lookupRequestItemId'?: number;
    /**
     * 
     * @type {number}
     * @memberof LookupRequestItemStat
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof LookupRequestItemStat
     */
    'status'?: LookupRequestItemStatStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LookupRequestItemStat
     */
    'createdDate'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum LookupRequestItemStatStatusEnum {
    Started = 'STARTED',
    InProgress = 'IN_PROGRESS',
    Completed = 'COMPLETED',
    Schedule = 'SCHEDULE',
    Added = 'ADDED',
    Failed = 'FAILED',
    TimeoutError = 'TIMEOUT_ERROR'
}

/**
 * 
 * @export
 * @interface LookupResponseDTO
 */
export interface LookupResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof LookupResponseDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupResponseDTO
     */
    'status'?: LookupResponseDTOStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LookupResponseDTOStatusEnum {
    Success = 'SUCCESS',
    Failed = 'FAILED'
}

/**
 * 
 * @export
 * @interface LookupResult
 */
export interface LookupResult {
    /**
     * 
     * @type {Set<string>}
     * @memberof LookupResult
     */
    'names'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof LookupResult
     */
    'phones'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof LookupResult
     */
    'images'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof LookupResult
     */
    'operator'?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupResult
     */
    'lastOnline'?: string;
}
/**
 * 
 * @export
 * @interface MMImageResponseDTO
 */
export interface MMImageResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof MMImageResponseDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof MMImageResponseDTO
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof MMImageResponseDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof MMImageResponseDTO
     */
    'faces'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MMImageResponseDTO
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MMImageResponseDTO
     */
    'names'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MMImageResponseDTO
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MMImageResponseDTO
     */
    'sources'?: Array<MMImageResponseDTOSourcesEnum>;
    /**
     * 
     * @type {Array<SocialNetworkWrapper>}
     * @memberof MMImageResponseDTO
     */
    'socialNetworks'?: Array<SocialNetworkWrapper>;
    /**
     * 
     * @type {string}
     * @memberof MMImageResponseDTO
     */
    'imsi'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MMImageResponseDTO
     */
    'mappedImages'?: { [key: string]: string; };
}

/**
    * @export
    * @enum {string}
    */
export enum MMImageResponseDTOSourcesEnum {
    CreatingTarget = 'CREATING_TARGET',
    ManualAdded = 'MANUAL_ADDED',
    WebCollection = 'WEB_COLLECTION',
    Adid = 'ADID',
    AdidGeo = 'ADID_GEO',
    Luna = 'LUNA',
    Pipl = 'PIPL',
    PiplPerson = 'PIPL_PERSON',
    PiplPossible = 'PIPL_POSSIBLE',
    PiplSource = 'PIPL_SOURCE',
    Pluto = 'PLUTO',
    Botim = 'BOTIM',
    Skype = 'SKYPE',
    Whatsapp = 'WHATSAPP',
    Callapp = 'CALLAPP',
    Tamtam = 'TAMTAM',
    Imo = 'IMO',
    Tc = 'TC',
    Telegram = 'TELEGRAM',
    Drupe = 'DRUPE',
    Getcontact = 'GETCONTACT',
    Viber = 'VIBER',
    Eyecon = 'EYECON',
    Hiya = 'HIYA',
    Viewcaller = 'VIEWCALLER',
    Kraken = 'KRAKEN',
    Hydra = 'HYDRA',
    Syncme = 'SYNCME',
    Line = 'LINE',
    Wechat = 'WECHAT',
    Vkontakte = 'VKONTAKTE',
    Zalo = 'ZALO',
    Showcaller = 'SHOWCALLER',
    Swarmapp = 'SWARMAPP',
    Numbuster = 'NUMBUSTER',
    Me = 'ME',
    Deepweb = 'DEEPWEB',
    MmImage = 'MM_IMAGE',
    ProfileImage = 'PROFILE_IMAGE',
    FindCloneImage = 'FIND_CLONE_IMAGE',
    Search4FaceImage = 'SEARCH_4_FACE_IMAGE',
    SniperImage = 'SNIPER_IMAGE',
    PsychoProfile = 'PSYCHO_PROFILE',
    Crawler = 'CRAWLER'
}

/**
 * 
 * @export
 * @interface MaturityCriteriaDTO
 */
export interface MaturityCriteriaDTO {
    /**
     * 
     * @type {string}
     * @memberof MaturityCriteriaDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MaturityCriteriaDTO
     */
    'name'?: MaturityCriteriaDTONameEnum;
    /**
     * 
     * @type {string}
     * @memberof MaturityCriteriaDTO
     */
    'calculationType'?: MaturityCriteriaDTOCalculationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MaturityCriteriaDTO
     */
    'category'?: MaturityCriteriaDTOCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof MaturityCriteriaDTO
     */
    'maxScore'?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof MaturityCriteriaDTO
     */
    'thresholds'?: { [key: string]: object; };
}

/**
    * @export
    * @enum {string}
    */
export enum MaturityCriteriaDTONameEnum {
    ProfilePicture = 'PROFILE_PICTURE',
    ProfileCoverPhoto = 'PROFILE_COVER_PHOTO',
    ProfileDescription = 'PROFILE_DESCRIPTION',
    Location = 'LOCATION',
    WebsiteLink = 'WEBSITE_LINK',
    TotalPosts = 'TOTAL_POSTS',
    PostingFrequency = 'POSTING_FREQUENCY',
    ContentDiversity = 'CONTENT_DIVERSITY',
    PostingConsistency = 'POSTING_CONSISTENCY',
    LikesReceived = 'LIKES_RECEIVED',
    CommentsReceived = 'COMMENTS_RECEIVED',
    RetweetsReceived = 'RETWEETS_RECEIVED',
    TotalEngagement = 'TOTAL_ENGAGEMENT',
    FollowersCount = 'FOLLOWERS_COUNT',
    FollowingCount = 'FOLLOWING_COUNT',
    FollowerFollowingRatio = 'FOLLOWER_FOLLOWING_RATIO',
    Custom = 'CUSTOM'
}
/**
    * @export
    * @enum {string}
    */
export enum MaturityCriteriaDTOCalculationTypeEnum {
    Boolean = 'BOOLEAN',
    TextLength = 'TEXT_LENGTH',
    UrlValidation = 'URL_VALIDATION',
    Count = 'COUNT',
    Range = 'RANGE',
    Percentage = 'PERCENTAGE',
    Consistency = 'CONSISTENCY',
    Formula = 'FORMULA',
    Threshold = 'THRESHOLD',
    Pending = 'PENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum MaturityCriteriaDTOCategoryEnum {
    ProfileCompleteness = 'PROFILE_COMPLETENESS',
    Activity = 'ACTIVITY',
    Engagement = 'ENGAGEMENT',
    NetworkGrowth = 'NETWORK_GROWTH',
    Custom = 'CUSTOM'
}

/**
 * 
 * @export
 * @interface MaturityCriteriaRequestDTO
 */
export interface MaturityCriteriaRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof MaturityCriteriaRequestDTO
     */
    'name'?: MaturityCriteriaRequestDTONameEnum;
    /**
     * 
     * @type {number}
     * @memberof MaturityCriteriaRequestDTO
     */
    'maxScore'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum MaturityCriteriaRequestDTONameEnum {
    ProfilePicture = 'PROFILE_PICTURE',
    ProfileCoverPhoto = 'PROFILE_COVER_PHOTO',
    ProfileDescription = 'PROFILE_DESCRIPTION',
    Location = 'LOCATION',
    WebsiteLink = 'WEBSITE_LINK',
    TotalPosts = 'TOTAL_POSTS',
    PostingFrequency = 'POSTING_FREQUENCY',
    ContentDiversity = 'CONTENT_DIVERSITY',
    PostingConsistency = 'POSTING_CONSISTENCY',
    LikesReceived = 'LIKES_RECEIVED',
    CommentsReceived = 'COMMENTS_RECEIVED',
    RetweetsReceived = 'RETWEETS_RECEIVED',
    TotalEngagement = 'TOTAL_ENGAGEMENT',
    FollowersCount = 'FOLLOWERS_COUNT',
    FollowingCount = 'FOLLOWING_COUNT',
    FollowerFollowingRatio = 'FOLLOWER_FOLLOWING_RATIO',
    Custom = 'CUSTOM'
}

/**
 * 
 * @export
 * @interface MaturityResultDTO
 */
export interface MaturityResultDTO {
    /**
     * 
     * @type {string}
     * @memberof MaturityResultDTO
     */
    'monitorResponseEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof MaturityResultDTO
     */
    'totalScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaturityResultDTO
     */
    'maxPossibleScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaturityResultDTO
     */
    'threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaturityResultDTO
     */
    'percentage'?: number;
    /**
     * 
     * @type {{ [key: string]: CategoryScore; }}
     * @memberof MaturityResultDTO
     */
    'categoryScores'?: { [key: string]: CategoryScore; };
    /**
     * 
     * @type {Array<CriterionResult>}
     * @memberof MaturityResultDTO
     */
    'criterionResults'?: Array<CriterionResult>;
    /**
     * 
     * @type {string}
     * @memberof MaturityResultDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {AIResult}
     * @memberof MaturityResultDTO
     */
    'aiAnalysis'?: AIResult;
    /**
     * 
     * @type {Age}
     * @memberof MaturityResultDTO
     */
    'age'?: Age;
    /**
     * 
     * @type {boolean}
     * @memberof MaturityResultDTO
     */
    'isPassed'?: boolean;
}
/**
 * 
 * @export
 * @interface MessageDto
 */
export interface MessageDto {
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface MetaAvatarDTO
 */
export interface MetaAvatarDTO {
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'id'?: string;
    /**
     * 
     * @type {Email}
     * @memberof MetaAvatarDTO
     */
    'email'?: Email;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'username'?: string;
    /**
     * 
     * @type {ProxyServer}
     * @memberof MetaAvatarDTO
     */
    'proxy'?: ProxyServer;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'gender'?: MetaAvatarDTOGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'base64Photo'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'details'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MetaAvatarDTO
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MetaAvatarDTO
     */
    'base64Photos'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'grId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'grName'?: string;
    /**
     * 
     * @type {Array<AvatarDto>}
     * @memberof MetaAvatarDTO
     */
    'socialNetworks'?: Array<AvatarDto>;
    /**
     * 
     * @type {number}
     * @memberof MetaAvatarDTO
     */
    'metaAvatarID'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'location'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MetaAvatarDTO
     */
    'file'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarDTO
     */
    'bday'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MetaAvatarDTOGenderEnum {
    Male = 'MALE',
    Female = 'FEMALE',
    Unknown = 'UNKNOWN'
}

/**
 * 
 * @export
 * @interface MetaAvatarFilter
 */
export interface MetaAvatarFilter {
    /**
     * 
     * @type {number}
     * @memberof MetaAvatarFilter
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetaAvatarFilter
     */
    'pageSize'?: number;
    /**
     * 
     * @type {Filter}
     * @memberof MetaAvatarFilter
     */
    'filter'?: Filter;
}
/**
 * 
 * @export
 * @interface MetaAvatarResponse
 */
export interface MetaAvatarResponse {
    /**
     * 
     * @type {MetaAvatarDTO}
     * @memberof MetaAvatarResponse
     */
    'metaAvatar'?: MetaAvatarDTO;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarResponse
     */
    'status'?: MetaAvatarResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarResponse
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarResponse
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarResponse
     */
    'summary'?: string;
    /**
     * 
     * @type {Array<MetaAvatarResponse>}
     * @memberof MetaAvatarResponse
     */
    'responses'?: Array<MetaAvatarResponse>;
    /**
     * 
     * @type {Array<ConflictInfo>}
     * @memberof MetaAvatarResponse
     */
    'conflicts'?: Array<ConflictInfo>;
    /**
     * 
     * @type {Array<ErrorInfo>}
     * @memberof MetaAvatarResponse
     */
    'errors'?: Array<ErrorInfo>;
}

/**
    * @export
    * @enum {string}
    */
export enum MetaAvatarResponseStatusEnum {
    Created = 'CREATED',
    AvatarAlreadyExists = 'AVATAR_ALREADY_EXISTS',
    Updated = 'UPDATED',
    Error = 'ERROR',
    PartialSuccess = 'PARTIAL_SUCCESS',
    Success = 'SUCCESS'
}

/**
 * 
 * @export
 * @interface MetaAvatarUserName
 */
export interface MetaAvatarUserName {
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarUserName
     */
    'metaAvatarId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarUserName
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaAvatarUserName
     */
    'grId'?: string;
}
/**
 * 
 * @export
 * @interface MinMax
 */
export interface MinMax {
    /**
     * 
     * @type {number}
     * @memberof MinMax
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof MinMax
     */
    'max'?: number;
}
/**
 * 
 * @export
 * @interface MonitorRequestDTO
 */
export interface MonitorRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof MonitorRequestDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitorRequestDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitorRequestDTO
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitorRequestDTO
     */
    'requestStatus'?: MonitorRequestDTORequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MonitorRequestDTO
     */
    'details'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MonitorRequestDTORequestStatusEnum {
    InProgress = 'IN_PROGRESS',
    Failed = 'FAILED',
    TimeOut = 'TIME_OUT',
    Completed = 'COMPLETED'
}

/**
 * 
 * @export
 * @interface MonitorStat
 */
export interface MonitorStat {
    /**
     * 
     * @type {boolean}
     * @memberof MonitorStat
     */
    'monitor'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MonitorStat
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface MoreInfo
 */
export interface MoreInfo {
    /**
     * 
     * @type {string}
     * @memberof MoreInfo
     */
    'about'?: string;
    /**
     * 
     * @type {string}
     * @memberof MoreInfo
     */
    'bookingAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof MoreInfo
     */
    'pressContact'?: string;
    /**
     * 
     * @type {string}
     * @memberof MoreInfo
     */
    'generalManager'?: string;
    /**
     * 
     * @type {string}
     * @memberof MoreInfo
     */
    'biography'?: string;
}
/**
 * 
 * @export
 * @interface Name
 */
export interface Name {
    /**
     * 
     * @type {number}
     * @memberof Name
     */
    'lookupRequestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface Node
 */
export interface Node {
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ObjectsAndScene
 */
export interface ObjectsAndScene {
    /**
     * 
     * @type {Array<string>}
     * @memberof ObjectsAndScene
     */
    'notableObjects'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ObjectsAndScene
     */
    'vehiclesOrTech'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OriginCountry
 */
export interface OriginCountry {
    /**
     * 
     * @type {string}
     * @memberof OriginCountry
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof OriginCountry
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OriginCountry
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OriginCountry
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OriginCountry
     */
    'country'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OriginCountry
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface PageADIDProfileEntityDto
 */
export interface PageADIDProfileEntityDto {
    /**
     * 
     * @type {number}
     * @memberof PageADIDProfileEntityDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageADIDProfileEntityDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageADIDProfileEntityDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<ADIDProfileEntityDto>}
     * @memberof PageADIDProfileEntityDto
     */
    'content'?: Array<ADIDProfileEntityDto>;
    /**
     * 
     * @type {number}
     * @memberof PageADIDProfileEntityDto
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageADIDProfileEntityDto
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageADIDProfileEntityDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageADIDProfileEntityDto
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageADIDProfileEntityDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageADIDProfileEntityDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageADIDProfileEntityDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageADIDRequestEntityDto2
 */
export interface PageADIDRequestEntityDto2 {
    /**
     * 
     * @type {number}
     * @memberof PageADIDRequestEntityDto2
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageADIDRequestEntityDto2
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageADIDRequestEntityDto2
     */
    'size'?: number;
    /**
     * 
     * @type {Array<ADIDRequestEntityDto2>}
     * @memberof PageADIDRequestEntityDto2
     */
    'content'?: Array<ADIDRequestEntityDto2>;
    /**
     * 
     * @type {number}
     * @memberof PageADIDRequestEntityDto2
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageADIDRequestEntityDto2
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageADIDRequestEntityDto2
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageADIDRequestEntityDto2
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageADIDRequestEntityDto2
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageADIDRequestEntityDto2
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageADIDRequestEntityDto2
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageActionDto
 */
export interface PageActionDto {
    /**
     * 
     * @type {number}
     * @memberof PageActionDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageActionDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageActionDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<ActionDto>}
     * @memberof PageActionDto
     */
    'content'?: Array<ActionDto>;
    /**
     * 
     * @type {number}
     * @memberof PageActionDto
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageActionDto
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageActionDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageActionDto
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageActionDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageActionDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageActionDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageAlert
 */
export interface PageAlert {
    /**
     * 
     * @type {number}
     * @memberof PageAlert
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageAlert
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageAlert
     */
    'size'?: number;
    /**
     * 
     * @type {Array<Alert>}
     * @memberof PageAlert
     */
    'content'?: Array<Alert>;
    /**
     * 
     * @type {number}
     * @memberof PageAlert
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageAlert
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageAlert
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageAlert
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageAlert
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageAlert
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageAlert
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageAuditActionDTO
 */
export interface PageAuditActionDTO {
    /**
     * 
     * @type {number}
     * @memberof PageAuditActionDTO
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageAuditActionDTO
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageAuditActionDTO
     */
    'size'?: number;
    /**
     * 
     * @type {Array<AuditActionDTO>}
     * @memberof PageAuditActionDTO
     */
    'content'?: Array<AuditActionDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageAuditActionDTO
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageAuditActionDTO
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageAuditActionDTO
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageAuditActionDTO
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageAuditActionDTO
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageAuditActionDTO
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageAuditActionDTO
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageCampaignWithStatsDto
 */
export interface PageCampaignWithStatsDto {
    /**
     * 
     * @type {number}
     * @memberof PageCampaignWithStatsDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignWithStatsDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignWithStatsDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<CampaignWithStatsDto>}
     * @memberof PageCampaignWithStatsDto
     */
    'content'?: Array<CampaignWithStatsDto>;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignWithStatsDto
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageCampaignWithStatsDto
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignWithStatsDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageCampaignWithStatsDto
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageCampaignWithStatsDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageCampaignWithStatsDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageCampaignWithStatsDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageChatMessageUserDTO
 */
export interface PageChatMessageUserDTO {
    /**
     * 
     * @type {number}
     * @memberof PageChatMessageUserDTO
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageChatMessageUserDTO
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageChatMessageUserDTO
     */
    'size'?: number;
    /**
     * 
     * @type {Array<ChatMessageUserDTO>}
     * @memberof PageChatMessageUserDTO
     */
    'content'?: Array<ChatMessageUserDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageChatMessageUserDTO
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageChatMessageUserDTO
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageChatMessageUserDTO
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageChatMessageUserDTO
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageChatMessageUserDTO
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageChatMessageUserDTO
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageChatMessageUserDTO
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageData
 */
export interface PageData {
    /**
     * 
     * @type {string}
     * @memberof PageData
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageData
     */
    'followersCount'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageData
     */
    'likesCount'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageData
     */
    'pageId'?: string;
    /**
     * 
     * @type {MoreInfo}
     * @memberof PageData
     */
    'moreInfo'?: MoreInfo;
    /**
     * 
     * @type {ContactInfo}
     * @memberof PageData
     */
    'contactInfo'?: ContactInfo;
    /**
     * 
     * @type {TeamMembers}
     * @memberof PageData
     */
    'teamMembers'?: TeamMembers;
    /**
     * 
     * @type {Array<Video>}
     * @memberof PageData
     */
    'videos'?: Array<Video>;
}
/**
 * 
 * @export
 * @interface PageFilter
 */
export interface PageFilter {
    /**
     * 
     * @type {number}
     * @memberof PageFilter
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageFilter
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageFilter
     */
    'startTimestamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageFilter
     */
    'endTimestamp'?: number;
}
/**
 * 
 * @export
 * @interface PageImplMetaAvatarDTO
 */
export interface PageImplMetaAvatarDTO {
    /**
     * 
     * @type {Array<MetaAvatarDTO>}
     * @memberof PageImplMetaAvatarDTO
     */
    'content'?: Array<MetaAvatarDTO>;
    /**
     * 
     * @type {Pageable}
     * @memberof PageImplMetaAvatarDTO
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof PageImplMetaAvatarDTO
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageImplMetaAvatarDTO
     */
    'totalPages'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageImplMetaAvatarDTO
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageImplMetaAvatarDTO
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageImplMetaAvatarDTO
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageImplMetaAvatarDTO
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageImplMetaAvatarDTO
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageImplMetaAvatarDTO
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageImplMetaAvatarDTO
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageProfileInfo
 */
export interface PageProfileInfo {
    /**
     * 
     * @type {number}
     * @memberof PageProfileInfo
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageProfileInfo
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageProfileInfo
     */
    'size'?: number;
    /**
     * 
     * @type {Array<ProfileInfo>}
     * @memberof PageProfileInfo
     */
    'content'?: Array<ProfileInfo>;
    /**
     * 
     * @type {number}
     * @memberof PageProfileInfo
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageProfileInfo
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageProfileInfo
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageProfileInfo
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageProfileInfo
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageProfileInfo
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageProfileInfo
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageProxyServer
 */
export interface PageProxyServer {
    /**
     * 
     * @type {number}
     * @memberof PageProxyServer
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageProxyServer
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageProxyServer
     */
    'size'?: number;
    /**
     * 
     * @type {Array<ProxyServer>}
     * @memberof PageProxyServer
     */
    'content'?: Array<ProxyServer>;
    /**
     * 
     * @type {number}
     * @memberof PageProxyServer
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageProxyServer
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageProxyServer
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageProxyServer
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageProxyServer
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageProxyServer
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageProxyServer
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageStepWithStatsDto
 */
export interface PageStepWithStatsDto {
    /**
     * 
     * @type {number}
     * @memberof PageStepWithStatsDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageStepWithStatsDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageStepWithStatsDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<StepWithStatsDto>}
     * @memberof PageStepWithStatsDto
     */
    'content'?: Array<StepWithStatsDto>;
    /**
     * 
     * @type {number}
     * @memberof PageStepWithStatsDto
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageStepWithStatsDto
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageStepWithStatsDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageStepWithStatsDto
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageStepWithStatsDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageStepWithStatsDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageStepWithStatsDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageUserResponseDTO
 */
export interface PageUserResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseDTO
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseDTO
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseDTO
     */
    'size'?: number;
    /**
     * 
     * @type {Array<UserResponseDTO>}
     * @memberof PageUserResponseDTO
     */
    'content'?: Array<UserResponseDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseDTO
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageUserResponseDTO
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseDTO
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageUserResponseDTO
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageUserResponseDTO
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageUserResponseDTO
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageUserResponseDTO
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageUserResponseSessionDTO
 */
export interface PageUserResponseSessionDTO {
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseSessionDTO
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseSessionDTO
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseSessionDTO
     */
    'size'?: number;
    /**
     * 
     * @type {Array<UserResponseSessionDTO>}
     * @memberof PageUserResponseSessionDTO
     */
    'content'?: Array<UserResponseSessionDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseSessionDTO
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageUserResponseSessionDTO
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageUserResponseSessionDTO
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageUserResponseSessionDTO
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageUserResponseSessionDTO
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageUserResponseSessionDTO
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageUserResponseSessionDTO
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageWebintDTO
 */
export interface PageWebintDTO {
    /**
     * 
     * @type {number}
     * @memberof PageWebintDTO
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageWebintDTO
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageWebintDTO
     */
    'size'?: number;
    /**
     * 
     * @type {Array<WebintDTO>}
     * @memberof PageWebintDTO
     */
    'content'?: Array<WebintDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageWebintDTO
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageWebintDTO
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageWebintDTO
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageWebintDTO
     */
    'pageable'?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageWebintDTO
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageWebintDTO
     */
    'last'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageWebintDTO
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface Pageable
 */
export interface Pageable {
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'size'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Pageable
     */
    'sort'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PasswordBody
 */
export interface PasswordBody {
    /**
     * 
     * @type {string}
     * @memberof PasswordBody
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface Permission
 */
export interface Permission {
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface PermissionDTO
 */
export interface PermissionDTO {
    /**
     * 
     * @type {string}
     * @memberof PermissionDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionDTO
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * 
     * @type {Array<Name>}
     * @memberof Person
     */
    'names'?: Array<Name>;
    /**
     * 
     * @type {Array<Address>}
     * @memberof Person
     */
    'addresses'?: Array<Address>;
    /**
     * 
     * @type {Array<Phone>}
     * @memberof Person
     */
    'phones'?: Array<Phone>;
    /**
     * 
     * @type {Array<Email>}
     * @memberof Person
     */
    'emails'?: Array<Email>;
    /**
     * 
     * @type {Array<Job>}
     * @memberof Person
     */
    'jobs'?: Array<Job>;
    /**
     * 
     * @type {Array<Education>}
     * @memberof Person
     */
    'educations'?: Array<Education>;
    /**
     * 
     * @type {Array<Image>}
     * @memberof Person
     */
    'images'?: Array<Image>;
    /**
     * 
     * @type {Array<Username>}
     * @memberof Person
     */
    'usernames'?: Array<Username>;
    /**
     * 
     * @type {Array<UserID>}
     * @memberof Person
     */
    'userIds'?: Array<UserID>;
    /**
     * 
     * @type {Array<Language>}
     * @memberof Person
     */
    'languages'?: Array<Language>;
    /**
     * 
     * @type {Array<Ethnicity>}
     * @memberof Person
     */
    'ethnicities'?: Array<Ethnicity>;
    /**
     * 
     * @type {Array<OriginCountry>}
     * @memberof Person
     */
    'originCountries'?: Array<OriginCountry>;
    /**
     * 
     * @type {Array<Url>}
     * @memberof Person
     */
    'urls'?: Array<Url>;
    /**
     * 
     * @type {Array<Relationship>}
     * @memberof Person
     */
    'relationships'?: Array<Relationship>;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof Person
     */
    'tags'?: Array<Tag>;
    /**
     * 
     * @type {DOB}
     * @memberof Person
     */
    'dob'?: DOB;
    /**
     * 
     * @type {Gender}
     * @memberof Person
     */
    'gender'?: Gender;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    'match'?: number;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'searchPointer'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface PersonalInfoDTO
 */
export interface PersonalInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof PersonalInfoDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDTO
     */
    'carrier'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDTO
     */
    'imsi'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDTO
     */
    'countryCode'?: string;
    /**
     * 
     * @type {Array<DataWithSourceAndLRID>}
     * @memberof PersonalInfoDTO
     */
    'phones'?: Array<DataWithSourceAndLRID>;
    /**
     * 
     * @type {Array<DataWithSourceAndLRID>}
     * @memberof PersonalInfoDTO
     */
    'passwords'?: Array<DataWithSourceAndLRID>;
    /**
     * 
     * @type {Array<DataWithSourceAndLRIID>}
     * @memberof PersonalInfoDTO
     */
    'hydraTelegramIds'?: Array<DataWithSourceAndLRIID>;
    /**
     * 
     * @type {Array<DataWithSourceAndLRID>}
     * @memberof PersonalInfoDTO
     */
    'emails'?: Array<DataWithSourceAndLRID>;
    /**
     * 
     * @type {Array<SourceInfoDTO>}
     * @memberof PersonalInfoDTO
     */
    'genders'?: Array<SourceInfoDTO>;
    /**
     * 
     * @type {Array<DataWithSource>}
     * @memberof PersonalInfoDTO
     */
    'addresses'?: Array<DataWithSource>;
    /**
     * 
     * @type {Array<DataWithSources>}
     * @memberof PersonalInfoDTO
     */
    'networks'?: Array<DataWithSources>;
    /**
     * 
     * @type {Array<SourceInfoDTO>}
     * @memberof PersonalInfoDTO
     */
    'sourceInfo'?: Array<SourceInfoDTO>;
    /**
     * 
     * @type {Array<DateWithSourceAndSN>}
     * @memberof PersonalInfoDTO
     */
    'lastOnlineStatuses'?: Array<DateWithSourceAndSN>;
    /**
     * 
     * @type {Array<DataWithSourceAndSNLRID>}
     * @memberof PersonalInfoDTO
     */
    'names'?: Array<DataWithSourceAndSNLRID>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonalInfoDTO
     */
    'statuses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonalInfoDTO
     */
    'statusesDate'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Phone
 */
export interface Phone {
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Phone
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Phone
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Phone
     */
    'countryCode'?: number;
    /**
     * 
     * @type {number}
     * @memberof Phone
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof Phone
     */
    'extension'?: number;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'raw'?: string;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'display'?: string;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'displayInternational'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Phone
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface PhotoDTO
 */
export interface PhotoDTO {
    /**
     * 
     * @type {string}
     * @memberof PhotoDTO
     */
    'source'?: PhotoDTOSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PhotoDTO
     */
    'imageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoDTO
     */
    'socialId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoDTO
     */
    'socialNetwork'?: PhotoDTOSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof PhotoDTO
     */
    'socialNetworkId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PhotoDTOSourceEnum {
    CreatingTarget = 'CREATING_TARGET',
    ManualAdded = 'MANUAL_ADDED',
    WebCollection = 'WEB_COLLECTION',
    Adid = 'ADID',
    AdidGeo = 'ADID_GEO',
    Luna = 'LUNA',
    Pipl = 'PIPL',
    PiplPerson = 'PIPL_PERSON',
    PiplPossible = 'PIPL_POSSIBLE',
    PiplSource = 'PIPL_SOURCE',
    Pluto = 'PLUTO',
    Botim = 'BOTIM',
    Skype = 'SKYPE',
    Whatsapp = 'WHATSAPP',
    Callapp = 'CALLAPP',
    Tamtam = 'TAMTAM',
    Imo = 'IMO',
    Tc = 'TC',
    Telegram = 'TELEGRAM',
    Drupe = 'DRUPE',
    Getcontact = 'GETCONTACT',
    Viber = 'VIBER',
    Eyecon = 'EYECON',
    Hiya = 'HIYA',
    Viewcaller = 'VIEWCALLER',
    Kraken = 'KRAKEN',
    Hydra = 'HYDRA',
    Syncme = 'SYNCME',
    Line = 'LINE',
    Wechat = 'WECHAT',
    Vkontakte = 'VKONTAKTE',
    Zalo = 'ZALO',
    Showcaller = 'SHOWCALLER',
    Swarmapp = 'SWARMAPP',
    Numbuster = 'NUMBUSTER',
    Me = 'ME',
    Deepweb = 'DEEPWEB',
    MmImage = 'MM_IMAGE',
    ProfileImage = 'PROFILE_IMAGE',
    FindCloneImage = 'FIND_CLONE_IMAGE',
    Search4FaceImage = 'SEARCH_4_FACE_IMAGE',
    SniperImage = 'SNIPER_IMAGE',
    PsychoProfile = 'PSYCHO_PROFILE',
    Crawler = 'CRAWLER'
}
/**
    * @export
    * @enum {string}
    */
export enum PhotoDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface PostAnalyze
 */
export interface PostAnalyze {
    /**
     * 
     * @type {string}
     * @memberof PostAnalyze
     */
    'sentiment'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAnalyze
     */
    'topic'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAnalyze
     */
    'summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAnalyze
     */
    'entity'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostAnalyze
     */
    'createdBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostAnalyze
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAnalyze
     */
    'errorReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAnalyze
     */
    'inProgress'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAnalyze
     */
    'failedResponse'?: string;
}
/**
 * 
 * @export
 * @interface PostData
 */
export interface PostData {
    /**
     * 
     * @type {number}
     * @memberof PostData
     */
    'numbersPost'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostData
     */
    'sentiment'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostData
     */
    'percent'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostData
     */
    'topic'?: string;
}
/**
 * 
 * @export
 * @interface PostFilterDTO
 */
export interface PostFilterDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof PostFilterDTO
     */
    'socialNetworks'?: Array<PostFilterDTOSocialNetworksEnum>;
    /**
     * 
     * @type {string}
     * @memberof PostFilterDTO
     */
    'text'?: string;
    /**
     * 
     * @type {PostSort}
     * @memberof PostFilterDTO
     */
    'sort'?: PostSort;
    /**
     * 
     * @type {number}
     * @memberof PostFilterDTO
     */
    'skip'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostFilterDTO
     */
    'batch'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostFilterDTO
     */
    'publishedDateFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostFilterDTO
     */
    'publishedDateTo'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostFilterDTO
     */
    'collectedDateFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostFilterDTO
     */
    'collectedDateTo'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PostFilterDTOSocialNetworksEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface PostGenerateRequest
 */
export interface PostGenerateRequest {
    /**
     * 
     * @type {string}
     * @memberof PostGenerateRequest
     */
    'lang'?: string;
    /**
     * 
     * @type {Array<PostData>}
     * @memberof PostGenerateRequest
     */
    'postsData'?: Array<PostData>;
    /**
     * 
     * @type {number}
     * @memberof PostGenerateRequest
     */
    'from'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostGenerateRequest
     */
    'to'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostGenerateRequest
     */
    'timeout'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateRequest
     */
    'openAIModel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateRequest
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateRequest
     */
    'avatarId'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostGenerateRequest
     */
    'requestTimeStamp'?: number;
}
/**
 * 
 * @export
 * @interface PostLocationDTO
 */
export interface PostLocationDTO {
    /**
     * 
     * @type {string}
     * @memberof PostLocationDTO
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostLocationDTO
     */
    'postUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostLocationDTO
     */
    'socialNetwork'?: PostLocationDTOSocialNetworkEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PostLocationDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface PostPromptGenerateRequest
 */
export interface PostPromptGenerateRequest {
    /**
     * 
     * @type {string}
     * @memberof PostPromptGenerateRequest
     */
    'openAIModel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostPromptGenerateRequest
     */
    'prompt'?: string;
}
/**
 * 
 * @export
 * @interface PostPsychoFilterDTO
 */
export interface PostPsychoFilterDTO {
    /**
     * 
     * @type {number}
     * @memberof PostPsychoFilterDTO
     */
    'publishedDateFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostPsychoFilterDTO
     */
    'publishedDateTo'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostPsychoFilterDTO
     */
    'collectedDateFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostPsychoFilterDTO
     */
    'collectedDateTo'?: number;
}
/**
 * 
 * @export
 * @interface PostSort
 */
export interface PostSort {
    /**
     * 
     * @type {string}
     * @memberof PostSort
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostSort
     */
    'direction'?: string;
}
/**
 * 
 * @export
 * @interface ProfileActivityStatDTO
 */
export interface ProfileActivityStatDTO {
    /**
     * 
     * @type {number}
     * @memberof ProfileActivityStatDTO
     */
    'likes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileActivityStatDTO
     */
    'friends'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileActivityStatDTO
     */
    'mentions'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileActivityStatDTO
     */
    'posts'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileActivityStatDTO
     */
    'comments'?: number;
}
/**
 * 
 * @export
 * @interface ProfileAnalyzeAssistantReqDTO
 */
export interface ProfileAnalyzeAssistantReqDTO {
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalyzeAssistantReqDTO
     */
    'userMessage'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileAnalyzeAssistantReqDTO
     */
    'isRerun'?: boolean;
}
/**
 * 
 * @export
 * @interface ProfileAnalyzeRequest
 */
export interface ProfileAnalyzeRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalyzeRequest
     */
    'requestId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileAnalyzeRequest
     */
    'profileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalyzeRequest
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalyzeRequest
     */
    'json'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalyzeRequest
     */
    'prompt'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileAnalyzeRequest
     */
    'timeout'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnalyzeRequest
     */
    'openAIModel'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileAnalyzeRequest
     */
    'isRerun'?: boolean;
}
/**
 * 
 * @export
 * @interface ProfileContactInfoDTO
 */
export interface ProfileContactInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'numericId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileContactInfoDTO
     */
    'professionalCategory'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'relationship2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'about'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'heading'?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'basicInfo'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'contactInfo'?: { [key: string]: object; };
    /**
     * 
     * @type {Array<Education>}
     * @memberof ProfileContactInfoDTO
     */
    'education'?: Array<Education>;
    /**
     * 
     * @type {Array<FamilyMember>}
     * @memberof ProfileContactInfoDTO
     */
    'familyMembers'?: Array<FamilyMember>;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'introduction'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'lifeEvents'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'otherNames'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'placesLived'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'relationship'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'tvShows'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'events'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<Work>}
     * @memberof ProfileContactInfoDTO
     */
    'work'?: Array<Work>;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'socialNetwork'?: ProfileContactInfoDTOSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profileHeadline'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileContactInfoDTO
     */
    'skills'?: Array<string>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'highlights'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'descriptions'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'reviews'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'movies'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'following'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'sports'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'checkIns'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'books'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {number}
     * @memberof ProfileContactInfoDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileContactInfoDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileContactInfoDTO
     */
    'likesCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profileDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileContactInfoDTO
     */
    'internalGroupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profileCreatedAt'?: string;
    /**
     * 
     * @type {object}
     * @memberof ProfileContactInfoDTO
     */
    'career'?: object;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'contact_information'?: { [key: string]: object; };
    /**
     * 
     * @type {object}
     * @memberof ProfileContactInfoDTO
     */
    'o_education'?: object;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'beliefs'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'personal_info'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'counters'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'achievements'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'url'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'holidays'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileContactInfoDTO
     */
    'forums'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'birth_place'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'marital_status'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'family'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'information'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'organizations'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'certifications'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'language'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profile_summary'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'experience'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'project'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'courses'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'awards'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'test_score'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'connections'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'volunteer_experience'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'favorite_quotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profileCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profileAge'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'hometown'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileContactInfoDTO
     */
    'profileBirthday'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'address'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileContactInfoDTO
     */
    'army'?: Array<{ [key: string]: object; }>;
}

/**
    * @export
    * @enum {string}
    */
export enum ProfileContactInfoDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface ProfileData
 */
export interface ProfileData {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileData
     */
    'professionalCategory'?: Array<string>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'stories'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {StatsLastPosts}
     * @memberof ProfileData
     */
    'statsLastPosts'?: StatsLastPosts;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'heading'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'profileHeadline'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'skillsLN'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileData
     */
    'skills'?: Array<string>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'tvShows'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'contactInfo'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'placesLived'?: { [key: string]: object; };
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'music'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<Education>}
     * @memberof ProfileData
     */
    'education'?: Array<Education>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'events'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'introduction'?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'otherNames'?: { [key: string]: object; };
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'groups'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<FamilyMember>}
     * @memberof ProfileData
     */
    'familyMembers'?: Array<FamilyMember>;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'relationship'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'notes'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'lifeEvents'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'reviews'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'movies'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'games'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'following'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {object}
     * @memberof ProfileData
     */
    'basicInfo'?: object;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'sports'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'videos'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<Work>}
     * @memberof ProfileData
     */
    'work'?: Array<Work>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'checkIns'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'books'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'highlights'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'descriptions'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileData
     */
    'favouritesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileData
     */
    'followingCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'profileCreatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileData
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileData
     */
    'likesCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'profileDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileData
     */
    'statusesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileData
     */
    'listedCount'?: number;
    /**
     * 
     * @type {Array<ProfileDataList>}
     * @memberof ProfileData
     */
    'lists'?: Array<ProfileDataList>;
    /**
     * 
     * @type {Array<ProfileDataItem>}
     * @memberof ProfileData
     */
    'likes'?: Array<ProfileDataItem>;
    /**
     * 
     * @type {number}
     * @memberof ProfileData
     */
    'internalGroupId'?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'career'?: { [key: string]: object; };
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'gifts'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'followers'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'contact_information'?: { [key: string]: object; };
    /**
     * 
     * @type {object}
     * @memberof ProfileData
     */
    'o_education'?: object;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'beliefs'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'personal_info'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'counters'?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'achievements'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'subscribers'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'url'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'holidays'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProfileData
     */
    'forums'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'birth_place'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'marital_status'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'family'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'organizations'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'certifications'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'language'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'profile_summary'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'experience'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'project'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'courses'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'awards'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'test_score'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'connections'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfileData
     */
    'volunteer_experience'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'favorite_quotes'?: string;
}
/**
 * 
 * @export
 * @interface ProfileDataItem
 */
export interface ProfileDataItem {
    /**
     * 
     * @type {string}
     * @memberof ProfileDataItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDataItem
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDataItem
     */
    'linkUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDataItem
     */
    'verified'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDataItem
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ProfileDataList
 */
export interface ProfileDataList {
    /**
     * 
     * @type {string}
     * @memberof ProfileDataList
     */
    'listName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDataList
     */
    'listUrl'?: string;
}
/**
 * 
 * @export
 * @interface ProfileGeneralStatDTO
 */
export interface ProfileGeneralStatDTO {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ProfileGeneralStatDTO
     */
    'sentiment'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ProfileGeneralStatDTO
     */
    'socialNetwork'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ProfileGeneralStatDTO
     */
    'post'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface ProfileInfo
 */
export interface ProfileInfo {
    /**
     * 
     * @type {number}
     * @memberof ProfileInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileInfo
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileInfo
     */
    'createdDate'?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof ProfileInfo
     */
    'statuses'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof ProfileInfo
     */
    'errors'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileInfo
     */
    'phone'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileInfo
     */
    'sources'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileInfo
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileInfo
     */
    'photo'?: string;
    /**
     * 
     * @type {Array<SocialProfileInfo>}
     * @memberof ProfileInfo
     */
    'socialNetworks'?: Array<SocialProfileInfo>;
    /**
     * 
     * @type {number}
     * @memberof ProfileInfo
     */
    'score'?: number;
    /**
     * 
     * @type {Array<DisplayName>}
     * @memberof ProfileInfo
     */
    'displayNames'?: Array<DisplayName>;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileInfo
     */
    'isFavorite'?: boolean;
}
/**
 * 
 * @export
 * @interface ProfileLocationStatDTO
 */
export interface ProfileLocationStatDTO {
    /**
     * 
     * @type {string}
     * @memberof ProfileLocationStatDTO
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileLocationStatDTO
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileLocationStatDTO
     */
    'city'?: string;
    /**
     * 
     * @type {Array<PostLocationDTO>}
     * @memberof ProfileLocationStatDTO
     */
    'postLocations'?: Array<PostLocationDTO>;
}
/**
 * 
 * @export
 * @interface ProfileModificationDTO
 */
export interface ProfileModificationDTO {
    /**
     * 
     * @type {string}
     * @memberof ProfileModificationDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileModificationDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileModificationDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileModificationDTO
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface ProfileNode
 */
export interface ProfileNode extends Node {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileNode
     */
    'cases'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileNode
     */
    'investigations'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileNode
     */
    'allNames'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileNode
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileNode
     */
    'phones'?: string;
}
/**
 * 
 * @export
 * @interface ProfileNodeAllOf
 */
export interface ProfileNodeAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileNodeAllOf
     */
    'cases'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileNodeAllOf
     */
    'investigations'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileNodeAllOf
     */
    'allNames'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileNodeAllOf
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileNodeAllOf
     */
    'phones'?: string;
}
/**
 * 
 * @export
 * @interface ProfilePreferenceDTO
 */
export interface ProfilePreferenceDTO {
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'tvShows'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'books'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'checkIns'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'events'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'following'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'games'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'groups'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'gifts'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'likes'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'movies'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'music'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'musics'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'notes'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'reviews'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'sports'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'videos'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ProfilePreferenceDTO
     */
    'socialNetwork'?: ProfilePreferenceDTOSocialNetworkEnum;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'highlights'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'followers'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ProfilePreferenceDTO
     */
    'subscribers'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {Array<ProfileDataList>}
     * @memberof ProfilePreferenceDTO
     */
    'lists'?: Array<ProfileDataList>;
    /**
     * 
     * @type {string}
     * @memberof ProfilePreferenceDTO
     */
    'profileId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProfilePreferenceDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface ProfileSearchProgressDTO
 */
export interface ProfileSearchProgressDTO {
    /**
     * 
     * @type {Set<string>}
     * @memberof ProfileSearchProgressDTO
     */
    'sources'?: Set<ProfileSearchProgressDTOSourcesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ProfileSearchProgressDTO
     */
    'lastLookupDate'?: string;
    /**
     * 
     * @type {Set<CrawlerProgressDTO>}
     * @memberof ProfileSearchProgressDTO
     */
    'nameCrawlers'?: Set<CrawlerProgressDTO>;
    /**
     * 
     * @type {Set<CrawlerProgressDTO>}
     * @memberof ProfileSearchProgressDTO
     */
    'passwordCrawlers'?: Set<CrawlerProgressDTO>;
    /**
     * 
     * @type {Set<CrawlerProgressDTO>}
     * @memberof ProfileSearchProgressDTO
     */
    'lookups'?: Set<CrawlerProgressDTO>;
    /**
     * 
     * @type {Set<Name>}
     * @memberof ProfileSearchProgressDTO
     */
    'names'?: Set<Name>;
    /**
     * 
     * @type {Set<string>}
     * @memberof ProfileSearchProgressDTO
     */
    'passwords'?: Set<string>;
    /**
     * 
     * @type {Set<CrawlerProgressDTO>}
     * @memberof ProfileSearchProgressDTO
     */
    'socialCrawlers'?: Set<CrawlerProgressDTO>;
    /**
     * 
     * @type {Set<CrawlerSearchResultDTO>}
     * @memberof ProfileSearchProgressDTO
     */
    'searchResults'?: Set<CrawlerSearchResultDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum ProfileSearchProgressDTOSourcesEnum {
    CreatingTarget = 'CREATING_TARGET',
    ManualAdded = 'MANUAL_ADDED',
    WebCollection = 'WEB_COLLECTION',
    Adid = 'ADID',
    AdidGeo = 'ADID_GEO',
    Luna = 'LUNA',
    Pipl = 'PIPL',
    PiplPerson = 'PIPL_PERSON',
    PiplPossible = 'PIPL_POSSIBLE',
    PiplSource = 'PIPL_SOURCE',
    Pluto = 'PLUTO',
    Botim = 'BOTIM',
    Skype = 'SKYPE',
    Whatsapp = 'WHATSAPP',
    Callapp = 'CALLAPP',
    Tamtam = 'TAMTAM',
    Imo = 'IMO',
    Tc = 'TC',
    Telegram = 'TELEGRAM',
    Drupe = 'DRUPE',
    Getcontact = 'GETCONTACT',
    Viber = 'VIBER',
    Eyecon = 'EYECON',
    Hiya = 'HIYA',
    Viewcaller = 'VIEWCALLER',
    Kraken = 'KRAKEN',
    Hydra = 'HYDRA',
    Syncme = 'SYNCME',
    Line = 'LINE',
    Wechat = 'WECHAT',
    Vkontakte = 'VKONTAKTE',
    Zalo = 'ZALO',
    Showcaller = 'SHOWCALLER',
    Swarmapp = 'SWARMAPP',
    Numbuster = 'NUMBUSTER',
    Me = 'ME',
    Deepweb = 'DEEPWEB',
    MmImage = 'MM_IMAGE',
    ProfileImage = 'PROFILE_IMAGE',
    FindCloneImage = 'FIND_CLONE_IMAGE',
    Search4FaceImage = 'SEARCH_4_FACE_IMAGE',
    SniperImage = 'SNIPER_IMAGE',
    PsychoProfile = 'PSYCHO_PROFILE',
    Crawler = 'CRAWLER'
}

/**
 * 
 * @export
 * @interface PromtAnalyzeRequest
 */
export interface PromtAnalyzeRequest {
    /**
     * 
     * @type {string}
     * @memberof PromtAnalyzeRequest
     */
    'requestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromtAnalyzeRequest
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromtAnalyzeRequest
     */
    'promt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PromtAnalyzeRequest
     */
    'timeout'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromtAnalyzeRequest
     */
    'openAIModel'?: string;
}
/**
 * 
 * @export
 * @interface ProxyServer
 */
export interface ProxyServer {
    /**
     * 
     * @type {boolean}
     * @memberof ProxyServer
     */
    'custom'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProxyServer
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServer
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServer
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServer
     */
    'port'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServer
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServer
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServer
     */
    'proxyType'?: ProxyServerProxyTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProxyServerProxyTypeEnum {
    Https = 'HTTPS',
    Socks5 = 'SOCKS5'
}

/**
 * 
 * @export
 * @interface ProxyServerDTO
 */
export interface ProxyServerDTO {
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProxyServerDTO
     */
    'proxyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'proxyName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyServerDTO
     */
    'custom'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'port'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyServerDTO
     */
    'proxyType'?: ProxyServerDTOProxyTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProxyServerDTOProxyTypeEnum {
    Https = 'HTTPS',
    Socks5 = 'SOCKS5'
}

/**
 * 
 * @export
 * @interface QuarantineInfo
 */
export interface QuarantineInfo {
    /**
     * 
     * @type {number}
     * @memberof QuarantineInfo
     */
    'from'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuarantineInfo
     */
    'to'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuarantineInfo
     */
    'numberOfUses'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuarantineInfo
     */
    'currentCounterOfUses'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuarantineInfo
     */
    'daysInQuarantine'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuarantineInfo
     */
    'startedQuarantine'?: string;
}
/**
 * 
 * @export
 * @interface QuarantineModeDTO
 */
export interface QuarantineModeDTO {
    /**
     * 
     * @type {string}
     * @memberof QuarantineModeDTO
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuarantineModeDTO
     */
    'useQuarantine'?: boolean;
}
/**
 * 
 * @export
 * @interface Quota
 */
export interface Quota {
    /**
     * 
     * @type {boolean}
     * @memberof Quota
     */
    'isDaily'?: boolean;
    /**
     * 
     * @type {QuotaModule}
     * @memberof Quota
     */
    'quotaProfiler'?: QuotaModule;
    /**
     * 
     * @type {QuotaModule}
     * @memberof Quota
     */
    'quotaWebint'?: QuotaModule;
    /**
     * 
     * @type {number}
     * @memberof Quota
     */
    'dailyQuota'?: number;
}
/**
 * 
 * @export
 * @interface QuotaEntity
 */
export interface QuotaEntity {
    /**
     * 
     * @type {number}
     * @memberof QuotaEntity
     */
    'usedQuota'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuotaEntity
     */
    'maxQuota'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuotaEntity
     */
    'maxDailyQuota'?: number;
}
/**
 * 
 * @export
 * @interface QuotaEntityDTO
 */
export interface QuotaEntityDTO {
    /**
     * 
     * @type {number}
     * @memberof QuotaEntityDTO
     */
    'maxQuota'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuotaEntityDTO
     */
    'maxDailyQuota'?: number;
}
/**
 * 
 * @export
 * @interface QuotaEntityResponseDTO
 */
export interface QuotaEntityResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof QuotaEntityResponseDTO
     */
    'maxQuota'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuotaEntityResponseDTO
     */
    'activeQuota'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuotaEntityResponseDTO
     */
    'usedQuota'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuotaEntityResponseDTO
     */
    'maxDailyQuota'?: number;
}
/**
 * 
 * @export
 * @interface QuotaGroupDTO
 */
export interface QuotaGroupDTO {
    /**
     * 
     * @type {boolean}
     * @memberof QuotaGroupDTO
     */
    'isDaily'?: boolean;
    /**
     * 
     * @type {QuotaModuleGroupDTO}
     * @memberof QuotaGroupDTO
     */
    'quotaProfiler'?: QuotaModuleGroupDTO;
    /**
     * 
     * @type {QuotaModuleGroupDTO}
     * @memberof QuotaGroupDTO
     */
    'quotaWebint'?: QuotaModuleGroupDTO;
    /**
     * 
     * @type {number}
     * @memberof QuotaGroupDTO
     */
    'dailyQuota'?: number;
}
/**
 * 
 * @export
 * @interface QuotaModule
 */
export interface QuotaModule {
    /**
     * 
     * @type {QuotaEntity}
     * @memberof QuotaModule
     */
    'lookup'?: QuotaEntity;
    /**
     * 
     * @type {QuotaEntity}
     * @memberof QuotaModule
     */
    'crawler'?: QuotaEntity;
    /**
     * 
     * @type {QuotaEntity}
     * @memberof QuotaModule
     */
    'cases'?: QuotaEntity;
    /**
     * 
     * @type {QuotaEntity}
     * @memberof QuotaModule
     */
    'periodic'?: QuotaEntity;
    /**
     * 
     * @type {QuotaEntity}
     * @memberof QuotaModule
     */
    'monitoring'?: QuotaEntity;
    /**
     * 
     * @type {string}
     * @memberof QuotaModule
     */
    'expireBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaModule
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaModule
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuotaModule
     */
    'isForever'?: boolean;
}
/**
 * 
 * @export
 * @interface QuotaModuleGroupDTO
 */
export interface QuotaModuleGroupDTO {
    /**
     * 
     * @type {QuotaEntityDTO}
     * @memberof QuotaModuleGroupDTO
     */
    'lookup'?: QuotaEntityDTO;
    /**
     * 
     * @type {QuotaEntityDTO}
     * @memberof QuotaModuleGroupDTO
     */
    'crawler'?: QuotaEntityDTO;
    /**
     * 
     * @type {QuotaEntityDTO}
     * @memberof QuotaModuleGroupDTO
     */
    'cases'?: QuotaEntityDTO;
    /**
     * 
     * @type {QuotaEntityDTO}
     * @memberof QuotaModuleGroupDTO
     */
    'monitoring'?: QuotaEntityDTO;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleGroupDTO
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleGroupDTO
     */
    'expireBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleGroupDTO
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuotaModuleGroupDTO
     */
    'isForever'?: boolean;
}
/**
 * 
 * @export
 * @interface QuotaModuleResponseDTO
 */
export interface QuotaModuleResponseDTO {
    /**
     * 
     * @type {QuotaEntityResponseDTO}
     * @memberof QuotaModuleResponseDTO
     */
    'lookup'?: QuotaEntityResponseDTO;
    /**
     * 
     * @type {QuotaEntityResponseDTO}
     * @memberof QuotaModuleResponseDTO
     */
    'crawler'?: QuotaEntityResponseDTO;
    /**
     * 
     * @type {QuotaEntityResponseDTO}
     * @memberof QuotaModuleResponseDTO
     */
    'cases'?: QuotaEntityResponseDTO;
    /**
     * 
     * @type {QuotaEntityResponseDTO}
     * @memberof QuotaModuleResponseDTO
     */
    'monitoring'?: QuotaEntityResponseDTO;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleResponseDTO
     */
    'expireBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleResponseDTO
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleResponseDTO
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuotaModuleResponseDTO
     */
    'isForever'?: boolean;
}
/**
 * 
 * @export
 * @interface QuotaModuleUserDTO
 */
export interface QuotaModuleUserDTO {
    /**
     * 
     * @type {QuotaEntityDTO}
     * @memberof QuotaModuleUserDTO
     */
    'lookup'?: QuotaEntityDTO;
    /**
     * 
     * @type {QuotaEntityDTO}
     * @memberof QuotaModuleUserDTO
     */
    'crawler'?: QuotaEntityDTO;
    /**
     * 
     * @type {QuotaEntityDTO}
     * @memberof QuotaModuleUserDTO
     */
    'cases'?: QuotaEntityDTO;
    /**
     * 
     * @type {QuotaEntityDTO}
     * @memberof QuotaModuleUserDTO
     */
    'monitoring'?: QuotaEntityDTO;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleUserDTO
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleUserDTO
     */
    'expireBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaModuleUserDTO
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuotaModuleUserDTO
     */
    'isForever'?: boolean;
}
/**
 * 
 * @export
 * @interface QuotaResponseDTO
 */
export interface QuotaResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof QuotaResponseDTO
     */
    'isDaily'?: boolean;
    /**
     * 
     * @type {QuotaModuleResponseDTO}
     * @memberof QuotaResponseDTO
     */
    'quotaProfiler'?: QuotaModuleResponseDTO;
    /**
     * 
     * @type {QuotaModuleResponseDTO}
     * @memberof QuotaResponseDTO
     */
    'quotaWebint'?: QuotaModuleResponseDTO;
    /**
     * 
     * @type {number}
     * @memberof QuotaResponseDTO
     */
    'dailyQuota'?: number;
}
/**
 * 
 * @export
 * @interface QuotaUserDTO
 */
export interface QuotaUserDTO {
    /**
     * 
     * @type {boolean}
     * @memberof QuotaUserDTO
     */
    'isDaily'?: boolean;
    /**
     * 
     * @type {QuotaModuleUserDTO}
     * @memberof QuotaUserDTO
     */
    'quotaProfiler'?: QuotaModuleUserDTO;
    /**
     * 
     * @type {QuotaModuleUserDTO}
     * @memberof QuotaUserDTO
     */
    'quotaWebint'?: QuotaModuleUserDTO;
    /**
     * 
     * @type {number}
     * @memberof QuotaUserDTO
     */
    'dailyQuota'?: number;
}
/**
 * 
 * @export
 * @interface QuotaUserModuleResponseDTO
 */
export interface QuotaUserModuleResponseDTO {
    /**
     * 
     * @type {QuotaEntityResponseDTO}
     * @memberof QuotaUserModuleResponseDTO
     */
    'lookup'?: QuotaEntityResponseDTO;
    /**
     * 
     * @type {QuotaEntityResponseDTO}
     * @memberof QuotaUserModuleResponseDTO
     */
    'crawler'?: QuotaEntityResponseDTO;
    /**
     * 
     * @type {QuotaEntityResponseDTO}
     * @memberof QuotaUserModuleResponseDTO
     */
    'cases'?: QuotaEntityResponseDTO;
    /**
     * 
     * @type {QuotaEntityResponseDTO}
     * @memberof QuotaUserModuleResponseDTO
     */
    'monitoring'?: QuotaEntityResponseDTO;
    /**
     * 
     * @type {string}
     * @memberof QuotaUserModuleResponseDTO
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaUserModuleResponseDTO
     */
    'expireBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuotaUserModuleResponseDTO
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuotaUserModuleResponseDTO
     */
    'isForever'?: boolean;
}
/**
 * 
 * @export
 * @interface QuotaUserResponseDTO
 */
export interface QuotaUserResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof QuotaUserResponseDTO
     */
    'isDaily'?: boolean;
    /**
     * 
     * @type {QuotaUserModuleResponseDTO}
     * @memberof QuotaUserResponseDTO
     */
    'quotaProfiler'?: QuotaUserModuleResponseDTO;
    /**
     * 
     * @type {QuotaUserModuleResponseDTO}
     * @memberof QuotaUserResponseDTO
     */
    'quotaWebint'?: QuotaUserModuleResponseDTO;
    /**
     * 
     * @type {number}
     * @memberof QuotaUserResponseDTO
     */
    'dailyQuota'?: number;
}
/**
 * 
 * @export
 * @interface RecentRepliers
 */
export interface RecentRepliers {
    /**
     * 
     * @type {string}
     * @memberof RecentRepliers
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface Reflections
 */
export interface Reflections {
    /**
     * 
     * @type {Array<string>}
     * @memberof Reflections
     */
    'analyzedElements'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RekognitionDetectRequest
 */
export interface RekognitionDetectRequest {
    /**
     * 
     * @type {string}
     * @memberof RekognitionDetectRequest
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof RekognitionDetectRequest
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof RekognitionDetectRequest
     */
    'collectionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof RekognitionDetectRequest
     */
    'profileId'?: number;
}
/**
 * 
 * @export
 * @interface RekognitionImageEnroll
 */
export interface RekognitionImageEnroll {
    /**
     * 
     * @type {string}
     * @memberof RekognitionImageEnroll
     */
    'imageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RekognitionImageEnroll
     */
    'targetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RekognitionImageEnroll
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof RekognitionImageEnroll
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof RekognitionImageEnroll
     */
    'collectionId'?: string;
}
/**
 * 
 * @export
 * @interface Relationship
 */
export interface Relationship {
    /**
     * 
     * @type {Array<Name>}
     * @memberof Relationship
     */
    'names'?: Array<Name>;
    /**
     * 
     * @type {Array<Address>}
     * @memberof Relationship
     */
    'addresses'?: Array<Address>;
    /**
     * 
     * @type {Array<Phone>}
     * @memberof Relationship
     */
    'phones'?: Array<Phone>;
    /**
     * 
     * @type {Array<Email>}
     * @memberof Relationship
     */
    'emails'?: Array<Email>;
    /**
     * 
     * @type {Array<Job>}
     * @memberof Relationship
     */
    'jobs'?: Array<Job>;
    /**
     * 
     * @type {Array<Education>}
     * @memberof Relationship
     */
    'educations'?: Array<Education>;
    /**
     * 
     * @type {Array<Image>}
     * @memberof Relationship
     */
    'images'?: Array<Image>;
    /**
     * 
     * @type {Array<Username>}
     * @memberof Relationship
     */
    'usernames'?: Array<Username>;
    /**
     * 
     * @type {Array<UserID>}
     * @memberof Relationship
     */
    'userIds'?: Array<UserID>;
    /**
     * 
     * @type {Array<Language>}
     * @memberof Relationship
     */
    'languages'?: Array<Language>;
    /**
     * 
     * @type {Array<Ethnicity>}
     * @memberof Relationship
     */
    'ethnicities'?: Array<Ethnicity>;
    /**
     * 
     * @type {Array<OriginCountry>}
     * @memberof Relationship
     */
    'originCountries'?: Array<OriginCountry>;
    /**
     * 
     * @type {Array<Url>}
     * @memberof Relationship
     */
    'urls'?: Array<Url>;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof Relationship
     */
    'tags'?: Array<Tag>;
    /**
     * 
     * @type {DOB}
     * @memberof Relationship
     */
    'dob'?: DOB;
    /**
     * 
     * @type {Gender}
     * @memberof Relationship
     */
    'gender'?: Gender;
    /**
     * 
     * @type {string}
     * @memberof Relationship
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Relationship
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Relationship
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Relationship
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Relationship
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Relationship
     */
    'subtype'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Relationship
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface Replies
 */
export interface Replies {
    /**
     * 
     * @type {string}
     * @memberof Replies
     */
    'replies'?: string;
    /**
     * 
     * @type {string}
     * @memberof Replies
     */
    'repliesPts'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Replies
     */
    'isComments'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Replies
     */
    'channelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Replies
     */
    'maxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Replies
     */
    'readMaxId'?: string;
    /**
     * 
     * @type {Array<RecentRepliers>}
     * @memberof Replies
     */
    'recentRepliers'?: Array<RecentRepliers>;
}
/**
 * 
 * @export
 * @interface RerunSearchCrawlerStatusDTO
 */
export interface RerunSearchCrawlerStatusDTO {
    /**
     * 
     * @type {number}
     * @memberof RerunSearchCrawlerStatusDTO
     */
    'profileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RerunSearchCrawlerStatusDTO
     */
    'lriId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RerunSearchCrawlerStatusDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RerunSearchCrawlerStatusDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RerunSearchCrawlerStatusDTO
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ScheduleInfoDTO
 */
export interface ScheduleInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'activity'?: ScheduleInfoDTOActivityEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'base64photo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduleInfoDTO
     */
    'timestamp'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'domain'?: ScheduleInfoDTODomainEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'login'?: string;
    /**
     * 
     * @type {AvatarDto}
     * @memberof ScheduleInfoDTO
     */
    'avatarDto'?: AvatarDto;
    /**
     * 
     * @type {string}
     * @memberof ScheduleInfoDTO
     */
    'postId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ScheduleInfoDTOActivityEnum {
    Autologin = 'AUTOLOGIN',
    Post = 'POST',
    LikePost = 'LIKE_POST',
    CommentPost = 'COMMENT_POST',
    Url = 'URL',
    GroupPost = 'GROUP_POST',
    UserPost = 'USER_POST',
    GetPost = 'GET_POST',
    GetComment = 'GET_COMMENT',
    Null = 'NULL'
}
/**
    * @export
    * @enum {string}
    */
export enum ScheduleInfoDTODomainEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface SchedulerSetting
 */
export interface SchedulerSetting {
    /**
     * 
     * @type {number}
     * @memberof SchedulerSetting
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof SchedulerSetting
     */
    'end'?: number;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSetting
     */
    'collectPeriod'?: SchedulerSettingCollectPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSetting
     */
    'lastMonitoringDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SchedulerSetting
     */
    'collectPeriodInHour'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SchedulerSettingCollectPeriodEnum {
    H1 = 'H1',
    H3 = 'H3',
    H5 = 'H5',
    D1 = 'D1'
}

/**
 * 
 * @export
 * @interface Search4FaceDTO
 */
export interface Search4FaceDTO {
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'requestId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Search4FaceDTO
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'face'?: string;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'photo'?: string;
    /**
     * 
     * @type {number}
     * @memberof Search4FaceDTO
     */
    'photoX'?: number;
    /**
     * 
     * @type {number}
     * @memberof Search4FaceDTO
     */
    'photoY'?: number;
    /**
     * 
     * @type {number}
     * @memberof Search4FaceDTO
     */
    'photoWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof Search4FaceDTO
     */
    'photoHeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'source'?: string;
    /**
     * 
     * @type {number}
     * @memberof Search4FaceDTO
     */
    'age'?: number;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'messageError'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Search4FaceDTO
     */
    'isFailed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'statusError'?: string;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Search4FaceDTO
     */
    'maiden_name'?: string;
}
/**
 * 
 * @export
 * @interface SearchHistoryDTO
 */
export interface SearchHistoryDTO {
    /**
     * 
     * @type {number}
     * @memberof SearchHistoryDTO
     */
    'timeStamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchHistoryDTO
     */
    'id'?: number;
    /**
     * 
     * @type {LookupResult}
     * @memberof SearchHistoryDTO
     */
    'lookupResult'?: LookupResult;
    /**
     * 
     * @type {Array<ImageSearchResultDTO>}
     * @memberof SearchHistoryDTO
     */
    'imageResult'?: Array<ImageSearchResultDTO>;
    /**
     * 
     * @type {Array<CrawlerResponseDTO>}
     * @memberof SearchHistoryDTO
     */
    'webResults'?: Array<CrawlerResponseDTO>;
    /**
     * 
     * @type {Array<CrawlerResponseDTO>}
     * @memberof SearchHistoryDTO
     */
    'crawlerResults'?: Array<CrawlerResponseDTO>;
}
/**
 * 
 * @export
 * @interface Sentiment
 */
export interface Sentiment {
    /**
     * 
     * @type {number}
     * @memberof Sentiment
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof Sentiment
     */
    'magnitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof Sentiment
     */
    'sentiment'?: SentimentSentimentEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SentimentSentimentEnum {
    Negative = 'NEGATIVE',
    Positive = 'POSITIVE',
    Neutral = 'NEUTRAL'
}

/**
 * 
 * @export
 * @interface SentimentStat
 */
export interface SentimentStat {
    /**
     * 
     * @type {number}
     * @memberof SentimentStat
     */
    'negative'?: number;
    /**
     * 
     * @type {number}
     * @memberof SentimentStat
     */
    'positive'?: number;
    /**
     * 
     * @type {number}
     * @memberof SentimentStat
     */
    'neutral'?: number;
}
/**
 * 
 * @export
 * @interface SessionDTO
 */
export interface SessionDTO {
    /**
     * 
     * @type {string}
     * @memberof SessionDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionDTO
     */
    'createdDate'?: number;
}
/**
 * 
 * @export
 * @interface SimplePageFilter
 */
export interface SimplePageFilter {
    /**
     * 
     * @type {number}
     * @memberof SimplePageFilter
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof SimplePageFilter
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface SmsBody
 */
export interface SmsBody {
    /**
     * 
     * @type {string}
     * @memberof SmsBody
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsBody
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsBody
     */
    'incoming_sms_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsBody
     */
    'port'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsBody
     */
    'number'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsBody
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsBody
     */
    'imsi'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsBody
     */
    'smsc'?: string;
}
/**
 * 
 * @export
 * @interface SmsDTO
 */
export interface SmsDTO {
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'imsi'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'smsc'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'ccid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'msg_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'port_num'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'number'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'datetime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'unicode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'card_add'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'simNum'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDTO
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface SmsDinstarDTO
 */
export interface SmsDinstarDTO {
    /**
     * 
     * @type {Array<SmsBody>}
     * @memberof SmsDinstarDTO
     */
    'sms'?: Array<SmsBody>;
    /**
     * 
     * @type {string}
     * @memberof SmsDinstarDTO
     */
    'sn'?: string;
}
/**
 * 
 * @export
 * @interface SniperItemDTO
 */
export interface SniperItemDTO {
    /**
     * 
     * @type {string}
     * @memberof SniperItemDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SniperItemDTO
     */
    'profileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SniperItemDTO
     */
    'customRequestId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SniperItemDTO
     */
    'relatedLookupRequestItemId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SniperItemDTO
     */
    'relatedLookupRequestId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SniperItemDTO
     */
    'relatedLookupResponseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SniperItemDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SniperItemDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SniperItemDTO
     */
    'isProfileDataAdded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SniperItemDTO
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof SniperItemDTO
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof SniperItemDTO
     */
    'indexDB'?: number;
    /**
     * 
     * @type {string}
     * @memberof SniperItemDTO
     */
    'base64'?: string;
    /**
     * 
     * @type {string}
     * @memberof SniperItemDTO
     */
    'guid'?: string;
    /**
     * 
     * @type {number}
     * @memberof SniperItemDTO
     */
    'index'?: number;
    /**
     * 
     * @type {string}
     * @memberof SniperItemDTO
     */
    'url'?: string;
    /**
     * 
     * @type {object}
     * @memberof SniperItemDTO
     */
    'seen'?: object;
    /**
     * 
     * @type {number}
     * @memberof SniperItemDTO
     */
    'group'?: number;
}
/**
 * 
 * @export
 * @interface SocialNetworkWrapper
 */
export interface SocialNetworkWrapper {
    /**
     * 
     * @type {string}
     * @memberof SocialNetworkWrapper
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialNetworkWrapper
     */
    'socialNetwork'?: SocialNetworkWrapperSocialNetworkEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SocialNetworkWrapperSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface SocialProfileData
 */
export interface SocialProfileData {
    /**
     * 
     * @type {string}
     * @memberof SocialProfileData
     */
    'profileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialProfileData
     */
    'socialNetwork'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialProfileData
     */
    'avatarId'?: string;
}
/**
 * 
 * @export
 * @interface SocialProfileInfo
 */
export interface SocialProfileInfo {
    /**
     * 
     * @type {string}
     * @memberof SocialProfileInfo
     */
    'socialNetwork'?: SocialProfileInfoSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof SocialProfileInfo
     */
    'profile'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SocialProfileInfoSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface SocialUrl
 */
export interface SocialUrl {
    /**
     * 
     * @type {string}
     * @memberof SocialUrl
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialUrl
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface Sort
 */
export interface Sort {
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'unsorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'sorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface Source
 */
export interface Source {
    /**
     * 
     * @type {Array<Name>}
     * @memberof Source
     */
    'names'?: Array<Name>;
    /**
     * 
     * @type {Array<Address>}
     * @memberof Source
     */
    'addresses'?: Array<Address>;
    /**
     * 
     * @type {Array<Phone>}
     * @memberof Source
     */
    'phones'?: Array<Phone>;
    /**
     * 
     * @type {Array<Email>}
     * @memberof Source
     */
    'emails'?: Array<Email>;
    /**
     * 
     * @type {Array<Job>}
     * @memberof Source
     */
    'jobs'?: Array<Job>;
    /**
     * 
     * @type {Array<Education>}
     * @memberof Source
     */
    'educations'?: Array<Education>;
    /**
     * 
     * @type {Array<Image>}
     * @memberof Source
     */
    'images'?: Array<Image>;
    /**
     * 
     * @type {Array<Username>}
     * @memberof Source
     */
    'usernames'?: Array<Username>;
    /**
     * 
     * @type {Array<UserID>}
     * @memberof Source
     */
    'userIds'?: Array<UserID>;
    /**
     * 
     * @type {Array<Language>}
     * @memberof Source
     */
    'languages'?: Array<Language>;
    /**
     * 
     * @type {Array<Ethnicity>}
     * @memberof Source
     */
    'ethnicities'?: Array<Ethnicity>;
    /**
     * 
     * @type {Array<OriginCountry>}
     * @memberof Source
     */
    'originCountries'?: Array<OriginCountry>;
    /**
     * 
     * @type {Array<Url>}
     * @memberof Source
     */
    'urls'?: Array<Url>;
    /**
     * 
     * @type {Array<Relationship>}
     * @memberof Source
     */
    'relationships'?: Array<Relationship>;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof Source
     */
    'tags'?: Array<Tag>;
    /**
     * 
     * @type {DOB}
     * @memberof Source
     */
    'dob'?: DOB;
    /**
     * 
     * @type {Gender}
     * @memberof Source
     */
    'gender'?: Gender;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    'originUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    'personId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Source
     */
    'match'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Source
     */
    'sponsored'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Source
     */
    'premium'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    'validSince'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Source
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface SourceInfoDTO
 */
export interface SourceInfoDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof SourceInfoDTO
     */
    'names'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourceInfoDTO
     */
    'emails'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SourceInfoDTO
     */
    'source'?: SourceInfoDTOSourceEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourceInfoDTO
     */
    'socialNetworkIDs'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SourceInfoDTO
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceInfoDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceInfoDTO
     */
    'statusDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceInfoDTO
     */
    'lastOnlineTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceInfoDTO
     */
    'bio'?: string;
    /**
     * 
     * @type {Array<LocationDTO>}
     * @memberof SourceInfoDTO
     */
    'locationInfo'?: Array<LocationDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum SourceInfoDTOSourceEnum {
    CreatingTarget = 'CREATING_TARGET',
    ManualAdded = 'MANUAL_ADDED',
    WebCollection = 'WEB_COLLECTION',
    Adid = 'ADID',
    AdidGeo = 'ADID_GEO',
    Luna = 'LUNA',
    Pipl = 'PIPL',
    PiplPerson = 'PIPL_PERSON',
    PiplPossible = 'PIPL_POSSIBLE',
    PiplSource = 'PIPL_SOURCE',
    Pluto = 'PLUTO',
    Botim = 'BOTIM',
    Skype = 'SKYPE',
    Whatsapp = 'WHATSAPP',
    Callapp = 'CALLAPP',
    Tamtam = 'TAMTAM',
    Imo = 'IMO',
    Tc = 'TC',
    Telegram = 'TELEGRAM',
    Drupe = 'DRUPE',
    Getcontact = 'GETCONTACT',
    Viber = 'VIBER',
    Eyecon = 'EYECON',
    Hiya = 'HIYA',
    Viewcaller = 'VIEWCALLER',
    Kraken = 'KRAKEN',
    Hydra = 'HYDRA',
    Syncme = 'SYNCME',
    Line = 'LINE',
    Wechat = 'WECHAT',
    Vkontakte = 'VKONTAKTE',
    Zalo = 'ZALO',
    Showcaller = 'SHOWCALLER',
    Swarmapp = 'SWARMAPP',
    Numbuster = 'NUMBUSTER',
    Me = 'ME',
    Deepweb = 'DEEPWEB',
    MmImage = 'MM_IMAGE',
    ProfileImage = 'PROFILE_IMAGE',
    FindCloneImage = 'FIND_CLONE_IMAGE',
    Search4FaceImage = 'SEARCH_4_FACE_IMAGE',
    SniperImage = 'SNIPER_IMAGE',
    PsychoProfile = 'PSYCHO_PROFILE',
    Crawler = 'CRAWLER'
}

/**
 * 
 * @export
 * @interface SpeechSearchFilter
 */
export interface SpeechSearchFilter {
    /**
     * 
     * @type {string}
     * @memberof SpeechSearchFilter
     */
    'userName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SpeechSearchFilter
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof SpeechSearchFilter
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof SpeechSearchFilter
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface StatsLastPosts
 */
export interface StatsLastPosts {
    /**
     * 
     * @type {number}
     * @memberof StatsLastPosts
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatsLastPosts
     */
    'likesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatsLastPosts
     */
    'averageCountOfReceivedLikesPerPost'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatsLastPosts
     */
    'averageCountOfReceivedCommentsPerPost'?: number;
    /**
     * 
     * @type {string}
     * @memberof StatsLastPosts
     */
    'averageTimeBetweenPosts'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatsLastPosts
     */
    'followersPercentageWhoLikesThePublishedPosts'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatsLastPosts
     */
    'followersPercentageWhoWriteACommentForPosts'?: string;
}
/**
 * 
 * @export
 * @interface StepConfigurationDto
 */
export interface StepConfigurationDto {
    /**
     * 
     * @type {number}
     * @memberof StepConfigurationDto
     */
    'postsCount'?: number;
    /**
     * 
     * @type {MinMax}
     * @memberof StepConfigurationDto
     */
    'commentsPerPost'?: MinMax;
    /**
     * 
     * @type {MinMax}
     * @memberof StepConfigurationDto
     */
    'likesPerPost'?: MinMax;
    /**
     * 
     * @type {string}
     * @memberof StepConfigurationDto
     */
    'timeDistribution'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepConfigurationDto
     */
    'contentThemes'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof StepConfigurationDto
     */
    'avoidSelfActions'?: boolean;
}
/**
 * 
 * @export
 * @interface StepCreateRequest
 */
export interface StepCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof StepCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StepCreateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepCreateRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {StepConfigurationDto}
     * @memberof StepCreateRequest
     */
    'configuration'?: StepConfigurationDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepCreateRequest
     */
    'socialProfileIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StepCreateRequest
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof StepCreateRequest
     */
    'endTime': string;
}
/**
 * 
 * @export
 * @interface StepDto
 */
export interface StepDto {
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'campaignId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof StepDto
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'status'?: StepDtoStatusEnum;
    /**
     * 
     * @type {StepConfigurationDto}
     * @memberof StepDto
     */
    'configuration'?: StepConfigurationDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepDto
     */
    'socialProfileIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepDto
     */
    'endTime'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum StepDtoStatusEnum {
    Draft = 'DRAFT',
    Scheduled = 'SCHEDULED',
    Active = 'ACTIVE',
    Paused = 'PAUSED',
    Completed = 'COMPLETED',
    Archived = 'ARCHIVED'
}

/**
 * 
 * @export
 * @interface StepPageRequest
 */
export interface StepPageRequest {
    /**
     * 
     * @type {number}
     * @memberof StepPageRequest
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepPageRequest
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof StepPageRequest
     */
    'status'?: StepPageRequestStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum StepPageRequestStatusEnum {
    Draft = 'DRAFT',
    Scheduled = 'SCHEDULED',
    Active = 'ACTIVE',
    Paused = 'PAUSED',
    Completed = 'COMPLETED',
    Archived = 'ARCHIVED'
}

/**
 * 
 * @export
 * @interface StepStatsDto
 */
export interface StepStatsDto {
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'totalActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'completedActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'failedActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'pendingActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'inProgressActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'pausedActions'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'likesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StepStatsDto
     */
    'completionPercentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof StepStatsDto
     */
    'lastUpdated'?: string;
}
/**
 * 
 * @export
 * @interface StepUpdateRequest
 */
export interface StepUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof StepUpdateRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof StepUpdateRequest
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof StepUpdateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepUpdateRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {StepConfigurationDto}
     * @memberof StepUpdateRequest
     */
    'configuration'?: StepConfigurationDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepUpdateRequest
     */
    'socialProfileIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StepUpdateRequest
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof StepUpdateRequest
     */
    'endTime': string;
}
/**
 * 
 * @export
 * @interface StepWithStatsDto
 */
export interface StepWithStatsDto {
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'campaignId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof StepWithStatsDto
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepWithStatsDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'status'?: StepWithStatsDtoStatusEnum;
    /**
     * 
     * @type {StepConfigurationDto}
     * @memberof StepWithStatsDto
     */
    'configuration'?: StepConfigurationDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepWithStatsDto
     */
    'socialProfileIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepWithStatsDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {StepStatsDto}
     * @memberof StepWithStatsDto
     */
    'stats'?: StepStatsDto;
}

/**
    * @export
    * @enum {string}
    */
export enum StepWithStatsDtoStatusEnum {
    Draft = 'DRAFT',
    Scheduled = 'SCHEDULED',
    Active = 'ACTIVE',
    Paused = 'PAUSED',
    Completed = 'COMPLETED',
    Archived = 'ARCHIVED'
}

/**
 * 
 * @export
 * @interface SynopsisDTO
 */
export interface SynopsisDTO {
    /**
     * 
     * @type {string}
     * @memberof SynopsisDTO
     */
    'content'?: string;
}
/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Tag
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Tag
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'classification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Tag
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface TeamMembers
 */
export interface TeamMembers {
    /**
     * 
     * @type {string}
     * @memberof TeamMembers
     */
    'other'?: string;
}
/**
 * 
 * @export
 * @interface TelegramIntegration
 */
export interface TelegramIntegration {
    /**
     * 
     * @type {string}
     * @memberof TelegramIntegration
     */
    'apiKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof TelegramIntegration
     */
    'chatId'?: string;
}
/**
 * 
 * @export
 * @interface TextsAndSymbols
 */
export interface TextsAndSymbols {
    /**
     * 
     * @type {Array<string>}
     * @memberof TextsAndSymbols
     */
    'visibleTexts'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TextsAndSymbols
     */
    'symbolsOrLogos'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TextsAndSymbols
     */
    'uniformsOrFlags'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ThreatAssessment
 */
export interface ThreatAssessment {
    /**
     * 
     * @type {Array<string>}
     * @memberof ThreatAssessment
     */
    'weapons'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ThreatAssessment
     */
    'suspiciousObjects'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ThreatAssessment
     */
    'violenceIndicators'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ThreatAssessment
     */
    'Alert'?: string;
}
/**
 * 
 * @export
 * @interface Time
 */
export interface Time {
    /**
     * 
     * @type {string}
     * @memberof Time
     */
    'estimatedTimeOfDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof Time
     */
    'season'?: string;
    /**
     * 
     * @type {string}
     * @memberof Time
     */
    'estimatedDate'?: string;
}
/**
 * 
 * @export
 * @interface Url
 */
export interface Url {
    /**
     * 
     * @type {string}
     * @memberof Url
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Url
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Url
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Url
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Url
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Url
     */
    'category'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Url
     */
    'sponsored'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Url
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof Url
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Url
     */
    'sourceId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Url
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface UserCreateDTO
 */
export interface UserCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof UserCreateDTO
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateDTO
     */
    'password': string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserCreateDTO
     */
    'roles': Set<UserCreateDTORolesEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserCreateDTO
     */
    'groupId'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserCreateDTO
     */
    'permissions'?: Set<string>;
    /**
     * 
     * @type {QuotaUserDTO}
     * @memberof UserCreateDTO
     */
    'quota'?: QuotaUserDTO;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreateDTO
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserCreateDTO
     */
    'createdDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserCreateDTO
     */
    'description'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserCreateDTORolesEnum {
    Admin = 'ADMIN',
    Manager = 'MANAGER',
    User = 'USER',
    System = 'SYSTEM'
}

/**
 * 
 * @export
 * @interface UserDetails
 */
export interface UserDetails {
    /**
     * 
     * @type {string}
     * @memberof UserDetails
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetails
     */
    'userName'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetails
     */
    'roles'?: Set<UserDetailsRolesEnum>;
    /**
     * 
     * @type {Quota}
     * @memberof UserDetails
     */
    'quota'?: Quota;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetails
     */
    'webintIsActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetails
     */
    'profilerIsActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetails
     */
    'topPostsIsActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetails
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserDetails
     */
    'invCount'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum UserDetailsRolesEnum {
    Admin = 'ADMIN',
    Manager = 'MANAGER',
    User = 'USER',
    System = 'SYSTEM'
}

/**
 * 
 * @export
 * @interface UserFilter
 */
export interface UserFilter {
    /**
     * 
     * @type {PageFilter}
     * @memberof UserFilter
     */
    'pageFilter'?: PageFilter;
    /**
     * 
     * @type {boolean}
     * @memberof UserFilter
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {UserSort}
     * @memberof UserFilter
     */
    'sort'?: UserSort;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    'groupId'?: string;
}
/**
 * 
 * @export
 * @interface UserID
 */
export interface UserID {
    /**
     * 
     * @type {string}
     * @memberof UserID
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserID
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserID
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserID
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserID
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserID
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    'userName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    'webintIsActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    'profilerIsActive'?: boolean;
    /**
     * 
     * @type {QuotaResponseDTO}
     * @memberof UserInfo
     */
    'quota'?: QuotaResponseDTO;
    /**
     * 
     * @type {Array<Permission>}
     * @memberof UserInfo
     */
    'permissions'?: Array<Permission>;
}
/**
 * 
 * @export
 * @interface UserInfoDTO
 */
export interface UserInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof UserInfoDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInfoDTO
     */
    'roles'?: Array<UserInfoDTORolesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfoDTO
     */
    'isActive'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum UserInfoDTORolesEnum {
    Admin = 'ADMIN',
    Manager = 'MANAGER',
    User = 'USER',
    System = 'SYSTEM'
}

/**
 * 
 * @export
 * @interface UserNameDTO
 */
export interface UserNameDTO {
    /**
     * 
     * @type {string}
     * @memberof UserNameDTO
     */
    'newName': string;
    /**
     * 
     * @type {string}
     * @memberof UserNameDTO
     */
    'oldName'?: string;
}
/**
 * 
 * @export
 * @interface UserResponseDTO
 */
export interface UserResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof UserResponseDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserResponseDTO
     */
    'roles'?: Set<UserResponseDTORolesEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDTO
     */
    'groupId'?: string;
    /**
     * 
     * @type {Set<Permission>}
     * @memberof UserResponseDTO
     */
    'permissions'?: Set<Permission>;
    /**
     * 
     * @type {QuotaUserResponseDTO}
     * @memberof UserResponseDTO
     */
    'quota'?: QuotaUserResponseDTO;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDTO
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserResponseDTO
     */
    'invCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserResponseDTO
     */
    'createdDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDTO
     */
    'description'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserResponseDTORolesEnum {
    Admin = 'ADMIN',
    Manager = 'MANAGER',
    User = 'USER',
    System = 'SYSTEM'
}

/**
 * 
 * @export
 * @interface UserResponseSessionDTO
 */
export interface UserResponseSessionDTO {
    /**
     * 
     * @type {string}
     * @memberof UserResponseSessionDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseSessionDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserResponseSessionDTO
     */
    'roles'?: Set<UserResponseSessionDTORolesEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserResponseSessionDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseSessionDTO
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseSessionDTO
     */
    'grName'?: string;
    /**
     * 
     * @type {Set<Permission>}
     * @memberof UserResponseSessionDTO
     */
    'permissions'?: Set<Permission>;
    /**
     * 
     * @type {SessionDTO}
     * @memberof UserResponseSessionDTO
     */
    'session'?: SessionDTO;
    /**
     * 
     * @type {QuotaUserResponseDTO}
     * @memberof UserResponseSessionDTO
     */
    'quota'?: QuotaUserResponseDTO;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseSessionDTO
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserResponseSessionDTO
     */
    'invCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserResponseSessionDTO
     */
    'createdDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserResponseSessionDTO
     */
    'description'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserResponseSessionDTORolesEnum {
    Admin = 'ADMIN',
    Manager = 'MANAGER',
    User = 'USER',
    System = 'SYSTEM'
}

/**
 * 
 * @export
 * @interface UserSort
 */
export interface UserSort {
    /**
     * 
     * @type {string}
     * @memberof UserSort
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSort
     */
    'direction'?: UserSortDirectionEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UserSortDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}

/**
 * 
 * @export
 * @interface UserStat
 */
export interface UserStat {
    /**
     * 
     * @type {string}
     * @memberof UserStat
     */
    'user'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserStat
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface UserUpdateDTO
 */
export interface UserUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDTO
     */
    'password'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserUpdateDTO
     */
    'roles'?: Set<UserUpdateDTORolesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserUpdateDTO
     */
    'permissions'?: Set<string>;
    /**
     * 
     * @type {QuotaUserDTO}
     * @memberof UserUpdateDTO
     */
    'quota'?: QuotaUserDTO;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDTO
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDTO
     */
    'description'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserUpdateDTORolesEnum {
    Admin = 'ADMIN',
    Manager = 'MANAGER',
    User = 'USER',
    System = 'SYSTEM'
}

/**
 * 
 * @export
 * @interface Username
 */
export interface Username {
    /**
     * 
     * @type {string}
     * @memberof Username
     */
    'validSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Username
     */
    'lastSeen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Username
     */
    'current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Username
     */
    'inferred'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Username
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Username
     */
    'searchable'?: boolean;
}
/**
 * 
 * @export
 * @interface VericityScore
 */
export interface VericityScore {
    /**
     * 
     * @type {number}
     * @memberof VericityScore
     */
    'location'?: number;
    /**
     * 
     * @type {number}
     * @memberof VericityScore
     */
    'time'?: number;
    /**
     * 
     * @type {number}
     * @memberof VericityScore
     */
    'people'?: number;
    /**
     * 
     * @type {number}
     * @memberof VericityScore
     */
    'textsAndSymbols'?: number;
    /**
     * 
     * @type {number}
     * @memberof VericityScore
     */
    'threatAssessment'?: number;
    /**
     * 
     * @type {number}
     * @memberof VericityScore
     */
    'objectsAndScene'?: number;
    /**
     * 
     * @type {number}
     * @memberof VericityScore
     */
    'reflections'?: number;
}
/**
 * 
 * @export
 * @interface Video
 */
export interface Video {
    /**
     * 
     * @type {string}
     * @memberof Video
     */
    'duration'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Video
     */
    'isTaggedVideo'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Video
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Video
     */
    'linkUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Video
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface WebIntEntity
 */
export interface WebIntEntity {
    /**
     * 
     * @type {Array<GroupDTO>}
     * @memberof WebIntEntity
     */
    'groups'?: Array<GroupDTO>;
}
/**
 * 
 * @export
 * @interface WebintAnalyzeRequest
 */
export interface WebintAnalyzeRequest {
    /**
     * 
     * @type {string}
     * @memberof WebintAnalyzeRequest
     */
    'requestId'?: string;
    /**
     * 
     * @type {number}
     * @memberof WebintAnalyzeRequest
     */
    'webintId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WebintAnalyzeRequest
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebintAnalyzeRequest
     */
    'json'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebintAnalyzeRequest
     */
    'prompt'?: string;
    /**
     * 
     * @type {number}
     * @memberof WebintAnalyzeRequest
     */
    'timeout'?: number;
    /**
     * 
     * @type {string}
     * @memberof WebintAnalyzeRequest
     */
    'openAIModel'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WebintAnalyzeRequest
     */
    'isRerun'?: boolean;
}
/**
 * 
 * @export
 * @interface WebintDTO
 */
export interface WebintDTO {
    /**
     * 
     * @type {string}
     * @memberof WebintDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof WebintDTO
     */
    'caseNumber'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WebintDTO
     */
    'isMonitoring'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebintDTO
     */
    'collectLikes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebintDTO
     */
    'collectComments'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebintDTO
     */
    'imageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebintDTO
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof WebintDTO
     */
    'createdDate'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebintDTO
     */
    'avatars'?: Array<string>;
    /**
     * 
     * @type {Array<AvatarInfo>}
     * @memberof WebintDTO
     */
    'avatarInfos'?: Array<AvatarInfo>;
    /**
     * 
     * @type {string}
     * @memberof WebintDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {Array<KeywordDTO>}
     * @memberof WebintDTO
     */
    'keywords'?: Array<KeywordDTO>;
    /**
     * 
     * @type {Array<WebintGroupDTO>}
     * @memberof WebintDTO
     */
    'groups'?: Array<WebintGroupDTO>;
    /**
     * 
     * @type {WebintProfileDTO}
     * @memberof WebintDTO
     */
    'profile'?: WebintProfileDTO;
    /**
     * 
     * @type {string}
     * @memberof WebintDTO
     */
    'type'?: WebintDTOTypeEnum;
    /**
     * 
     * @type {SchedulerSetting}
     * @memberof WebintDTO
     */
    'schedulerSetting'?: SchedulerSetting;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebintDTO
     */
    'socialNetworks'?: Array<WebintDTOSocialNetworksEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof WebintDTO
     */
    'isFavorite'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum WebintDTOTypeEnum {
    GroupChannel = 'GROUP_CHANNEL',
    Keywords = 'KEYWORDS',
    ProfilePosts = 'PROFILE_POSTS',
    GroupKeywords = 'GROUP_KEYWORDS'
}
/**
    * @export
    * @enum {string}
    */
export enum WebintDTOSocialNetworksEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface WebintGeneralStatDTO
 */
export interface WebintGeneralStatDTO {
    /**
     * 
     * @type {Array<UserStat>}
     * @memberof WebintGeneralStatDTO
     */
    'users'?: Array<UserStat>;
    /**
     * 
     * @type {Array<MonitorStat>}
     * @memberof WebintGeneralStatDTO
     */
    'monitors'?: Array<MonitorStat>;
}
/**
 * 
 * @export
 * @interface WebintGroupDTO
 */
export interface WebintGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof WebintGroupDTO
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebintGroupDTO
     */
    'socialNetwork'?: WebintGroupDTOSocialNetworkEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum WebintGroupDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface WebintInfoDTO
 */
export interface WebintInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof WebintInfoDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebintInfoDTO
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface WebintProfileDTO
 */
export interface WebintProfileDTO {
    /**
     * 
     * @type {string}
     * @memberof WebintProfileDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebintProfileDTO
     */
    'socialNetwork'?: WebintProfileDTOSocialNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof WebintProfileDTO
     */
    'socialProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebintProfileDTO
     */
    'imageId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum WebintProfileDTOSocialNetworkEnum {
    Fb = 'FB',
    Facebook = 'FACEBOOK',
    Vk = 'VK',
    Vkontakte = 'VKONTAKTE',
    Ok = 'OK',
    Odnoklassniki = 'ODNOKLASSNIKI',
    Linkedin = 'LINKEDIN',
    Tumblr = 'TUMBLR',
    Youtube = 'YOUTUBE',
    Jobzella = 'JOBZELLA',
    Twitter = 'TWITTER',
    X = 'X',
    Foursquare = 'FOURSQUARE',
    Angellist = 'ANGELLIST',
    Instagram = 'INSTAGRAM',
    MyMailRu = 'MY_MAIL_RU',
    Gplus = 'GPLUS',
    GooglePlus = 'GOOGLE_PLUS',
    Gab = 'GAB',
    Snapchat = 'SNAPCHAT',
    Badoo = 'BADOO',
    Fling = 'FLING',
    Tpersona = 'TPERSONA',
    PhNewId = 'PH_NEW_ID',
    Blackhatworld = 'BLACKHATWORLD',
    Dubsmash = 'DUBSMASH',
    GeorgiaCitizenship = 'GEORGIA_CITIZENSHIP',
    Telegram = 'TELEGRAM',
    Search4Faces = 'SEARCH4FACES',
    Findclone = 'FINDCLONE',
    WebvsPrimary = 'WEBVS_PRIMARY',
    Baidu = 'BAIDU',
    Googlesearch = 'GOOGLESEARCH',
    Mymail = 'MYMAIL',
    Yandex = 'YANDEX',
    Yahoo = 'YAHOO',
    Skype = 'SKYPE',
    Massmapper = 'MASSMAPPER',
    Mm = 'MM',
    Profiler = 'PROFILER',
    Pipl = 'PIPL',
    Hydra = 'HYDRA',
    Tiktok = 'TIKTOK',
    Instanavigation = 'INSTANAVIGATION',
    Sniper = 'SNIPER',
    Psychoprofile = 'PSYCHOPROFILE',
    Irbisnamelookup = 'IRBISNAMELOOKUP',
    Pinterest = 'PINTEREST'
}

/**
 * 
 * @export
 * @interface WebintUserStatFilterDTO
 */
export interface WebintUserStatFilterDTO {
    /**
     * 
     * @type {string}
     * @memberof WebintUserStatFilterDTO
     */
    'userName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WebintUserStatFilterDTO
     */
    'isMonitoring'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WebintUserStatFilterDTO
     */
    'startDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof WebintUserStatFilterDTO
     */
    'endDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof WebintUserStatFilterDTO
     */
    'skip'?: number;
    /**
     * 
     * @type {number}
     * @memberof WebintUserStatFilterDTO
     */
    'batch'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebintUserStatFilterDTO
     */
    'userNames'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Work
 */
export interface Work {
    /**
     * 
     * @type {Array<string>}
     * @memberof Work
     */
    'otherInfo'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Work
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Work
     */
    'jobTitle'?: string;
}

/**
 * ApiCRUDToCreateAlertCriteriaApi - axios parameter creator
 * @export
 */
export const ApiCRUDToCreateAlertCriteriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AlertCriteria} alertCriteria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertC: async (alertCriteria: AlertCriteria, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertCriteria' is not null or undefined
            assertParamExists('createAlertC', 'alertCriteria', alertCriteria)
            const localVarPath = `/api/alert/criteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertCriteria, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alertId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertC: async (alertId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('deleteAlertC', 'alertId', alertId)
            const localVarPath = `/api/alert/criteria/{alertId}`
                .replace(`{${"alertId"}}`, encodeURIComponent(String(alertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alertId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertC: async (alertId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('getAlertC', 'alertId', alertId)
            const localVarPath = `/api/alert/criteria/{alertId}`
                .replace(`{${"alertId"}}`, encodeURIComponent(String(alertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlertC: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alert/criteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alertId 
         * @param {AlertCriteria} alertCriteria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertC: async (alertId: string, alertCriteria: AlertCriteria, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('updateAlertC', 'alertId', alertId)
            // verify required parameter 'alertCriteria' is not null or undefined
            assertParamExists('updateAlertC', 'alertCriteria', alertCriteria)
            const localVarPath = `/api/alert/criteria/{alertId}`
                .replace(`{${"alertId"}}`, encodeURIComponent(String(alertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertCriteria, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiCRUDToCreateAlertCriteriaApi - functional programming interface
 * @export
 */
export const ApiCRUDToCreateAlertCriteriaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiCRUDToCreateAlertCriteriaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AlertCriteria} alertCriteria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAlertC(alertCriteria: AlertCriteria, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertCriteria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAlertC(alertCriteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} alertId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlertC(alertId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertCriteria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlertC(alertId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} alertId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlertC(alertId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertCriteria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlertC(alertId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAlertC(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlertCriteria>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAlertC(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} alertId 
         * @param {AlertCriteria} alertCriteria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAlertC(alertId: string, alertCriteria: AlertCriteria, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAlertC(alertId, alertCriteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiCRUDToCreateAlertCriteriaApi - factory interface
 * @export
 */
export const ApiCRUDToCreateAlertCriteriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiCRUDToCreateAlertCriteriaApiFp(configuration)
    return {
        /**
         * 
         * @param {AlertCriteria} alertCriteria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertC(alertCriteria: AlertCriteria, options?: any): AxiosPromise<AlertCriteria> {
            return localVarFp.createAlertC(alertCriteria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} alertId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertC(alertId: string, options?: any): AxiosPromise<AlertCriteria> {
            return localVarFp.deleteAlertC(alertId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} alertId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertC(alertId: string, options?: any): AxiosPromise<AlertCriteria> {
            return localVarFp.getAlertC(alertId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlertC(options?: any): AxiosPromise<Array<AlertCriteria>> {
            return localVarFp.getAllAlertC(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} alertId 
         * @param {AlertCriteria} alertCriteria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertC(alertId: string, alertCriteria: AlertCriteria, options?: any): AxiosPromise<object> {
            return localVarFp.updateAlertC(alertId, alertCriteria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiCRUDToCreateAlertCriteriaApi - object-oriented interface
 * @export
 * @class ApiCRUDToCreateAlertCriteriaApi
 * @extends {BaseAPI}
 */
export class ApiCRUDToCreateAlertCriteriaApi extends BaseAPI {
    /**
     * 
     * @param {AlertCriteria} alertCriteria 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiCRUDToCreateAlertCriteriaApi
     */
    public createAlertC(alertCriteria: AlertCriteria, options?: AxiosRequestConfig) {
        return ApiCRUDToCreateAlertCriteriaApiFp(this.configuration).createAlertC(alertCriteria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} alertId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiCRUDToCreateAlertCriteriaApi
     */
    public deleteAlertC(alertId: string, options?: AxiosRequestConfig) {
        return ApiCRUDToCreateAlertCriteriaApiFp(this.configuration).deleteAlertC(alertId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} alertId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiCRUDToCreateAlertCriteriaApi
     */
    public getAlertC(alertId: string, options?: AxiosRequestConfig) {
        return ApiCRUDToCreateAlertCriteriaApiFp(this.configuration).getAlertC(alertId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiCRUDToCreateAlertCriteriaApi
     */
    public getAllAlertC(options?: AxiosRequestConfig) {
        return ApiCRUDToCreateAlertCriteriaApiFp(this.configuration).getAllAlertC(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} alertId 
     * @param {AlertCriteria} alertCriteria 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiCRUDToCreateAlertCriteriaApi
     */
    public updateAlertC(alertId: string, alertCriteria: AlertCriteria, options?: AxiosRequestConfig) {
        return ApiCRUDToCreateAlertCriteriaApiFp(this.configuration).updateAlertC(alertId, alertCriteria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToCheckHealthStatusOfAppApi - axios parameter creator
 * @export
 */
export const ApiToCheckHealthStatusOfAppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        all: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health-checker/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'IMAGESERVICE' | 'MONGODB'} service 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus: async (service: 'IMAGESERVICE' | 'MONGODB', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'service' is not null or undefined
            assertParamExists('getServiceStatus', 'service', service)
            const localVarPath = `/api/health-checker/{service}`
                .replace(`{${"service"}}`, encodeURIComponent(String(service)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health-checker`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToCheckHealthStatusOfAppApi - functional programming interface
 * @export
 */
export const ApiToCheckHealthStatusOfAppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToCheckHealthStatusOfAppApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async all(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.all(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'IMAGESERVICE' | 'MONGODB'} service 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceStatus(service: 'IMAGESERVICE' | 'MONGODB', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceStatus(service, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ping(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ping(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToCheckHealthStatusOfAppApi - factory interface
 * @export
 */
export const ApiToCheckHealthStatusOfAppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToCheckHealthStatusOfAppApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        all(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.all(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'IMAGESERVICE' | 'MONGODB'} service 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus(service: 'IMAGESERVICE' | 'MONGODB', options?: any): AxiosPromise<string> {
            return localVarFp.getServiceStatus(service, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options?: any): AxiosPromise<string> {
            return localVarFp.ping(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToCheckHealthStatusOfAppApi - object-oriented interface
 * @export
 * @class ApiToCheckHealthStatusOfAppApi
 * @extends {BaseAPI}
 */
export class ApiToCheckHealthStatusOfAppApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToCheckHealthStatusOfAppApi
     */
    public all(options?: AxiosRequestConfig) {
        return ApiToCheckHealthStatusOfAppApiFp(this.configuration).all(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'IMAGESERVICE' | 'MONGODB'} service 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToCheckHealthStatusOfAppApi
     */
    public getServiceStatus(service: 'IMAGESERVICE' | 'MONGODB', options?: AxiosRequestConfig) {
        return ApiToCheckHealthStatusOfAppApiFp(this.configuration).getServiceStatus(service, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToCheckHealthStatusOfAppApi
     */
    public ping(options?: AxiosRequestConfig) {
        return ApiToCheckHealthStatusOfAppApiFp(this.configuration).ping(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToGetAuditApi - axios parameter creator
 * @export
 */
export const ApiToGetAuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AuditCreationReq} auditCreationReq 
         * @param {'Bh+kvRBL/+WABVtsy76giOwGHtLtMGEPgu9lfpvq'} [kEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apaAudit: async (auditCreationReq: AuditCreationReq, kEY?: 'Bh+kvRBL/+WABVtsy76giOwGHtLtMGEPgu9lfpvq', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditCreationReq' is not null or undefined
            assertParamExists('apaAudit', 'auditCreationReq', auditCreationReq)
            const localVarPath = `/api/audit/apa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kEY !== undefined && kEY !== null) {
                localVarHeaderParameter['KEY'] = String(kEY);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditCreationReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuditCreationReq} auditCreationReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAudit: async (auditCreationReq: AuditCreationReq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditCreationReq' is not null or undefined
            assertParamExists('createAudit', 'auditCreationReq', auditCreationReq)
            const localVarPath = `/api/audit/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditCreationReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {AuditSearchFilter} auditSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAudits: async (type: string, auditSearchFilter: AuditSearchFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('exportAudits', 'type', type)
            // verify required parameter 'auditSearchFilter' is not null or undefined
            assertParamExists('exportAudits', 'auditSearchFilter', auditSearchFilter)
            const localVarPath = `/api/audit/export/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditSearchFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GlobalStatisticFilter} [globalStatisticFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalStatistic: async (globalStatisticFilter?: GlobalStatisticFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit/globalStatistic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(globalStatisticFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuditSearchFilter} auditSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAudits: async (auditSearchFilter: AuditSearchFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditSearchFilter' is not null or undefined
            assertParamExists('searchAudits', 'auditSearchFilter', auditSearchFilter)
            const localVarPath = `/api/audit/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditSearchFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToGetAuditApi - functional programming interface
 * @export
 */
export const ApiToGetAuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToGetAuditApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AuditCreationReq} auditCreationReq 
         * @param {'Bh+kvRBL/+WABVtsy76giOwGHtLtMGEPgu9lfpvq'} [kEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apaAudit(auditCreationReq: AuditCreationReq, kEY?: 'Bh+kvRBL/+WABVtsy76giOwGHtLtMGEPgu9lfpvq', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apaAudit(auditCreationReq, kEY, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AuditCreationReq} auditCreationReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAudit(auditCreationReq: AuditCreationReq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAudit(auditCreationReq, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} type 
         * @param {AuditSearchFilter} auditSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAudits(type: string, auditSearchFilter: AuditSearchFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAuditActionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAudits(type, auditSearchFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GlobalStatisticFilter} [globalStatisticFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGlobalStatistic(globalStatisticFilter?: GlobalStatisticFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGlobalStatistic(globalStatisticFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AuditSearchFilter} auditSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAudits(auditSearchFilter: AuditSearchFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAuditActionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAudits(auditSearchFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToGetAuditApi - factory interface
 * @export
 */
export const ApiToGetAuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToGetAuditApiFp(configuration)
    return {
        /**
         * 
         * @param {AuditCreationReq} auditCreationReq 
         * @param {'Bh+kvRBL/+WABVtsy76giOwGHtLtMGEPgu9lfpvq'} [kEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apaAudit(auditCreationReq: AuditCreationReq, kEY?: 'Bh+kvRBL/+WABVtsy76giOwGHtLtMGEPgu9lfpvq', options?: any): AxiosPromise<object> {
            return localVarFp.apaAudit(auditCreationReq, kEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditCreationReq} auditCreationReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAudit(auditCreationReq: AuditCreationReq, options?: any): AxiosPromise<object> {
            return localVarFp.createAudit(auditCreationReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type 
         * @param {AuditSearchFilter} auditSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAudits(type: string, auditSearchFilter: AuditSearchFilter, options?: any): AxiosPromise<PageAuditActionDTO> {
            return localVarFp.exportAudits(type, auditSearchFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GlobalStatisticFilter} [globalStatisticFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalStatistic(globalStatisticFilter?: GlobalStatisticFilter, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getGlobalStatistic(globalStatisticFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditSearchFilter} auditSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAudits(auditSearchFilter: AuditSearchFilter, options?: any): AxiosPromise<PageAuditActionDTO> {
            return localVarFp.searchAudits(auditSearchFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToGetAuditApi - object-oriented interface
 * @export
 * @class ApiToGetAuditApi
 * @extends {BaseAPI}
 */
export class ApiToGetAuditApi extends BaseAPI {
    /**
     * 
     * @param {AuditCreationReq} auditCreationReq 
     * @param {'Bh+kvRBL/+WABVtsy76giOwGHtLtMGEPgu9lfpvq'} [kEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetAuditApi
     */
    public apaAudit(auditCreationReq: AuditCreationReq, kEY?: 'Bh+kvRBL/+WABVtsy76giOwGHtLtMGEPgu9lfpvq', options?: AxiosRequestConfig) {
        return ApiToGetAuditApiFp(this.configuration).apaAudit(auditCreationReq, kEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditCreationReq} auditCreationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetAuditApi
     */
    public createAudit(auditCreationReq: AuditCreationReq, options?: AxiosRequestConfig) {
        return ApiToGetAuditApiFp(this.configuration).createAudit(auditCreationReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type 
     * @param {AuditSearchFilter} auditSearchFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetAuditApi
     */
    public exportAudits(type: string, auditSearchFilter: AuditSearchFilter, options?: AxiosRequestConfig) {
        return ApiToGetAuditApiFp(this.configuration).exportAudits(type, auditSearchFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GlobalStatisticFilter} [globalStatisticFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetAuditApi
     */
    public getGlobalStatistic(globalStatisticFilter?: GlobalStatisticFilter, options?: AxiosRequestConfig) {
        return ApiToGetAuditApiFp(this.configuration).getGlobalStatistic(globalStatisticFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditSearchFilter} auditSearchFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetAuditApi
     */
    public searchAudits(auditSearchFilter: AuditSearchFilter, options?: AxiosRequestConfig) {
        return ApiToGetAuditApiFp(this.configuration).searchAudits(auditSearchFilter, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToGetImageFileApi - axios parameter creator
 * @export
 */
export const ApiToGetImageFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} imageBase64 
         * @param {'jpg' | 'png' | 'webp'} [outputFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertWebpToPNG: async (imageBase64: string, outputFormat?: 'jpg' | 'png' | 'webp', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageBase64' is not null or undefined
            assertParamExists('convertWebpToPNG', 'imageBase64', imageBase64)
            const localVarPath = `/api/image/convert/webp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (imageBase64 !== undefined) {
                localVarQueryParameter['imageBase64'] = imageBase64;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['outputFormat'] = outputFormat;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImage', 'id', id)
            const localVarPath = `/api/image/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageProxy: async (image: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('getImageProxy', 'image', image)
            const localVarPath = `/api/image/proxy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (image !== undefined) {
                localVarQueryParameter['image'] = image;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToGetImageFileApi - functional programming interface
 * @export
 */
export const ApiToGetImageFileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToGetImageFileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} imageBase64 
         * @param {'jpg' | 'png' | 'webp'} [outputFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertWebpToPNG(imageBase64: string, outputFormat?: 'jpg' | 'png' | 'webp', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertWebpToPNG(imageBase64, outputFormat, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageProxy(image: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageProxy(image, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToGetImageFileApi - factory interface
 * @export
 */
export const ApiToGetImageFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToGetImageFileApiFp(configuration)
    return {
        /**
         * 
         * @param {string} imageBase64 
         * @param {'jpg' | 'png' | 'webp'} [outputFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertWebpToPNG(imageBase64: string, outputFormat?: 'jpg' | 'png' | 'webp', options?: any): AxiosPromise<string> {
            return localVarFp.convertWebpToPNG(imageBase64, outputFormat, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageProxy(image: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getImageProxy(image, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToGetImageFileApi - object-oriented interface
 * @export
 * @class ApiToGetImageFileApi
 * @extends {BaseAPI}
 */
export class ApiToGetImageFileApi extends BaseAPI {
    /**
     * 
     * @param {string} imageBase64 
     * @param {'jpg' | 'png' | 'webp'} [outputFormat] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetImageFileApi
     */
    public convertWebpToPNG(imageBase64: string, outputFormat?: 'jpg' | 'png' | 'webp', options?: AxiosRequestConfig) {
        return ApiToGetImageFileApiFp(this.configuration).convertWebpToPNG(imageBase64, outputFormat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetImageFileApi
     */
    public getImage(id: string, options?: AxiosRequestConfig) {
        return ApiToGetImageFileApiFp(this.configuration).getImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} image 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetImageFileApi
     */
    public getImageProxy(image: string, options?: AxiosRequestConfig) {
        return ApiToGetImageFileApiFp(this.configuration).getImageProxy(image, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToViewAndSearchInAlertsApi - axios parameter creator
 * @export
 */
export const ApiToViewAndSearchInAlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Alert} alert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAlert: async (alert: Alert, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alert' is not null or undefined
            assertParamExists('addAlert', 'alert', alert)
            const localVarPath = `/api/alert/addAlert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alert, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AlertFilter} alertFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertSearch: async (alertFilter: AlertFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertFilter' is not null or undefined
            assertParamExists('alertSearch', 'alertFilter', alertFilter)
            const localVarPath = `/api/alert/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PageFilter} pageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts: async (pageFilter: PageFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageFilter' is not null or undefined
            assertParamExists('getAlerts', 'pageFilter', pageFilter)
            const localVarPath = `/api/alert/view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToViewAndSearchInAlertsApi - functional programming interface
 * @export
 */
export const ApiToViewAndSearchInAlertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToViewAndSearchInAlertsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Alert} alert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAlert(alert: Alert, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAlert(alert, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AlertFilter} alertFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async alertSearch(alertFilter: AlertFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAlert>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.alertSearch(alertFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PageFilter} pageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlerts(pageFilter: PageFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAlert>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlerts(pageFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToViewAndSearchInAlertsApi - factory interface
 * @export
 */
export const ApiToViewAndSearchInAlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToViewAndSearchInAlertsApiFp(configuration)
    return {
        /**
         * 
         * @param {Alert} alert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAlert(alert: Alert, options?: any): AxiosPromise<void> {
            return localVarFp.addAlert(alert, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AlertFilter} alertFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertSearch(alertFilter: AlertFilter, options?: any): AxiosPromise<PageAlert> {
            return localVarFp.alertSearch(alertFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PageFilter} pageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(pageFilter: PageFilter, options?: any): AxiosPromise<PageAlert> {
            return localVarFp.getAlerts(pageFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToViewAndSearchInAlertsApi - object-oriented interface
 * @export
 * @class ApiToViewAndSearchInAlertsApi
 * @extends {BaseAPI}
 */
export class ApiToViewAndSearchInAlertsApi extends BaseAPI {
    /**
     * 
     * @param {Alert} alert 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToViewAndSearchInAlertsApi
     */
    public addAlert(alert: Alert, options?: AxiosRequestConfig) {
        return ApiToViewAndSearchInAlertsApiFp(this.configuration).addAlert(alert, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AlertFilter} alertFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToViewAndSearchInAlertsApi
     */
    public alertSearch(alertFilter: AlertFilter, options?: AxiosRequestConfig) {
        return ApiToViewAndSearchInAlertsApiFp(this.configuration).alertSearch(alertFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PageFilter} pageFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToViewAndSearchInAlertsApi
     */
    public getAlerts(pageFilter: PageFilter, options?: AxiosRequestConfig) {
        return ApiToViewAndSearchInAlertsApiFp(this.configuration).getAlerts(pageFilter, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithADIDRequestsApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithADIDRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteADIDProfile: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteADIDProfile', 'id', id)
            const localVarPath = `/api/adid/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteADIDRequest: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteADIDRequest', 'id', id)
            const localVarPath = `/api/adid/request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getADIDProfile: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getADIDProfile', 'id', id)
            const localVarPath = `/api/adid/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithADIDRequestsApi - functional programming interface
 * @export
 */
export const ApiToWorkWithADIDRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithADIDRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteADIDProfile(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteADIDProfile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteADIDRequest(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteADIDRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getADIDProfile(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ADIDProfileEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getADIDProfile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithADIDRequestsApi - factory interface
 * @export
 */
export const ApiToWorkWithADIDRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithADIDRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteADIDProfile(id: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteADIDProfile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteADIDRequest(id: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteADIDRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getADIDProfile(id: number, options?: any): AxiosPromise<ADIDProfileEntityDto> {
            return localVarFp.getADIDProfile(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithADIDRequestsApi - object-oriented interface
 * @export
 * @class ApiToWorkWithADIDRequestsApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithADIDRequestsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithADIDRequestsApi
     */
    public deleteADIDProfile(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithADIDRequestsApiFp(this.configuration).deleteADIDProfile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithADIDRequestsApi
     */
    public deleteADIDRequest(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithADIDRequestsApiFp(this.configuration).deleteADIDRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithADIDRequestsApi
     */
    public getADIDProfile(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithADIDRequestsApiFp(this.configuration).getADIDProfile(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithAmmApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithAmmApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} avatarId 
         * @param {AvatarAuditDTO} avatarAuditDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAuditLogs: async (username: string, avatarId: string, avatarAuditDTO: AvatarAuditDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('addAuditLogs', 'username', username)
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('addAuditLogs', 'avatarId', avatarId)
            // verify required parameter 'avatarAuditDTO' is not null or undefined
            assertParamExists('addAuditLogs', 'avatarAuditDTO', avatarAuditDTO)
            const localVarPath = `/api/amm/avatar-audit/{username}/{avatarId}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)))
                .replace(`{${"avatarId"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarAuditDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {APAProfileDTO} aPAProfileDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSyntheticTargetForAPA: async (username: string, aPAProfileDTO: APAProfileDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('createSyntheticTargetForAPA', 'username', username)
            // verify required parameter 'aPAProfileDTO' is not null or undefined
            assertParamExists('createSyntheticTargetForAPA', 'aPAProfileDTO', aPAProfileDTO)
            const localVarPath = `/api/amm/create/syntheticTarget/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPAProfileDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {APAWebintDTO} aPAWebintDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebintTargetForAPA: async (username: string, aPAWebintDTO: APAWebintDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('createWebintTargetForAPA', 'username', username)
            // verify required parameter 'aPAWebintDTO' is not null or undefined
            assertParamExists('createWebintTargetForAPA', 'aPAWebintDTO', aPAWebintDTO)
            const localVarPath = `/api/amm/create/webintentity/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPAWebintDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} socialNetwork 
         * @param {string} module 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarsPerSocialNetwork: async (socialNetwork: string, module: string, username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialNetwork' is not null or undefined
            assertParamExists('getAvatarsPerSocialNetwork', 'socialNetwork', socialNetwork)
            // verify required parameter 'module' is not null or undefined
            assertParamExists('getAvatarsPerSocialNetwork', 'module', module)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getAvatarsPerSocialNetwork', 'username', username)
            const localVarPath = `/api/amm/getAvatarList/{socialNetwork}/{module}/{username}`
                .replace(`{${"socialNetwork"}}`, encodeURIComponent(String(socialNetwork)))
                .replace(`{${"module"}}`, encodeURIComponent(String(module)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithAmmApi - functional programming interface
 * @export
 */
export const ApiToWorkWithAmmApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithAmmApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} avatarId 
         * @param {AvatarAuditDTO} avatarAuditDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAuditLogs(username: string, avatarId: string, avatarAuditDTO: AvatarAuditDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAuditLogs(username, avatarId, avatarAuditDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {APAProfileDTO} aPAProfileDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSyntheticTargetForAPA(username: string, aPAProfileDTO: APAProfileDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSyntheticTargetForAPA(username, aPAProfileDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {APAWebintDTO} aPAWebintDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWebintTargetForAPA(username: string, aPAWebintDTO: APAWebintDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebintDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWebintTargetForAPA(username, aPAWebintDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} socialNetwork 
         * @param {string} module 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvatarsPerSocialNetwork(socialNetwork: string, module: string, username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvatarsPerSocialNetwork(socialNetwork, module, username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithAmmApi - factory interface
 * @export
 */
export const ApiToWorkWithAmmApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithAmmApiFp(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} avatarId 
         * @param {AvatarAuditDTO} avatarAuditDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAuditLogs(username: string, avatarId: string, avatarAuditDTO: AvatarAuditDTO, options?: any): AxiosPromise<object> {
            return localVarFp.addAuditLogs(username, avatarId, avatarAuditDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {APAProfileDTO} aPAProfileDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSyntheticTargetForAPA(username: string, aPAProfileDTO: APAProfileDTO, options?: any): AxiosPromise<Array<ProfileInfo>> {
            return localVarFp.createSyntheticTargetForAPA(username, aPAProfileDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {APAWebintDTO} aPAWebintDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebintTargetForAPA(username: string, aPAWebintDTO: APAWebintDTO, options?: any): AxiosPromise<WebintDTO> {
            return localVarFp.createWebintTargetForAPA(username, aPAWebintDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} socialNetwork 
         * @param {string} module 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarsPerSocialNetwork(socialNetwork: string, module: string, username: string, options?: any): AxiosPromise<Array<AvatarInfo>> {
            return localVarFp.getAvatarsPerSocialNetwork(socialNetwork, module, username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithAmmApi - object-oriented interface
 * @export
 * @class ApiToWorkWithAmmApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithAmmApi extends BaseAPI {
    /**
     * 
     * @param {string} username 
     * @param {string} avatarId 
     * @param {AvatarAuditDTO} avatarAuditDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAmmApi
     */
    public addAuditLogs(username: string, avatarId: string, avatarAuditDTO: AvatarAuditDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAmmApiFp(this.configuration).addAuditLogs(username, avatarId, avatarAuditDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {APAProfileDTO} aPAProfileDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAmmApi
     */
    public createSyntheticTargetForAPA(username: string, aPAProfileDTO: APAProfileDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAmmApiFp(this.configuration).createSyntheticTargetForAPA(username, aPAProfileDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {APAWebintDTO} aPAWebintDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAmmApi
     */
    public createWebintTargetForAPA(username: string, aPAWebintDTO: APAWebintDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAmmApiFp(this.configuration).createWebintTargetForAPA(username, aPAWebintDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} socialNetwork 
     * @param {string} module 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAmmApi
     */
    public getAvatarsPerSocialNetwork(socialNetwork: string, module: string, username: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAmmApiFp(this.configuration).getAvatarsPerSocialNetwork(socialNetwork, module, username, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithAnalyticsApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithAnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AnalyticItemsRequest} analyticItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connection: async (analyticItemsRequest: AnalyticItemsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticItemsRequest' is not null or undefined
            assertParamExists('connection', 'analyticItemsRequest', analyticItemsRequest)
            const localVarPath = `/api/analytics/connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analyticItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithAnalyticsApi - functional programming interface
 * @export
 */
export const ApiToWorkWithAnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithAnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AnalyticItemsRequest} analyticItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connection(analyticItemsRequest: AnalyticItemsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connection(analyticItemsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithAnalyticsApi - factory interface
 * @export
 */
export const ApiToWorkWithAnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithAnalyticsApiFp(configuration)
    return {
        /**
         * 
         * @param {AnalyticItemsRequest} analyticItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connection(analyticItemsRequest: AnalyticItemsRequest, options?: any): AxiosPromise<AnalyticItemsResponse> {
            return localVarFp.connection(analyticItemsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithAnalyticsApi - object-oriented interface
 * @export
 * @class ApiToWorkWithAnalyticsApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithAnalyticsApi extends BaseAPI {
    /**
     * 
     * @param {AnalyticItemsRequest} analyticItemsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAnalyticsApi
     */
    public connection(analyticItemsRequest: AnalyticItemsRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithAnalyticsApiFp(this.configuration).connection(analyticItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithAvatarActivityApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithAvatarActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} avatarId 
         * @param {Array<AvatarActivityDTO>} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivities: async (avatarId: string, avatarActivityDTO: Array<AvatarActivityDTO>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('createActivities', 'avatarId', avatarId)
            // verify required parameter 'avatarActivityDTO' is not null or undefined
            assertParamExists('createActivities', 'avatarActivityDTO', avatarActivityDTO)
            const localVarPath = `/api/avatar-activity/avatar/{avatarId}/bulk`
                .replace(`{${"avatarId"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarActivityDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity: async (avatarId: string, avatarActivityDTO: AvatarActivityDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('createActivity', 'avatarId', avatarId)
            // verify required parameter 'avatarActivityDTO' is not null or undefined
            assertParamExists('createActivity', 'avatarActivityDTO', avatarActivityDTO)
            const localVarPath = `/api/avatar-activity/avatar/{avatarId}`
                .replace(`{${"avatarId"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarActivityDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity: async (avatarActivityDTO: AvatarActivityDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarActivityDTO' is not null or undefined
            assertParamExists('deleteActivity', 'avatarActivityDTO', avatarActivityDTO)
            const localVarPath = `/api/avatar-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarActivityDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {PostGenerateRequest} postGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePosts: async (avatarId: string, postGenerateRequest: PostGenerateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('generatePosts', 'avatarId', avatarId)
            // verify required parameter 'postGenerateRequest' is not null or undefined
            assertParamExists('generatePosts', 'postGenerateRequest', postGenerateRequest)
            const localVarPath = `/api/avatar-activity/avatar/{avatarId}/post-generate`
                .replace(`{${"avatarId"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postGenerateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {PostPromptGenerateRequest} postPromptGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePromptPosts: async (avatarId: string, postPromptGenerateRequest: PostPromptGenerateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('generatePromptPosts', 'avatarId', avatarId)
            // verify required parameter 'postPromptGenerateRequest' is not null or undefined
            assertParamExists('generatePromptPosts', 'postPromptGenerateRequest', postPromptGenerateRequest)
            const localVarPath = `/api/avatar-activity/avatar/{avatarId}/post-prompt-generate`
                .replace(`{${"avatarId"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPromptGenerateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'AUTOLOGIN' | 'POST' | 'LIKE_POST' | 'COMMENT_POST' | 'URL' | 'GROUP_POST' | 'USER_POST' | 'GET_POST' | 'GET_COMMENT' | 'NULL'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleById: async (id: string, type: 'AUTOLOGIN' | 'POST' | 'LIKE_POST' | 'COMMENT_POST' | 'URL' | 'GROUP_POST' | 'USER_POST' | 'GET_POST' | 'GET_COMMENT' | 'NULL', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getScheduleById', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getScheduleById', 'type', type)
            const localVarPath = `/api/avatar-activity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} startPeriod 
         * @param {number} endPeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleByMetaAvatarId: async (id: string, startPeriod: number, endPeriod: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getScheduleByMetaAvatarId', 'id', id)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('getScheduleByMetaAvatarId', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('getScheduleByMetaAvatarId', 'endPeriod', endPeriod)
            const localVarPath = `/api/avatar-activity/meta-avatar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity: async (id: string, avatarActivityDTO: AvatarActivityDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateActivity', 'id', id)
            // verify required parameter 'avatarActivityDTO' is not null or undefined
            assertParamExists('updateActivity', 'avatarActivityDTO', avatarActivityDTO)
            const localVarPath = `/api/avatar-activity/{id}/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarActivityDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithAvatarActivityApi - functional programming interface
 * @export
 */
export const ApiToWorkWithAvatarActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithAvatarActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} avatarId 
         * @param {Array<AvatarActivityDTO>} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivities(avatarId: string, avatarActivityDTO: Array<AvatarActivityDTO>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarActivityDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivities(avatarId, avatarActivityDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivity(avatarId: string, avatarActivityDTO: AvatarActivityDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarActivityDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivity(avatarId, avatarActivityDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivity(avatarActivityDTO: AvatarActivityDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarActivityDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivity(avatarActivityDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {PostGenerateRequest} postGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePosts(avatarId: string, postGenerateRequest: PostGenerateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePosts(avatarId, postGenerateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {PostPromptGenerateRequest} postPromptGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePromptPosts(avatarId: string, postPromptGenerateRequest: PostPromptGenerateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePromptPosts(avatarId, postPromptGenerateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {'AUTOLOGIN' | 'POST' | 'LIKE_POST' | 'COMMENT_POST' | 'URL' | 'GROUP_POST' | 'USER_POST' | 'GET_POST' | 'GET_COMMENT' | 'NULL'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleById(id: string, type: 'AUTOLOGIN' | 'POST' | 'LIKE_POST' | 'COMMENT_POST' | 'URL' | 'GROUP_POST' | 'USER_POST' | 'GET_POST' | 'GET_COMMENT' | 'NULL', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleById(id, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} startPeriod 
         * @param {number} endPeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleByMetaAvatarId(id: string, startPeriod: number, endPeriod: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduleInfoDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleByMetaAvatarId(id, startPeriod, endPeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActivity(id: string, avatarActivityDTO: AvatarActivityDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActivity(id, avatarActivityDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithAvatarActivityApi - factory interface
 * @export
 */
export const ApiToWorkWithAvatarActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithAvatarActivityApiFp(configuration)
    return {
        /**
         * 
         * @param {string} avatarId 
         * @param {Array<AvatarActivityDTO>} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivities(avatarId: string, avatarActivityDTO: Array<AvatarActivityDTO>, options?: any): AxiosPromise<Array<AvatarActivityDTO>> {
            return localVarFp.createActivities(avatarId, avatarActivityDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity(avatarId: string, avatarActivityDTO: AvatarActivityDTO, options?: any): AxiosPromise<AvatarActivityDTO> {
            return localVarFp.createActivity(avatarId, avatarActivityDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity(avatarActivityDTO: AvatarActivityDTO, options?: any): AxiosPromise<AvatarActivityDeleteResponse> {
            return localVarFp.deleteActivity(avatarActivityDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {PostGenerateRequest} postGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePosts(avatarId: string, postGenerateRequest: PostGenerateRequest, options?: any): AxiosPromise<object> {
            return localVarFp.generatePosts(avatarId, postGenerateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {PostPromptGenerateRequest} postPromptGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePromptPosts(avatarId: string, postPromptGenerateRequest: PostPromptGenerateRequest, options?: any): AxiosPromise<object> {
            return localVarFp.generatePromptPosts(avatarId, postPromptGenerateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {'AUTOLOGIN' | 'POST' | 'LIKE_POST' | 'COMMENT_POST' | 'URL' | 'GROUP_POST' | 'USER_POST' | 'GET_POST' | 'GET_COMMENT' | 'NULL'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleById(id: string, type: 'AUTOLOGIN' | 'POST' | 'LIKE_POST' | 'COMMENT_POST' | 'URL' | 'GROUP_POST' | 'USER_POST' | 'GET_POST' | 'GET_COMMENT' | 'NULL', options?: any): AxiosPromise<ScheduleInfoDTO> {
            return localVarFp.getScheduleById(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} startPeriod 
         * @param {number} endPeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleByMetaAvatarId(id: string, startPeriod: number, endPeriod: number, options?: any): AxiosPromise<Array<ScheduleInfoDTO>> {
            return localVarFp.getScheduleByMetaAvatarId(id, startPeriod, endPeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarActivityDTO} avatarActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity(id: string, avatarActivityDTO: AvatarActivityDTO, options?: any): AxiosPromise<ScheduleInfoDTO> {
            return localVarFp.updateActivity(id, avatarActivityDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithAvatarActivityApi - object-oriented interface
 * @export
 * @class ApiToWorkWithAvatarActivityApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithAvatarActivityApi extends BaseAPI {
    /**
     * 
     * @param {string} avatarId 
     * @param {Array<AvatarActivityDTO>} avatarActivityDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarActivityApi
     */
    public createActivities(avatarId: string, avatarActivityDTO: Array<AvatarActivityDTO>, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarActivityApiFp(this.configuration).createActivities(avatarId, avatarActivityDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} avatarId 
     * @param {AvatarActivityDTO} avatarActivityDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarActivityApi
     */
    public createActivity(avatarId: string, avatarActivityDTO: AvatarActivityDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarActivityApiFp(this.configuration).createActivity(avatarId, avatarActivityDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AvatarActivityDTO} avatarActivityDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarActivityApi
     */
    public deleteActivity(avatarActivityDTO: AvatarActivityDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarActivityApiFp(this.configuration).deleteActivity(avatarActivityDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} avatarId 
     * @param {PostGenerateRequest} postGenerateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarActivityApi
     */
    public generatePosts(avatarId: string, postGenerateRequest: PostGenerateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarActivityApiFp(this.configuration).generatePosts(avatarId, postGenerateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} avatarId 
     * @param {PostPromptGenerateRequest} postPromptGenerateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarActivityApi
     */
    public generatePromptPosts(avatarId: string, postPromptGenerateRequest: PostPromptGenerateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarActivityApiFp(this.configuration).generatePromptPosts(avatarId, postPromptGenerateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {'AUTOLOGIN' | 'POST' | 'LIKE_POST' | 'COMMENT_POST' | 'URL' | 'GROUP_POST' | 'USER_POST' | 'GET_POST' | 'GET_COMMENT' | 'NULL'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarActivityApi
     */
    public getScheduleById(id: string, type: 'AUTOLOGIN' | 'POST' | 'LIKE_POST' | 'COMMENT_POST' | 'URL' | 'GROUP_POST' | 'USER_POST' | 'GET_POST' | 'GET_COMMENT' | 'NULL', options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarActivityApiFp(this.configuration).getScheduleById(id, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} startPeriod 
     * @param {number} endPeriod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarActivityApi
     */
    public getScheduleByMetaAvatarId(id: string, startPeriod: number, endPeriod: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarActivityApiFp(this.configuration).getScheduleByMetaAvatarId(id, startPeriod, endPeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {AvatarActivityDTO} avatarActivityDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarActivityApi
     */
    public updateActivity(id: string, avatarActivityDTO: AvatarActivityDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarActivityApiFp(this.configuration).updateActivity(id, avatarActivityDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithAvatarCreatingApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithAvatarCreatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} avatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquireAvatar: async (avatarId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('acquireAvatar', 'avatarId', avatarId)
            const localVarPath = `/rest-api/avatar-creation/{avatarId}/acquire`
                .replace(`{${"avatarId"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAvatar: async (avatarId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('activateAvatar', 'avatarId', avatarId)
            const localVarPath = `/rest-api/avatar-creation/{avatarId}/activate`
                .replace(`{${"avatarId"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {MessageDto} messageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateAvatar: async (avatarId: string, messageDto: MessageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('deactivateAvatar', 'avatarId', avatarId)
            // verify required parameter 'messageDto' is not null or undefined
            assertParamExists('deactivateAvatar', 'messageDto', messageDto)
            const localVarPath = `/rest-api/avatar-creation/{avatarId}/block`
                .replace(`{${"avatarId"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest-api/avatar-creation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSms: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest-api/avatar-creation/sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithAvatarCreatingApi - functional programming interface
 * @export
 */
export const ApiToWorkWithAvatarCreatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithAvatarCreatingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} avatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acquireAvatar(avatarId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acquireAvatar(avatarId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateAvatar(avatarId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateAvatar(avatarId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {MessageDto} messageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateAvatar(avatarId: string, messageDto: MessageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateAvatar(avatarId, messageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarCreationMessageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSms(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SmsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSms(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithAvatarCreatingApi - factory interface
 * @export
 */
export const ApiToWorkWithAvatarCreatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithAvatarCreatingApiFp(configuration)
    return {
        /**
         * 
         * @param {string} avatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquireAvatar(avatarId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.acquireAvatar(avatarId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAvatar(avatarId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.activateAvatar(avatarId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} avatarId 
         * @param {MessageDto} messageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateAvatar(avatarId: string, messageDto: MessageDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.deactivateAvatar(avatarId, messageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<Array<AvatarCreationMessageDTO>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSms(options?: any): AxiosPromise<Array<SmsDTO>> {
            return localVarFp.getSms(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithAvatarCreatingApi - object-oriented interface
 * @export
 * @class ApiToWorkWithAvatarCreatingApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithAvatarCreatingApi extends BaseAPI {
    /**
     * 
     * @param {string} avatarId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarCreatingApi
     */
    public acquireAvatar(avatarId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarCreatingApiFp(this.configuration).acquireAvatar(avatarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} avatarId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarCreatingApi
     */
    public activateAvatar(avatarId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarCreatingApiFp(this.configuration).activateAvatar(avatarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} avatarId 
     * @param {MessageDto} messageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarCreatingApi
     */
    public deactivateAvatar(avatarId: string, messageDto: MessageDto, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarCreatingApiFp(this.configuration).deactivateAvatar(avatarId, messageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarCreatingApi
     */
    public getAll(options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarCreatingApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarCreatingApi
     */
    public getSms(options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarCreatingApiFp(this.configuration).getSms(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithAvatarsApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithAvatarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {AvatarDto} avatarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAvatar: async (id: string, avatarDto: AvatarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addAvatar', 'id', id)
            // verify required parameter 'avatarDto' is not null or undefined
            assertParamExists('addAvatar', 'avatarDto', avatarDto)
            const localVarPath = `/api/meta-avatar/{id}/avatar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSynopsis: async (id: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addSynopsis', 'id', id)
            const localVarPath = `/api/meta-avatar/{id}/synopsis`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSNStatuses: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkSNStatuses', 'id', id)
            const localVarPath = `/api/meta-avatar/{id}/sn-check`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MetaAvatarDTO} metaAvatarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (metaAvatarDTO: MetaAvatarDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metaAvatarDTO' is not null or undefined
            assertParamExists('create', 'metaAvatarDTO', metaAvatarDTO)
            const localVarPath = `/api/meta-avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaAvatarDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvatarById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAvatarById', 'id', id)
            const localVarPath = `/api/avatars/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteById', 'id', id)
            const localVarPath = `/api/meta-avatar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCheckAvatarMaturity: async (id: string, flag: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableCheckAvatarMaturity', 'id', id)
            // verify required parameter 'flag' is not null or undefined
            assertParamExists('enableCheckAvatarMaturity', 'flag', flag)
            const localVarPath = `/api/avatars/{id}/maturity/{flag}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"flag"}}`, encodeURIComponent(String(flag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAvatars: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/avatars/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DateFilter} [dateFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAvatarLogs: async (dateFilter?: DateFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/avatar-audit/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dateFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AvatarRequest} avatarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAvatarBySNAndLock: async (avatarRequest: AvatarRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarRequest' is not null or undefined
            assertParamExists('getAvailableAvatarBySNAndLock', 'avatarRequest', avatarRequest)
            const localVarPath = `/api/avatars/available-avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [socialNetwork] 
         * @param {string} [module] 
         * @param {string} [taskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAvatars: async (socialNetwork?: string, module?: string, taskId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/avatars/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (socialNetwork !== undefined) {
                localVarQueryParameter['socialNetwork'] = socialNetwork;
            }

            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }

            if (taskId !== undefined) {
                localVarQueryParameter['taskId'] = taskId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuditFilter} auditFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarLogs: async (auditFilter: AuditFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditFilter' is not null or undefined
            assertParamExists('getAvatarLogs', 'auditFilter', auditFilter)
            const localVarPath = `/api/avatar-audit/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} metaAvatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarLogsByLastDay: async (metaAvatarId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metaAvatarId' is not null or undefined
            assertParamExists('getAvatarLogsByLastDay', 'metaAvatarId', metaAvatarId)
            const localVarPath = `/api/avatar-audit/{metaAvatarId}/lastDay`
                .replace(`{${"metaAvatarId"}}`, encodeURIComponent(String(metaAvatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuditFilter} auditFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarLogsWithoutPagination: async (auditFilter: AuditFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditFilter' is not null or undefined
            assertParamExists('getAvatarLogsWithoutPagination', 'auditFilter', auditFilter)
            const localVarPath = `/api/avatar-audit/searchByPeriod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarStatistic: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAvatarStatistic', 'id', id)
            const localVarPath = `/api/avatars/{id}/statistic`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarsUsage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAvatarsUsage', 'id', id)
            const localVarPath = `/api/meta-avatar/{id}/avatarsUsage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedAvatars: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBlockedAvatars', 'id', id)
            const localVarPath = `/api/meta-avatar/{id}/blocked`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetaAvatarById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMetaAvatarById', 'id', id)
            const localVarPath = `/api/meta-avatar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSNStatuses: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSNStatuses', 'id', id)
            const localVarPath = `/api/meta-avatar/{id}/sn-check`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAvatarGetAlerts: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('metaAvatarGetAlerts', 'id', id)
            const localVarPath = `/api/meta-avatar/{id}/alerts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseAvatars: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/avatars/release-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AvatarReturnRequest} avatarReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnLockedAvatar: async (avatarReturnRequest: AvatarReturnRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarReturnRequest' is not null or undefined
            assertParamExists('returnLockedAvatar', 'avatarReturnRequest', avatarReturnRequest)
            const localVarPath = `/api/avatars/return-avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MetaAvatarFilter} metaAvatarFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (metaAvatarFilter: MetaAvatarFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metaAvatarFilter' is not null or undefined
            assertParamExists('search', 'metaAvatarFilter', metaAvatarFilter)
            const localVarPath = `/api/meta-avatar/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaAvatarFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGrIdToMA: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meta-avatar/setGrIdToMA`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarDto} avatarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, avatarDto: AvatarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'avatarDto' is not null or undefined
            assertParamExists('update', 'avatarDto', avatarDto)
            const localVarPath = `/api/avatars/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAPAUsage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAPAUsage', 'id', id)
            const localVarPath = `/api/avatars/{id}/updateAPAusage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarAdditionalInfo} avatarAdditionalInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatarAdditionalInfo: async (id: string, avatarAdditionalInfo: AvatarAdditionalInfo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAvatarAdditionalInfo', 'id', id)
            // verify required parameter 'avatarAdditionalInfo' is not null or undefined
            assertParamExists('updateAvatarAdditionalInfo', 'avatarAdditionalInfo', avatarAdditionalInfo)
            const localVarPath = `/api/meta-avatar/{id}/additional-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarAdditionalInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarStatusDTO} avatarStatusDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatarStatus: async (id: string, avatarStatusDTO: AvatarStatusDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAvatarStatus', 'id', id)
            // verify required parameter 'avatarStatusDTO' is not null or undefined
            assertParamExists('updateAvatarStatus', 'avatarStatusDTO', avatarStatusDTO)
            const localVarPath = `/api/avatars/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarStatusDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmail: async (id: string, email: Email, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmail', 'id', id)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('updateEmail', 'email', email)
            const localVarPath = `/api/meta-avatar/{id}/email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(email, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MetaAvatarDTO} metaAvatarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetaAvatar: async (id: string, metaAvatarDTO: MetaAvatarDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMetaAvatar', 'id', id)
            // verify required parameter 'metaAvatarDTO' is not null or undefined
            assertParamExists('updateMetaAvatar', 'metaAvatarDTO', metaAvatarDTO)
            const localVarPath = `/api/meta-avatar/{id}/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaAvatarDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MetaAvatarUserName} metaAvatarUserName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetaAvatarUserName: async (id: string, metaAvatarUserName: MetaAvatarUserName, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMetaAvatarUserName', 'id', id)
            // verify required parameter 'metaAvatarUserName' is not null or undefined
            assertParamExists('updateMetaAvatarUserName', 'metaAvatarUserName', metaAvatarUserName)
            const localVarPath = `/api/meta-avatar/{id}/changeUserName`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaAvatarUserName, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PasswordBody} passwordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (id: string, passwordBody: PasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePassword', 'id', id)
            // verify required parameter 'passwordBody' is not null or undefined
            assertParamExists('updatePassword', 'passwordBody', passwordBody)
            const localVarPath = `/api/meta-avatar/{id}/password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ProxyServer} proxyServer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProxy: async (id: string, proxyServer: ProxyServer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProxy', 'id', id)
            // verify required parameter 'proxyServer' is not null or undefined
            assertParamExists('updateProxy', 'proxyServer', proxyServer)
            const localVarPath = `/api/meta-avatar/{id}/proxy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxyServer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {QuarantineModeDTO} quarantineModeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useAutoQuarantine: async (id: string, quarantineModeDTO: QuarantineModeDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('useAutoQuarantine', 'id', id)
            // verify required parameter 'quarantineModeDTO' is not null or undefined
            assertParamExists('useAutoQuarantine', 'quarantineModeDTO', quarantineModeDTO)
            const localVarPath = `/api/avatars/{id}/useAutoQuarantine`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quarantineModeDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AvatarVerificationDTO} avatarVerificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAvatar: async (avatarVerificationDTO: AvatarVerificationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarVerificationDTO' is not null or undefined
            assertParamExists('verifyAvatar', 'avatarVerificationDTO', avatarVerificationDTO)
            const localVarPath = `/api/meta-avatar/verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarVerificationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithAvatarsApi - functional programming interface
 * @export
 */
export const ApiToWorkWithAvatarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithAvatarsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AvatarDto} avatarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAvatar(id: string, avatarDto: AvatarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAvatar(id, avatarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSynopsis(id: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSynopsis(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkSNStatuses(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkSNStatuses(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MetaAvatarDTO} metaAvatarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(metaAvatarDTO: MetaAvatarDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAvatarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(metaAvatarDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAvatarById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAvatarById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableCheckAvatarMaturity(id: string, flag: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableCheckAvatarMaturity(id, flag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAvatars(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAvatars(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DateFilter} [dateFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAvatarLogs(dateFilter?: DateFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarAuditDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAvatarLogs(dateFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AvatarRequest} avatarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableAvatarBySNAndLock(avatarRequest: AvatarRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableAvatarBySNAndLock(avatarRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [socialNetwork] 
         * @param {string} [module] 
         * @param {string} [taskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableAvatars(socialNetwork?: string, module?: string, taskId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableAvatars(socialNetwork, module, taskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AuditFilter} auditFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvatarLogs(auditFilter: AuditFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvatarLogs(auditFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} metaAvatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvatarLogsByLastDay(metaAvatarId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarAuditDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvatarLogsByLastDay(metaAvatarId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AuditFilter} auditFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvatarLogsWithoutPagination(auditFilter: AuditFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarAuditDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvatarLogsWithoutPagination(auditFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvatarStatistic(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarStatisticDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvatarStatistic(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvatarsUsage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarUsageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvatarsUsage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlockedAvatars(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BlockedAvatarDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlockedAvatars(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetaAvatarById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAvatarDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetaAvatarById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSNStatuses(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSNStatuses(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAvatarGetAlerts(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarAlertDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAvatarGetAlerts(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseAvatars(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseAvatars(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AvatarReturnRequest} avatarReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnLockedAvatar(avatarReturnRequest: AvatarReturnRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarReturnResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnLockedAvatar(avatarReturnRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MetaAvatarFilter} metaAvatarFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(metaAvatarFilter: MetaAvatarFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageImplMetaAvatarDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(metaAvatarFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setGrIdToMA(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setGrIdToMA(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarDto} avatarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, avatarDto: AvatarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, avatarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAPAUsage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAPAUsage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarAdditionalInfo} avatarAdditionalInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvatarAdditionalInfo(id: string, avatarAdditionalInfo: AvatarAdditionalInfo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarAdditionalInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvatarAdditionalInfo(id, avatarAdditionalInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarStatusDTO} avatarStatusDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvatarStatus(id: string, avatarStatusDTO: AvatarStatusDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvatarStatus(id, avatarStatusDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmail(id: string, email: Email, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Email>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmail(id, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {MetaAvatarDTO} metaAvatarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMetaAvatar(id: string, metaAvatarDTO: MetaAvatarDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAvatarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMetaAvatar(id, metaAvatarDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {MetaAvatarUserName} metaAvatarUserName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMetaAvatarUserName(id: string, metaAvatarUserName: MetaAvatarUserName, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAvatarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMetaAvatarUserName(id, metaAvatarUserName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PasswordBody} passwordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(id: string, passwordBody: PasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAvatarDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(id, passwordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ProxyServer} proxyServer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProxy(id: string, proxyServer: ProxyServer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProxyServer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProxy(id, proxyServer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {QuarantineModeDTO} quarantineModeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async useAutoQuarantine(id: string, quarantineModeDTO: QuarantineModeDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantineModeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.useAutoQuarantine(id, quarantineModeDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AvatarVerificationDTO} avatarVerificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAvatar(avatarVerificationDTO: AvatarVerificationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAvatar(avatarVerificationDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithAvatarsApi - factory interface
 * @export
 */
export const ApiToWorkWithAvatarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithAvatarsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AvatarDto} avatarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAvatar(id: string, avatarDto: AvatarDto, options?: any): AxiosPromise<AvatarDTOResponse> {
            return localVarFp.addAvatar(id, avatarDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSynopsis(id: string, body?: string, options?: any): AxiosPromise<string> {
            return localVarFp.addSynopsis(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSNStatuses(id: string, options?: any): AxiosPromise<Array<AvatarDto>> {
            return localVarFp.checkSNStatuses(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MetaAvatarDTO} metaAvatarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(metaAvatarDTO: MetaAvatarDTO, options?: any): AxiosPromise<MetaAvatarResponse> {
            return localVarFp.create(metaAvatarDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvatarById(id: string, options?: any): AxiosPromise<AvatarDeleteResponse> {
            return localVarFp.deleteAvatarById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCheckAvatarMaturity(id: string, flag: boolean, options?: any): AxiosPromise<AvatarDto> {
            return localVarFp.enableCheckAvatarMaturity(id, flag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAvatars(options?: any): AxiosPromise<void> {
            return localVarFp.exportAvatars(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DateFilter} [dateFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAvatarLogs(dateFilter?: DateFilter, options?: any): AxiosPromise<Array<AvatarAuditDTO>> {
            return localVarFp.getAllAvatarLogs(dateFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AvatarRequest} avatarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAvatarBySNAndLock(avatarRequest: AvatarRequest, options?: any): AxiosPromise<AvatarResponse> {
            return localVarFp.getAvailableAvatarBySNAndLock(avatarRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [socialNetwork] 
         * @param {string} [module] 
         * @param {string} [taskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAvatars(socialNetwork?: string, module?: string, taskId?: string, options?: any): AxiosPromise<Array<AvatarInfo>> {
            return localVarFp.getAvailableAvatars(socialNetwork, module, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditFilter} auditFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarLogs(auditFilter: AuditFilter, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getAvatarLogs(auditFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} metaAvatarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarLogsByLastDay(metaAvatarId: string, options?: any): AxiosPromise<Array<AvatarAuditDTO>> {
            return localVarFp.getAvatarLogsByLastDay(metaAvatarId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditFilter} auditFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarLogsWithoutPagination(auditFilter: AuditFilter, options?: any): AxiosPromise<Array<AvatarAuditDTO>> {
            return localVarFp.getAvatarLogsWithoutPagination(auditFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarStatistic(id: string, options?: any): AxiosPromise<AvatarStatisticDTO> {
            return localVarFp.getAvatarStatistic(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarsUsage(id: string, options?: any): AxiosPromise<Array<AvatarUsageDTO>> {
            return localVarFp.getAvatarsUsage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedAvatars(id: string, options?: any): AxiosPromise<Array<BlockedAvatarDTO>> {
            return localVarFp.getBlockedAvatars(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetaAvatarById(id: string, options?: any): AxiosPromise<MetaAvatarDTO> {
            return localVarFp.getMetaAvatarById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSNStatuses(id: string, options?: any): AxiosPromise<Array<AvatarDto>> {
            return localVarFp.getSNStatuses(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAvatarGetAlerts(id: string, options?: any): AxiosPromise<Array<AvatarAlertDTO>> {
            return localVarFp.metaAvatarGetAlerts(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseAvatars(options?: any): AxiosPromise<void> {
            return localVarFp.releaseAvatars(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AvatarReturnRequest} avatarReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnLockedAvatar(avatarReturnRequest: AvatarReturnRequest, options?: any): AxiosPromise<AvatarReturnResponse> {
            return localVarFp.returnLockedAvatar(avatarReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MetaAvatarFilter} metaAvatarFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(metaAvatarFilter: MetaAvatarFilter, options?: any): AxiosPromise<PageImplMetaAvatarDTO> {
            return localVarFp.search(metaAvatarFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGrIdToMA(options?: any): AxiosPromise<object> {
            return localVarFp.setGrIdToMA(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarDto} avatarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, avatarDto: AvatarDto, options?: any): AxiosPromise<AvatarDTOResponse> {
            return localVarFp.update(id, avatarDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAPAUsage(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.updateAPAUsage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarAdditionalInfo} avatarAdditionalInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatarAdditionalInfo(id: string, avatarAdditionalInfo: AvatarAdditionalInfo, options?: any): AxiosPromise<AvatarAdditionalInfo> {
            return localVarFp.updateAvatarAdditionalInfo(id, avatarAdditionalInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {AvatarStatusDTO} avatarStatusDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatarStatus(id: string, avatarStatusDTO: AvatarStatusDTO, options?: any): AxiosPromise<AvatarDto> {
            return localVarFp.updateAvatarStatus(id, avatarStatusDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmail(id: string, email: Email, options?: any): AxiosPromise<Email> {
            return localVarFp.updateEmail(id, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {MetaAvatarDTO} metaAvatarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetaAvatar(id: string, metaAvatarDTO: MetaAvatarDTO, options?: any): AxiosPromise<MetaAvatarResponse> {
            return localVarFp.updateMetaAvatar(id, metaAvatarDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {MetaAvatarUserName} metaAvatarUserName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetaAvatarUserName(id: string, metaAvatarUserName: MetaAvatarUserName, options?: any): AxiosPromise<MetaAvatarResponse> {
            return localVarFp.updateMetaAvatarUserName(id, metaAvatarUserName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PasswordBody} passwordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(id: string, passwordBody: PasswordBody, options?: any): AxiosPromise<MetaAvatarDTO> {
            return localVarFp.updatePassword(id, passwordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ProxyServer} proxyServer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProxy(id: string, proxyServer: ProxyServer, options?: any): AxiosPromise<ProxyServer> {
            return localVarFp.updateProxy(id, proxyServer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {QuarantineModeDTO} quarantineModeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useAutoQuarantine(id: string, quarantineModeDTO: QuarantineModeDTO, options?: any): AxiosPromise<QuarantineModeDTO> {
            return localVarFp.useAutoQuarantine(id, quarantineModeDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AvatarVerificationDTO} avatarVerificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAvatar(avatarVerificationDTO: AvatarVerificationDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.verifyAvatar(avatarVerificationDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithAvatarsApi - object-oriented interface
 * @export
 * @class ApiToWorkWithAvatarsApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithAvatarsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {AvatarDto} avatarDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public addAvatar(id: string, avatarDto: AvatarDto, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).addAvatar(id, avatarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public addSynopsis(id: string, body?: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).addSynopsis(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public checkSNStatuses(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).checkSNStatuses(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MetaAvatarDTO} metaAvatarDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public create(metaAvatarDTO: MetaAvatarDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).create(metaAvatarDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public deleteAvatarById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).deleteAvatarById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public deleteById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).deleteById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {boolean} flag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public enableCheckAvatarMaturity(id: string, flag: boolean, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).enableCheckAvatarMaturity(id, flag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public exportAvatars(options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).exportAvatars(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DateFilter} [dateFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getAllAvatarLogs(dateFilter?: DateFilter, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getAllAvatarLogs(dateFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AvatarRequest} avatarRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getAvailableAvatarBySNAndLock(avatarRequest: AvatarRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getAvailableAvatarBySNAndLock(avatarRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [socialNetwork] 
     * @param {string} [module] 
     * @param {string} [taskId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getAvailableAvatars(socialNetwork?: string, module?: string, taskId?: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getAvailableAvatars(socialNetwork, module, taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditFilter} auditFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getAvatarLogs(auditFilter: AuditFilter, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getAvatarLogs(auditFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} metaAvatarId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getAvatarLogsByLastDay(metaAvatarId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getAvatarLogsByLastDay(metaAvatarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditFilter} auditFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getAvatarLogsWithoutPagination(auditFilter: AuditFilter, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getAvatarLogsWithoutPagination(auditFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getAvatarStatistic(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getAvatarStatistic(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getAvatarsUsage(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getAvatarsUsage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getBlockedAvatars(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getBlockedAvatars(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getMetaAvatarById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getMetaAvatarById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public getSNStatuses(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).getSNStatuses(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public metaAvatarGetAlerts(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).metaAvatarGetAlerts(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public releaseAvatars(options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).releaseAvatars(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AvatarReturnRequest} avatarReturnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public returnLockedAvatar(avatarReturnRequest: AvatarReturnRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).returnLockedAvatar(avatarReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MetaAvatarFilter} metaAvatarFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public search(metaAvatarFilter: MetaAvatarFilter, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).search(metaAvatarFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public setGrIdToMA(options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).setGrIdToMA(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {AvatarDto} avatarDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public update(id: string, avatarDto: AvatarDto, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).update(id, avatarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public updateAPAUsage(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).updateAPAUsage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {AvatarAdditionalInfo} avatarAdditionalInfo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public updateAvatarAdditionalInfo(id: string, avatarAdditionalInfo: AvatarAdditionalInfo, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).updateAvatarAdditionalInfo(id, avatarAdditionalInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {AvatarStatusDTO} avatarStatusDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public updateAvatarStatus(id: string, avatarStatusDTO: AvatarStatusDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).updateAvatarStatus(id, avatarStatusDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public updateEmail(id: string, email: Email, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).updateEmail(id, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {MetaAvatarDTO} metaAvatarDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public updateMetaAvatar(id: string, metaAvatarDTO: MetaAvatarDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).updateMetaAvatar(id, metaAvatarDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {MetaAvatarUserName} metaAvatarUserName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public updateMetaAvatarUserName(id: string, metaAvatarUserName: MetaAvatarUserName, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).updateMetaAvatarUserName(id, metaAvatarUserName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {PasswordBody} passwordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public updatePassword(id: string, passwordBody: PasswordBody, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).updatePassword(id, passwordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ProxyServer} proxyServer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public updateProxy(id: string, proxyServer: ProxyServer, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).updateProxy(id, proxyServer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {QuarantineModeDTO} quarantineModeDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public useAutoQuarantine(id: string, quarantineModeDTO: QuarantineModeDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).useAutoQuarantine(id, quarantineModeDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AvatarVerificationDTO} avatarVerificationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithAvatarsApi
     */
    public verifyAvatar(avatarVerificationDTO: AvatarVerificationDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithAvatarsApiFp(this.configuration).verifyAvatar(avatarVerificationDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithCampaignActionsRequestsApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithCampaignActionsRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} stepId 
         * @param {ActionCreateRequest} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAction: async (stepId: string, actionCreateRequest: ActionCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('createAction', 'stepId', stepId)
            // verify required parameter 'actionCreateRequest' is not null or undefined
            assertParamExists('createAction', 'actionCreateRequest', actionCreateRequest)
            const localVarPath = `/api/actions/{stepId}/create`
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {Array<ActionCreateRequest>} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActions: async (stepId: string, actionCreateRequest: Array<ActionCreateRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('createActions', 'stepId', stepId)
            // verify required parameter 'actionCreateRequest' is not null or undefined
            assertParamExists('createActions', 'actionCreateRequest', actionCreateRequest)
            const localVarPath = `/api/actions/{stepId}/bulk`
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {ActionGenerateRequest} actionGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateActions: async (stepId: string, actionGenerateRequest: ActionGenerateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('generateActions', 'stepId', stepId)
            // verify required parameter 'actionGenerateRequest' is not null or undefined
            assertParamExists('generateActions', 'actionGenerateRequest', actionGenerateRequest)
            const localVarPath = `/api/actions/{stepId}/actions/generate`
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionGenerateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} actonId 
         * @param {ActionGetRequest} actionGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAction: async (actonId: string, actionGetRequest: ActionGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actonId' is not null or undefined
            assertParamExists('getAction', 'actonId', actonId)
            // verify required parameter 'actionGetRequest' is not null or undefined
            assertParamExists('getAction', 'actionGetRequest', actionGetRequest)
            const localVarPath = `/api/actions/{actonId}`
                .replace(`{${"actonId"}}`, encodeURIComponent(String(actonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {ActionPageRequest} actionPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionsForStep: async (stepId: string, actionPageRequest: ActionPageRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('getActionsForStep', 'stepId', stepId)
            // verify required parameter 'actionPageRequest' is not null or undefined
            assertParamExists('getActionsForStep', 'actionPageRequest', actionPageRequest)
            const localVarPath = `/api/actions/step/{stepId}`
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionPageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} actonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAction: async (actonId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actonId' is not null or undefined
            assertParamExists('removeAction', 'actonId', actonId)
            const localVarPath = `/api/actions/{actonId}`
                .replace(`{${"actonId"}}`, encodeURIComponent(String(actonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} actionId 
         * @param {ActionUpdateRequest} actionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAction: async (actionId: string, actionUpdateRequest: ActionUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updateAction', 'actionId', actionId)
            // verify required parameter 'actionUpdateRequest' is not null or undefined
            assertParamExists('updateAction', 'actionUpdateRequest', actionUpdateRequest)
            const localVarPath = `/api/actions/{actionId}`
                .replace(`{${"actionId"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithCampaignActionsRequestsApi - functional programming interface
 * @export
 */
export const ApiToWorkWithCampaignActionsRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithCampaignActionsRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} stepId 
         * @param {ActionCreateRequest} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAction(stepId: string, actionCreateRequest: ActionCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAction(stepId, actionCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {Array<ActionCreateRequest>} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActions(stepId: string, actionCreateRequest: Array<ActionCreateRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActions(stepId, actionCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {ActionGenerateRequest} actionGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateActions(stepId: string, actionGenerateRequest: ActionGenerateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionGenerateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateActions(stepId, actionGenerateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} actonId 
         * @param {ActionGetRequest} actionGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAction(actonId: string, actionGetRequest: ActionGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAction(actonId, actionGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {ActionPageRequest} actionPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionsForStep(stepId: string, actionPageRequest: ActionPageRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageActionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionsForStep(stepId, actionPageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} actonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAction(actonId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAction(actonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} actionId 
         * @param {ActionUpdateRequest} actionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAction(actionId: string, actionUpdateRequest: ActionUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAction(actionId, actionUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithCampaignActionsRequestsApi - factory interface
 * @export
 */
export const ApiToWorkWithCampaignActionsRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithCampaignActionsRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} stepId 
         * @param {ActionCreateRequest} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAction(stepId: string, actionCreateRequest: ActionCreateRequest, options?: any): AxiosPromise<ActionDto> {
            return localVarFp.createAction(stepId, actionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {Array<ActionCreateRequest>} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActions(stepId: string, actionCreateRequest: Array<ActionCreateRequest>, options?: any): AxiosPromise<Array<ActionDto>> {
            return localVarFp.createActions(stepId, actionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {ActionGenerateRequest} actionGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateActions(stepId: string, actionGenerateRequest: ActionGenerateRequest, options?: any): AxiosPromise<ActionGenerateResponseDto> {
            return localVarFp.generateActions(stepId, actionGenerateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} actonId 
         * @param {ActionGetRequest} actionGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAction(actonId: string, actionGetRequest: ActionGetRequest, options?: any): AxiosPromise<ActionDto> {
            return localVarFp.getAction(actonId, actionGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {ActionPageRequest} actionPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionsForStep(stepId: string, actionPageRequest: ActionPageRequest, options?: any): AxiosPromise<PageActionDto> {
            return localVarFp.getActionsForStep(stepId, actionPageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} actonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAction(actonId: string, options?: any): AxiosPromise<object> {
            return localVarFp.removeAction(actonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} actionId 
         * @param {ActionUpdateRequest} actionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAction(actionId: string, actionUpdateRequest: ActionUpdateRequest, options?: any): AxiosPromise<ActionDto> {
            return localVarFp.updateAction(actionId, actionUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithCampaignActionsRequestsApi - object-oriented interface
 * @export
 * @class ApiToWorkWithCampaignActionsRequestsApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithCampaignActionsRequestsApi extends BaseAPI {
    /**
     * 
     * @param {string} stepId 
     * @param {ActionCreateRequest} actionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignActionsRequestsApi
     */
    public createAction(stepId: string, actionCreateRequest: ActionCreateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignActionsRequestsApiFp(this.configuration).createAction(stepId, actionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {Array<ActionCreateRequest>} actionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignActionsRequestsApi
     */
    public createActions(stepId: string, actionCreateRequest: Array<ActionCreateRequest>, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignActionsRequestsApiFp(this.configuration).createActions(stepId, actionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {ActionGenerateRequest} actionGenerateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignActionsRequestsApi
     */
    public generateActions(stepId: string, actionGenerateRequest: ActionGenerateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignActionsRequestsApiFp(this.configuration).generateActions(stepId, actionGenerateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} actonId 
     * @param {ActionGetRequest} actionGetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignActionsRequestsApi
     */
    public getAction(actonId: string, actionGetRequest: ActionGetRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignActionsRequestsApiFp(this.configuration).getAction(actonId, actionGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {ActionPageRequest} actionPageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignActionsRequestsApi
     */
    public getActionsForStep(stepId: string, actionPageRequest: ActionPageRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignActionsRequestsApiFp(this.configuration).getActionsForStep(stepId, actionPageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} actonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignActionsRequestsApi
     */
    public removeAction(actonId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignActionsRequestsApiFp(this.configuration).removeAction(actonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} actionId 
     * @param {ActionUpdateRequest} actionUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignActionsRequestsApi
     */
    public updateAction(actionId: string, actionUpdateRequest: ActionUpdateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignActionsRequestsApiFp(this.configuration).updateAction(actionId, actionUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithCampaignRequestsApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithCampaignRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {string} [grId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUsersToCampaign: async (id: string, requestBody: Array<string>, grId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignUsersToCampaign', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('assignUsersToCampaign', 'requestBody', requestBody)
            const localVarPath = `/api/campaigns/{id}/assign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (grId !== undefined) {
                localVarQueryParameter['grId'] = grId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign: async (campaignCreateRequest: CampaignCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignCreateRequest' is not null or undefined
            assertParamExists('createCampaign', 'campaignCreateRequest', campaignCreateRequest)
            const localVarPath = `/api/campaigns/campaign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCampaign', 'id', id)
            const localVarPath = `/api/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CampaignGeneralStatRequest} campaignGeneralStatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignStat: async (id: string, campaignGeneralStatRequest: CampaignGeneralStatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCampaignStat', 'id', id)
            // verify required parameter 'campaignGeneralStatRequest' is not null or undefined
            assertParamExists('getCampaignStat', 'campaignGeneralStatRequest', campaignGeneralStatRequest)
            const localVarPath = `/api/campaigns/{id}/generalStat`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignGeneralStatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CampaignPageRequest} campaignPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCampaigns: async (campaignPageRequest: CampaignPageRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignPageRequest' is not null or undefined
            assertParamExists('getUserCampaigns', 'campaignPageRequest', campaignPageRequest)
            const localVarPath = `/api/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignPageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CampaignUpdateRequest} campaignUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign: async (id: string, campaignUpdateRequest: CampaignUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCampaign', 'id', id)
            // verify required parameter 'campaignUpdateRequest' is not null or undefined
            assertParamExists('updateCampaign', 'campaignUpdateRequest', campaignUpdateRequest)
            const localVarPath = `/api/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithCampaignRequestsApi - functional programming interface
 * @export
 */
export const ApiToWorkWithCampaignRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithCampaignRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {string} [grId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignUsersToCampaign(id: string, requestBody: Array<string>, grId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignWithStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignUsersToCampaign(id, requestBody, grId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCampaign(campaignCreateRequest: CampaignCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCampaign(campaignCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaign(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignWithStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaign(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CampaignGeneralStatRequest} campaignGeneralStatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignStat(id: string, campaignGeneralStatRequest: CampaignGeneralStatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignStat(id, campaignGeneralStatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CampaignPageRequest} campaignPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCampaigns(campaignPageRequest: CampaignPageRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCampaignWithStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCampaigns(campaignPageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CampaignUpdateRequest} campaignUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCampaign(id: string, campaignUpdateRequest: CampaignUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignWithStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCampaign(id, campaignUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithCampaignRequestsApi - factory interface
 * @export
 */
export const ApiToWorkWithCampaignRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithCampaignRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {string} [grId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUsersToCampaign(id: string, requestBody: Array<string>, grId?: string, options?: any): AxiosPromise<CampaignWithStatsDto> {
            return localVarFp.assignUsersToCampaign(id, requestBody, grId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(campaignCreateRequest: CampaignCreateRequest, options?: any): AxiosPromise<CampaignDto> {
            return localVarFp.createCampaign(campaignCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign(id: string, options?: any): AxiosPromise<CampaignWithStatsDto> {
            return localVarFp.getCampaign(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CampaignGeneralStatRequest} campaignGeneralStatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignStat(id: string, campaignGeneralStatRequest: CampaignGeneralStatRequest, options?: any): AxiosPromise<CampaignStatsResponse> {
            return localVarFp.getCampaignStat(id, campaignGeneralStatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CampaignPageRequest} campaignPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCampaigns(campaignPageRequest: CampaignPageRequest, options?: any): AxiosPromise<PageCampaignWithStatsDto> {
            return localVarFp.getUserCampaigns(campaignPageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CampaignUpdateRequest} campaignUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign(id: string, campaignUpdateRequest: CampaignUpdateRequest, options?: any): AxiosPromise<CampaignWithStatsDto> {
            return localVarFp.updateCampaign(id, campaignUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithCampaignRequestsApi - object-oriented interface
 * @export
 * @class ApiToWorkWithCampaignRequestsApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithCampaignRequestsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {Array<string>} requestBody 
     * @param {string} [grId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignRequestsApi
     */
    public assignUsersToCampaign(id: string, requestBody: Array<string>, grId?: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignRequestsApiFp(this.configuration).assignUsersToCampaign(id, requestBody, grId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CampaignCreateRequest} campaignCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignRequestsApi
     */
    public createCampaign(campaignCreateRequest: CampaignCreateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignRequestsApiFp(this.configuration).createCampaign(campaignCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignRequestsApi
     */
    public getCampaign(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignRequestsApiFp(this.configuration).getCampaign(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CampaignGeneralStatRequest} campaignGeneralStatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignRequestsApi
     */
    public getCampaignStat(id: string, campaignGeneralStatRequest: CampaignGeneralStatRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignRequestsApiFp(this.configuration).getCampaignStat(id, campaignGeneralStatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CampaignPageRequest} campaignPageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignRequestsApi
     */
    public getUserCampaigns(campaignPageRequest: CampaignPageRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignRequestsApiFp(this.configuration).getUserCampaigns(campaignPageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CampaignUpdateRequest} campaignUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignRequestsApi
     */
    public updateCampaign(id: string, campaignUpdateRequest: CampaignUpdateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignRequestsApiFp(this.configuration).updateCampaign(id, campaignUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithCampaignStepRequestsApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithCampaignStepRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} campaignId 
         * @param {StepCreateRequest} stepCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStep: async (campaignId: string, stepCreateRequest: StepCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('createStep', 'campaignId', campaignId)
            // verify required parameter 'stepCreateRequest' is not null or undefined
            assertParamExists('createStep', 'stepCreateRequest', stepCreateRequest)
            const localVarPath = `/api/steps/{campaignId}/step`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStep: async (stepId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('getStep', 'stepId', stepId)
            const localVarPath = `/api/steps/{stepId}`
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {StepPageRequest} stepPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSteps: async (campaignId: string, stepPageRequest: StepPageRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getSteps', 'campaignId', campaignId)
            // verify required parameter 'stepPageRequest' is not null or undefined
            assertParamExists('getSteps', 'stepPageRequest', stepPageRequest)
            const localVarPath = `/api/steps/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepPageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {StepUpdateRequest} stepUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStep: async (stepId: string, stepUpdateRequest: StepUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('updateStep', 'stepId', stepId)
            // verify required parameter 'stepUpdateRequest' is not null or undefined
            assertParamExists('updateStep', 'stepUpdateRequest', stepUpdateRequest)
            const localVarPath = `/api/steps/{stepId}`
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithCampaignStepRequestsApi - functional programming interface
 * @export
 */
export const ApiToWorkWithCampaignStepRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithCampaignStepRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} campaignId 
         * @param {StepCreateRequest} stepCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStep(campaignId: string, stepCreateRequest: StepCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStep(campaignId, stepCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStep(stepId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepWithStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStep(stepId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {StepPageRequest} stepPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSteps(campaignId: string, stepPageRequest: StepPageRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageStepWithStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSteps(campaignId, stepPageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {StepUpdateRequest} stepUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStep(stepId: string, stepUpdateRequest: StepUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepWithStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStep(stepId, stepUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithCampaignStepRequestsApi - factory interface
 * @export
 */
export const ApiToWorkWithCampaignStepRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithCampaignStepRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} campaignId 
         * @param {StepCreateRequest} stepCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStep(campaignId: string, stepCreateRequest: StepCreateRequest, options?: any): AxiosPromise<StepDto> {
            return localVarFp.createStep(campaignId, stepCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStep(stepId: string, options?: any): AxiosPromise<StepWithStatsDto> {
            return localVarFp.getStep(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {StepPageRequest} stepPageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSteps(campaignId: string, stepPageRequest: StepPageRequest, options?: any): AxiosPromise<PageStepWithStatsDto> {
            return localVarFp.getSteps(campaignId, stepPageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {StepUpdateRequest} stepUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStep(stepId: string, stepUpdateRequest: StepUpdateRequest, options?: any): AxiosPromise<StepWithStatsDto> {
            return localVarFp.updateStep(stepId, stepUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithCampaignStepRequestsApi - object-oriented interface
 * @export
 * @class ApiToWorkWithCampaignStepRequestsApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithCampaignStepRequestsApi extends BaseAPI {
    /**
     * 
     * @param {string} campaignId 
     * @param {StepCreateRequest} stepCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignStepRequestsApi
     */
    public createStep(campaignId: string, stepCreateRequest: StepCreateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignStepRequestsApiFp(this.configuration).createStep(campaignId, stepCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignStepRequestsApi
     */
    public getStep(stepId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignStepRequestsApiFp(this.configuration).getStep(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} campaignId 
     * @param {StepPageRequest} stepPageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignStepRequestsApi
     */
    public getSteps(campaignId: string, stepPageRequest: StepPageRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignStepRequestsApiFp(this.configuration).getSteps(campaignId, stepPageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {StepUpdateRequest} stepUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCampaignStepRequestsApi
     */
    public updateStep(stepId: string, stepUpdateRequest: StepUpdateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCampaignStepRequestsApiFp(this.configuration).updateStep(stepId, stepUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithCasesApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithCasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseNumber 
         * @param {CaseCreateDTO} caseCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseUpdate: async (caseNumber: number, caseCreateDTO: CaseCreateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('caseUpdate', 'caseNumber', caseNumber)
            // verify required parameter 'caseCreateDTO' is not null or undefined
            assertParamExists('caseUpdate', 'caseCreateDTO', caseCreateDTO)
            const localVarPath = `/api/case/{caseNumber}/update`
                .replace(`{${"caseNumber"}}`, encodeURIComponent(String(caseNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {ADIDCreateRequest} aDIDCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createADIDGEOProfile: async (caseNumber: number, aDIDCreateRequest: ADIDCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('createADIDGEOProfile', 'caseNumber', caseNumber)
            // verify required parameter 'aDIDCreateRequest' is not null or undefined
            assertParamExists('createADIDGEOProfile', 'aDIDCreateRequest', aDIDCreateRequest)
            const localVarPath = `/api/case/{caseNumber}/geo`
                .replace(`{${"caseNumber"}}`, encodeURIComponent(String(caseNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aDIDCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {ADIDCreateRequest} aDIDCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createADIDProfile: async (caseNumber: number, aDIDCreateRequest: ADIDCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('createADIDProfile', 'caseNumber', caseNumber)
            // verify required parameter 'aDIDCreateRequest' is not null or undefined
            assertParamExists('createADIDProfile', 'aDIDCreateRequest', aDIDCreateRequest)
            const localVarPath = `/api/case/{caseNumber}/adid`
                .replace(`{${"caseNumber"}}`, encodeURIComponent(String(caseNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aDIDCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CaseCreateDTO} caseCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCase: async (caseCreateDTO: CaseCreateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseCreateDTO' is not null or undefined
            assertParamExists('createCase', 'caseCreateDTO', caseCreateDTO)
            const localVarPath = `/api/case`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile: async (number: number, inlineObject5?: InlineObject5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('createProfile', 'number', number)
            const localVarPath = `/api/case/{number}/profile`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebint: async (number: number, inlineObject1?: InlineObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('createWebint', 'number', number)
            const localVarPath = `/api/case/{number}/webint`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByCaseNumber: async (caseNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('deleteByCaseNumber', 'caseNumber', caseNumber)
            const localVarPath = `/api/case`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfileToExcel: async (number: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('exportProfileToExcel', 'number', number)
            const localVarPath = `/api/case/{number}/profile-excel`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'PROFILER' | 'WEBINT' | 'GEOMC' | 'DARKWEB' | 'SHIP' | 'CONTAINER' | 'ADID'} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFavoriteTargets: async (module: 'PROFILER' | 'WEBINT' | 'GEOMC' | 'DARKWEB' | 'SHIP' | 'CONTAINER' | 'ADID', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'module' is not null or undefined
            assertParamExists('getAllFavoriteTargets', 'module', module)
            const localVarPath = `/api/case/favorite/{module}`
                .replace(`{${"module"}}`, encodeURIComponent(String(module)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCaseNumber: async (caseNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('getByCaseNumber', 'caseNumber', caseNumber)
            const localVarPath = `/api/case`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseAdidProfiles: async (number: number, page: number, size: number, isFavorite?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('getCaseAdidProfiles', 'number', number)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCaseAdidProfiles', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getCaseAdidProfiles', 'size', size)
            const localVarPath = `/api/case/{number}/adid`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (isFavorite !== undefined) {
                localVarQueryParameter['isFavorite'] = isFavorite;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseProfiles: async (number: number, page: number, size: number, isFavorite?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('getCaseProfiles', 'number', number)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCaseProfiles', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getCaseProfiles', 'size', size)
            const localVarPath = `/api/case/{number}/profile`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (isFavorite !== undefined) {
                localVarQueryParameter['isFavorite'] = isFavorite;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseWebins: async (number: number, page: number, size: number, isFavorite?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('getCaseWebins', 'number', number)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCaseWebins', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getCaseWebins', 'size', size)
            const localVarPath = `/api/case/{number}/webint`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (isFavorite !== undefined) {
                localVarQueryParameter['isFavorite'] = isFavorite;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltredCaseProfiles: async (number: number, page: number, size: number, filterTreeInv: FilterTreeInv, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('getFiltredCaseProfiles', 'number', number)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getFiltredCaseProfiles', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getFiltredCaseProfiles', 'size', size)
            // verify required parameter 'filterTreeInv' is not null or undefined
            assertParamExists('getFiltredCaseProfiles', 'filterTreeInv', filterTreeInv)
            const localVarPath = `/api/case/{number}/profile/filter`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterTreeInv, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltredCaseWebins: async (number: number, page: number, size: number, filterTreeInv: FilterTreeInv, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('getFiltredCaseWebins', 'number', number)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getFiltredCaseWebins', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getFiltredCaseWebins', 'size', size)
            // verify required parameter 'filterTreeInv' is not null or undefined
            assertParamExists('getFiltredCaseWebins', 'filterTreeInv', filterTreeInv)
            const localVarPath = `/api/case/{number}/webint/filter`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterTreeInv, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {FullProfilesRequest} fullProfilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullProfiles: async (number: number, fullProfilesRequest: FullProfilesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('getFullProfiles', 'number', number)
            // verify required parameter 'fullProfilesRequest' is not null or undefined
            assertParamExists('getFullProfiles', 'fullProfilesRequest', fullProfilesRequest)
            const localVarPath = `/api/case/{number}/profiles`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fullProfilesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneRequest: async (number: number, page: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('getPhoneRequest', 'number', number)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPhoneRequest', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getPhoneRequest', 'size', size)
            const localVarPath = `/api/case/{number}/adid-requests`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveStatusCase: async (caseNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('setActiveStatusCase', 'caseNumber', caseNumber)
            const localVarPath = `/api/case/{caseNumber}/active`
                .replace(`{${"caseNumber"}}`, encodeURIComponent(String(caseNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setArchiveStatusCase: async (caseNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('setArchiveStatusCase', 'caseNumber', caseNumber)
            const localVarPath = `/api/case/{caseNumber}/archive`
                .replace(`{${"caseNumber"}}`, encodeURIComponent(String(caseNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FavoriteCreateReqDTO} favoriteCreateReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFavorite: async (favoriteCreateReqDTO: FavoriteCreateReqDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteCreateReqDTO' is not null or undefined
            assertParamExists('setFavorite', 'favoriteCreateReqDTO', favoriteCreateReqDTO)
            const localVarPath = `/api/case/setFavorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoriteCreateReqDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithCasesApi - functional programming interface
 * @export
 */
export const ApiToWorkWithCasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithCasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseNumber 
         * @param {CaseCreateDTO} caseCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caseUpdate(caseNumber: number, caseCreateDTO: CaseCreateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caseUpdate(caseNumber, caseCreateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {ADIDCreateRequest} aDIDCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createADIDGEOProfile(caseNumber: number, aDIDCreateRequest: ADIDCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createADIDGEOProfile(caseNumber, aDIDCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {ADIDCreateRequest} aDIDCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createADIDProfile(caseNumber: number, aDIDCreateRequest: ADIDCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createADIDProfile(caseNumber, aDIDCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CaseCreateDTO} caseCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCase(caseCreateDTO: CaseCreateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCase(caseCreateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProfile(number: number, inlineObject5?: InlineObject5, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProfile(number, inlineObject5, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWebint(number: number, inlineObject1?: InlineObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebintDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWebint(number, inlineObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByCaseNumber(caseNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByCaseNumber(caseNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportProfileToExcel(number: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportProfileToExcel(number, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'PROFILER' | 'WEBINT' | 'GEOMC' | 'DARKWEB' | 'SHIP' | 'CONTAINER' | 'ADID'} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFavoriteTargets(module: 'PROFILER' | 'WEBINT' | 'GEOMC' | 'DARKWEB' | 'SHIP' | 'CONTAINER' | 'ADID', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFavoriteTargets(module, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCaseNumber(caseNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCaseNumber(caseNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseAdidProfiles(number: number, page: number, size: number, isFavorite?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageADIDProfileEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseAdidProfiles(number, page, size, isFavorite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseProfiles(number: number, page: number, size: number, isFavorite?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProfileInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseProfiles(number, page, size, isFavorite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseWebins(number: number, page: number, size: number, isFavorite?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWebintDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseWebins(number, page, size, isFavorite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiltredCaseProfiles(number: number, page: number, size: number, filterTreeInv: FilterTreeInv, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProfileInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiltredCaseProfiles(number, page, size, filterTreeInv, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiltredCaseWebins(number: number, page: number, size: number, filterTreeInv: FilterTreeInv, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWebintDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiltredCaseWebins(number, page, size, filterTreeInv, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {FullProfilesRequest} fullProfilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFullProfiles(number: number, fullProfilesRequest: FullProfilesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFullProfiles(number, fullProfilesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoneRequest(number: number, page: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageADIDRequestEntityDto2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoneRequest(number, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setActiveStatusCase(caseNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setActiveStatusCase(caseNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setArchiveStatusCase(caseNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setArchiveStatusCase(caseNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FavoriteCreateReqDTO} favoriteCreateReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFavorite(favoriteCreateReqDTO: FavoriteCreateReqDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFavorite(favoriteCreateReqDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithCasesApi - factory interface
 * @export
 */
export const ApiToWorkWithCasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithCasesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseNumber 
         * @param {CaseCreateDTO} caseCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseUpdate(caseNumber: number, caseCreateDTO: CaseCreateDTO, options?: any): AxiosPromise<CaseResponseDTO> {
            return localVarFp.caseUpdate(caseNumber, caseCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {ADIDCreateRequest} aDIDCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createADIDGEOProfile(caseNumber: number, aDIDCreateRequest: ADIDCreateRequest, options?: any): AxiosPromise<object> {
            return localVarFp.createADIDGEOProfile(caseNumber, aDIDCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {ADIDCreateRequest} aDIDCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createADIDProfile(caseNumber: number, aDIDCreateRequest: ADIDCreateRequest, options?: any): AxiosPromise<object> {
            return localVarFp.createADIDProfile(caseNumber, aDIDCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaseCreateDTO} caseCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCase(caseCreateDTO: CaseCreateDTO, options?: any): AxiosPromise<CaseResponseDTO> {
            return localVarFp.createCase(caseCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile(number: number, inlineObject5?: InlineObject5, options?: any): AxiosPromise<Array<ProfileInfo>> {
            return localVarFp.createProfile(number, inlineObject5, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebint(number: number, inlineObject1?: InlineObject1, options?: any): AxiosPromise<WebintDTO> {
            return localVarFp.createWebint(number, inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByCaseNumber(caseNumber: number, options?: any): AxiosPromise<CaseResponseDTO> {
            return localVarFp.deleteByCaseNumber(caseNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfileToExcel(number: number, options?: any): AxiosPromise<void> {
            return localVarFp.exportProfileToExcel(number, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'PROFILER' | 'WEBINT' | 'GEOMC' | 'DARKWEB' | 'SHIP' | 'CONTAINER' | 'ADID'} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFavoriteTargets(module: 'PROFILER' | 'WEBINT' | 'GEOMC' | 'DARKWEB' | 'SHIP' | 'CONTAINER' | 'ADID', options?: any): AxiosPromise<object> {
            return localVarFp.getAllFavoriteTargets(module, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCaseNumber(caseNumber: number, options?: any): AxiosPromise<CaseResponseDTO> {
            return localVarFp.getByCaseNumber(caseNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseAdidProfiles(number: number, page: number, size: number, isFavorite?: boolean, options?: any): AxiosPromise<PageADIDProfileEntityDto> {
            return localVarFp.getCaseAdidProfiles(number, page, size, isFavorite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseProfiles(number: number, page: number, size: number, isFavorite?: boolean, options?: any): AxiosPromise<PageProfileInfo> {
            return localVarFp.getCaseProfiles(number, page, size, isFavorite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseWebins(number: number, page: number, size: number, isFavorite?: boolean, options?: any): AxiosPromise<PageWebintDTO> {
            return localVarFp.getCaseWebins(number, page, size, isFavorite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltredCaseProfiles(number: number, page: number, size: number, filterTreeInv: FilterTreeInv, options?: any): AxiosPromise<PageProfileInfo> {
            return localVarFp.getFiltredCaseProfiles(number, page, size, filterTreeInv, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltredCaseWebins(number: number, page: number, size: number, filterTreeInv: FilterTreeInv, options?: any): AxiosPromise<PageWebintDTO> {
            return localVarFp.getFiltredCaseWebins(number, page, size, filterTreeInv, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {FullProfilesRequest} fullProfilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullProfiles(number: number, fullProfilesRequest: FullProfilesRequest, options?: any): AxiosPromise<object> {
            return localVarFp.getFullProfiles(number, fullProfilesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} number 
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneRequest(number: number, page: number, size: number, options?: any): AxiosPromise<PageADIDRequestEntityDto2> {
            return localVarFp.getPhoneRequest(number, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveStatusCase(caseNumber: number, options?: any): AxiosPromise<object> {
            return localVarFp.setActiveStatusCase(caseNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setArchiveStatusCase(caseNumber: number, options?: any): AxiosPromise<object> {
            return localVarFp.setArchiveStatusCase(caseNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FavoriteCreateReqDTO} favoriteCreateReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFavorite(favoriteCreateReqDTO: FavoriteCreateReqDTO, options?: any): AxiosPromise<object> {
            return localVarFp.setFavorite(favoriteCreateReqDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithCasesApi - object-oriented interface
 * @export
 * @class ApiToWorkWithCasesApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithCasesApi extends BaseAPI {
    /**
     * 
     * @param {number} caseNumber 
     * @param {CaseCreateDTO} caseCreateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public caseUpdate(caseNumber: number, caseCreateDTO: CaseCreateDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).caseUpdate(caseNumber, caseCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseNumber 
     * @param {ADIDCreateRequest} aDIDCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public createADIDGEOProfile(caseNumber: number, aDIDCreateRequest: ADIDCreateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).createADIDGEOProfile(caseNumber, aDIDCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseNumber 
     * @param {ADIDCreateRequest} aDIDCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public createADIDProfile(caseNumber: number, aDIDCreateRequest: ADIDCreateRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).createADIDProfile(caseNumber, aDIDCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaseCreateDTO} caseCreateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public createCase(caseCreateDTO: CaseCreateDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).createCase(caseCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {InlineObject5} [inlineObject5] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public createProfile(number: number, inlineObject5?: InlineObject5, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).createProfile(number, inlineObject5, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {InlineObject1} [inlineObject1] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public createWebint(number: number, inlineObject1?: InlineObject1, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).createWebint(number, inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public deleteByCaseNumber(caseNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).deleteByCaseNumber(caseNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public exportProfileToExcel(number: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).exportProfileToExcel(number, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'PROFILER' | 'WEBINT' | 'GEOMC' | 'DARKWEB' | 'SHIP' | 'CONTAINER' | 'ADID'} module 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getAllFavoriteTargets(module: 'PROFILER' | 'WEBINT' | 'GEOMC' | 'DARKWEB' | 'SHIP' | 'CONTAINER' | 'ADID', options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getAllFavoriteTargets(module, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getByCaseNumber(caseNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getByCaseNumber(caseNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {number} page 
     * @param {number} size 
     * @param {boolean} [isFavorite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getCaseAdidProfiles(number: number, page: number, size: number, isFavorite?: boolean, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getCaseAdidProfiles(number, page, size, isFavorite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {number} page 
     * @param {number} size 
     * @param {boolean} [isFavorite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getCaseProfiles(number: number, page: number, size: number, isFavorite?: boolean, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getCaseProfiles(number, page, size, isFavorite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {number} page 
     * @param {number} size 
     * @param {boolean} [isFavorite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getCaseWebins(number: number, page: number, size: number, isFavorite?: boolean, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getCaseWebins(number, page, size, isFavorite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {number} page 
     * @param {number} size 
     * @param {FilterTreeInv} filterTreeInv 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getFiltredCaseProfiles(number: number, page: number, size: number, filterTreeInv: FilterTreeInv, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getFiltredCaseProfiles(number, page, size, filterTreeInv, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {number} page 
     * @param {number} size 
     * @param {FilterTreeInv} filterTreeInv 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getFiltredCaseWebins(number: number, page: number, size: number, filterTreeInv: FilterTreeInv, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getFiltredCaseWebins(number, page, size, filterTreeInv, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {FullProfilesRequest} fullProfilesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getFullProfiles(number: number, fullProfilesRequest: FullProfilesRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getFullProfiles(number, fullProfilesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} number 
     * @param {number} page 
     * @param {number} size 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public getPhoneRequest(number: number, page: number, size: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).getPhoneRequest(number, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public setActiveStatusCase(caseNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).setActiveStatusCase(caseNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public setArchiveStatusCase(caseNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).setArchiveStatusCase(caseNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FavoriteCreateReqDTO} favoriteCreateReqDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithCasesApi
     */
    public setFavorite(favoriteCreateReqDTO: FavoriteCreateReqDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithCasesApiFp(this.configuration).setFavorite(favoriteCreateReqDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithInvestigationsApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithInvestigationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {InvestigationUserNameReq} investigationUserNameReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAssignedUser: async (investigationUserNameReq: InvestigationUserNameReq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationUserNameReq' is not null or undefined
            assertParamExists('changeAssignedUser', 'investigationUserNameReq', investigationUserNameReq)
            const localVarPath = `/api/inv/changeUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationUserNameReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByInvNumber: async (invNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('deleteByInvNumber', 'invNumber', invNumber)
            const localVarPath = `/api/inv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invNumber !== undefined) {
                localVarQueryParameter['invNumber'] = invNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInv: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/inv/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInvTree: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/inv/tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByInvNumber: async (invNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('getByInvNumber', 'invNumber', invNumber)
            const localVarPath = `/api/inv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invNumber !== undefined) {
                localVarQueryParameter['invNumber'] = invNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCasesByInvNumber: async (invNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('getCasesByInvNumber', 'invNumber', invNumber)
            const localVarPath = `/api/inv/cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invNumber !== undefined) {
                localVarQueryParameter['invNumber'] = invNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltredAllInvTree: async (filterTreeInv: FilterTreeInv, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterTreeInv' is not null or undefined
            assertParamExists('getFiltredAllInvTree', 'filterTreeInv', filterTreeInv)
            const localVarPath = `/api/inv/tree/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterTreeInv, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltredCasesByInvNumber: async (invNumber: number, filterTreeInv: FilterTreeInv, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('getFiltredCasesByInvNumber', 'invNumber', invNumber)
            // verify required parameter 'filterTreeInv' is not null or undefined
            assertParamExists('getFiltredCasesByInvNumber', 'filterTreeInv', filterTreeInv)
            const localVarPath = `/api/inv/cases/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invNumber !== undefined) {
                localVarQueryParameter['invNumber'] = invNumber;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterTreeInv, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvByUsername: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getInvByUsername', 'username', username)
            const localVarPath = `/api/inv/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvsByUsername: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getInvsByUsername', 'username', username)
            const localVarPath = `/api/inv/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvestigationDTO} investigationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        investigationCreate: async (investigationDTO: InvestigationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationDTO' is not null or undefined
            assertParamExists('investigationCreate', 'investigationDTO', investigationDTO)
            const localVarPath = `/api/inv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {InvestigationDTO} investigationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        investigationUpdate: async (invNumber: number, investigationDTO: InvestigationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('investigationUpdate', 'invNumber', invNumber)
            // verify required parameter 'investigationDTO' is not null or undefined
            assertParamExists('investigationUpdate', 'investigationDTO', investigationDTO)
            const localVarPath = `/api/inv/{invNumber}/update`
                .replace(`{${"invNumber"}}`, encodeURIComponent(String(invNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(investigationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveStatusInv: async (invNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('setActiveStatusInv', 'invNumber', invNumber)
            const localVarPath = `/api/inv/{invNumber}/active`
                .replace(`{${"invNumber"}}`, encodeURIComponent(String(invNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setArchiveStatusInv: async (invNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('setArchiveStatusInv', 'invNumber', invNumber)
            const localVarPath = `/api/inv/{invNumber}/archive`
                .replace(`{${"invNumber"}}`, encodeURIComponent(String(invNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithInvestigationsApi - functional programming interface
 * @export
 */
export const ApiToWorkWithInvestigationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithInvestigationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {InvestigationUserNameReq} investigationUserNameReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAssignedUser(investigationUserNameReq: InvestigationUserNameReq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Investigation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAssignedUser(investigationUserNameReq, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByInvNumber(invNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByInvNumber(invNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInv(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Investigation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInv(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInvTree(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: InvestigationTreeNodeDTO; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInvTree(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByInvNumber(invNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByInvNumber(invNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCasesByInvNumber(invNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Case>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCasesByInvNumber(invNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiltredAllInvTree(filterTreeInv: FilterTreeInv, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: InvestigationTreeNodeDTO; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiltredAllInvTree(filterTreeInv, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiltredCasesByInvNumber(invNumber: number, filterTreeInv: FilterTreeInv, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Case>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiltredCasesByInvNumber(invNumber, filterTreeInv, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvByUsername(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Investigation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvByUsername(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvsByUsername(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvestigationInfoDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvsByUsername(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InvestigationDTO} investigationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async investigationCreate(investigationDTO: InvestigationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.investigationCreate(investigationDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {InvestigationDTO} investigationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async investigationUpdate(invNumber: number, investigationDTO: InvestigationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.investigationUpdate(invNumber, investigationDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setActiveStatusInv(invNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setActiveStatusInv(invNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setArchiveStatusInv(invNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setArchiveStatusInv(invNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithInvestigationsApi - factory interface
 * @export
 */
export const ApiToWorkWithInvestigationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithInvestigationsApiFp(configuration)
    return {
        /**
         * 
         * @param {InvestigationUserNameReq} investigationUserNameReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAssignedUser(investigationUserNameReq: InvestigationUserNameReq, options?: any): AxiosPromise<Array<Investigation>> {
            return localVarFp.changeAssignedUser(investigationUserNameReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByInvNumber(invNumber: number, options?: any): AxiosPromise<InvestigationResponseDTO> {
            return localVarFp.deleteByInvNumber(invNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInv(options?: any): AxiosPromise<Array<Investigation>> {
            return localVarFp.getAllInv(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInvTree(options?: any): AxiosPromise<{ [key: string]: InvestigationTreeNodeDTO; }> {
            return localVarFp.getAllInvTree(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByInvNumber(invNumber: number, options?: any): AxiosPromise<InvestigationResponseDTO> {
            return localVarFp.getByInvNumber(invNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCasesByInvNumber(invNumber: number, options?: any): AxiosPromise<Array<Case>> {
            return localVarFp.getCasesByInvNumber(invNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltredAllInvTree(filterTreeInv: FilterTreeInv, options?: any): AxiosPromise<{ [key: string]: InvestigationTreeNodeDTO; }> {
            return localVarFp.getFiltredAllInvTree(filterTreeInv, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {FilterTreeInv} filterTreeInv 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltredCasesByInvNumber(invNumber: number, filterTreeInv: FilterTreeInv, options?: any): AxiosPromise<Array<Case>> {
            return localVarFp.getFiltredCasesByInvNumber(invNumber, filterTreeInv, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvByUsername(username: string, options?: any): AxiosPromise<Array<Investigation>> {
            return localVarFp.getInvByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvsByUsername(username: string, options?: any): AxiosPromise<Array<InvestigationInfoDTO>> {
            return localVarFp.getInvsByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvestigationDTO} investigationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        investigationCreate(investigationDTO: InvestigationDTO, options?: any): AxiosPromise<InvestigationResponseDTO> {
            return localVarFp.investigationCreate(investigationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {InvestigationDTO} investigationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        investigationUpdate(invNumber: number, investigationDTO: InvestigationDTO, options?: any): AxiosPromise<InvestigationResponseDTO> {
            return localVarFp.investigationUpdate(invNumber, investigationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveStatusInv(invNumber: number, options?: any): AxiosPromise<object> {
            return localVarFp.setActiveStatusInv(invNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setArchiveStatusInv(invNumber: number, options?: any): AxiosPromise<object> {
            return localVarFp.setArchiveStatusInv(invNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithInvestigationsApi - object-oriented interface
 * @export
 * @class ApiToWorkWithInvestigationsApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithInvestigationsApi extends BaseAPI {
    /**
     * 
     * @param {InvestigationUserNameReq} investigationUserNameReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public changeAssignedUser(investigationUserNameReq: InvestigationUserNameReq, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).changeAssignedUser(investigationUserNameReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public deleteByInvNumber(invNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).deleteByInvNumber(invNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public getAllInv(options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).getAllInv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public getAllInvTree(options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).getAllInvTree(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public getByInvNumber(invNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).getByInvNumber(invNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public getCasesByInvNumber(invNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).getCasesByInvNumber(invNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilterTreeInv} filterTreeInv 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public getFiltredAllInvTree(filterTreeInv: FilterTreeInv, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).getFiltredAllInvTree(filterTreeInv, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {FilterTreeInv} filterTreeInv 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public getFiltredCasesByInvNumber(invNumber: number, filterTreeInv: FilterTreeInv, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).getFiltredCasesByInvNumber(invNumber, filterTreeInv, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public getInvByUsername(username: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).getInvByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public getInvsByUsername(username: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).getInvsByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvestigationDTO} investigationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public investigationCreate(investigationDTO: InvestigationDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).investigationCreate(investigationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {InvestigationDTO} investigationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public investigationUpdate(invNumber: number, investigationDTO: InvestigationDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).investigationUpdate(invNumber, investigationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public setActiveStatusInv(invNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).setActiveStatusInv(invNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithInvestigationsApi
     */
    public setArchiveStatusInv(invNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithInvestigationsApiFp(this.configuration).setArchiveStatusInv(invNumber, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithProfileApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmail: async (id: number, profileModificationDTO: ProfileModificationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addEmail', 'id', id)
            // verify required parameter 'profileModificationDTO' is not null or undefined
            assertParamExists('addEmail', 'profileModificationDTO', profileModificationDTO)
            const localVarPath = `/api/profile/{id}/add-email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileModificationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHydraItemToProfileInfo: async (id: number, lri: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addHydraItemToProfileInfo', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('addHydraItemToProfileInfo', 'lri', lri)
            const localVarPath = `/api/profile/{id}/hydra-item-data/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {InlineObject3} [inlineObject3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addImage: async (id: number, inlineObject3?: InlineObject3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addImage', 'id', id)
            const localVarPath = `/api/profile/{id}/add-image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addName: async (id: number, profileModificationDTO: ProfileModificationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addName', 'id', id)
            // verify required parameter 'profileModificationDTO' is not null or undefined
            assertParamExists('addName', 'profileModificationDTO', profileModificationDTO)
            const localVarPath = `/api/profile/{id}/add-name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileModificationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPassword: async (id: number, profileModificationDTO: ProfileModificationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addPassword', 'id', id)
            // verify required parameter 'profileModificationDTO' is not null or undefined
            assertParamExists('addPassword', 'profileModificationDTO', profileModificationDTO)
            const localVarPath = `/api/profile/{id}/add-password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileModificationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPhone: async (id: number, profileModificationDTO: ProfileModificationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addPhone', 'id', id)
            // verify required parameter 'profileModificationDTO' is not null or undefined
            assertParamExists('addPhone', 'profileModificationDTO', profileModificationDTO)
            const localVarPath = `/api/profile/{id}/add-phone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileModificationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProfileItemToProfile: async (id: number, lri: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addProfileItemToProfile', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('addProfileItemToProfile', 'lri', lri)
            const localVarPath = `/api/profile/{id}/profile-item-data/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SocialProfileData} socialProfileData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSocialProfile: async (id: number, socialProfileData: SocialProfileData, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addSocialProfile', 'id', id)
            // verify required parameter 'socialProfileData' is not null or undefined
            assertParamExists('addSocialProfile', 'socialProfileData', socialProfileData)
            const localVarPath = `/api/profile/{id}/add-social-profile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialProfileData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeEntities: async (body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('analyzeEntities', 'body', body)
            const localVarPath = `/api/profile/analyzeEntities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileAnalyzeAssistantReqDTO} profileAnalyzeAssistantReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantProfileAnalyse: async (id: number, profileAnalyzeAssistantReqDTO: ProfileAnalyzeAssistantReqDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assistantProfileAnalyse', 'id', id)
            // verify required parameter 'profileAnalyzeAssistantReqDTO' is not null or undefined
            assertParamExists('assistantProfileAnalyse', 'profileAnalyzeAssistantReqDTO', profileAnalyzeAssistantReqDTO)
            const localVarPath = `/api/profile/{id}/assistant-analyzer`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileAnalyzeAssistantReqDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfileTarget: async (inlineObject4?: InlineObject4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/profile/create-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfileTargetDefCase: async (phoneNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('createProfileTargetDefCase', 'phoneNumber', phoneNumber)
            const localVarPath = `/api/profile/create/{phoneNumber}`
                .replace(`{${"phoneNumber"}}`, encodeURIComponent(String(phoneNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteLookupRequestDTO} deleteLookupRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLookupRequest: async (id: number, deleteLookupRequestDTO: DeleteLookupRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLookupRequest', 'id', id)
            // verify required parameter 'deleteLookupRequestDTO' is not null or undefined
            assertParamExists('deleteLookupRequest', 'deleteLookupRequestDTO', deleteLookupRequestDTO)
            const localVarPath = `/api/profile/{id}/lookup-request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteLookupRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProfile', 'id', id)
            const localVarPath = `/api/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSocialProfile: async (id: number, lri: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSocialProfile', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('deleteSocialProfile', 'lri', lri)
            const localVarPath = `/api/profile/{id}/social-profile/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {FetchMoreReq} fetchMoreReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMoreFriends: async (id: number, fetchMoreReq: FetchMoreReq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fetchMoreFriends', 'id', id)
            // verify required parameter 'fetchMoreReq' is not null or undefined
            assertParamExists('fetchMoreFriends', 'fetchMoreReq', fetchMoreReq)
            const localVarPath = `/api/profile/{id}/fetch-more-friends`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchMoreReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {FetchMoreReq} fetchMoreReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMorePosts: async (id: number, fetchMoreReq: FetchMoreReq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fetchMorePosts', 'id', id)
            // verify required parameter 'fetchMoreReq' is not null or undefined
            assertParamExists('fetchMorePosts', 'fetchMoreReq', fetchMoreReq)
            const localVarPath = `/api/profile/{id}/fetch-more-posts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchMoreReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalFriends: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdditionalFriends', 'id', id)
            const localVarPath = `/api/profile/{id}/friends/additional`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvataTaskCountInQueue: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/profile/avatar-tasks/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SimplePageFilter} simplePageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessagesAssistant: async (id: number, simplePageFilter: SimplePageFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getChatMessagesAssistant', 'id', id)
            // verify required parameter 'simplePageFilter' is not null or undefined
            assertParamExists('getChatMessagesAssistant', 'simplePageFilter', simplePageFilter)
            const localVarPath = `/api/profile/{id}/chatMessages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simplePageFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} size 
         * @param {string} cursor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessagesAssistantByCursor: async (id: number, size: number, cursor: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getChatMessagesAssistantByCursor', 'id', id)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getChatMessagesAssistantByCursor', 'size', size)
            // verify required parameter 'cursor' is not null or undefined
            assertParamExists('getChatMessagesAssistantByCursor', 'cursor', cursor)
            const localVarPath = `/api/profile/{id}/chatMessages/{cursor}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"cursor"}}`, encodeURIComponent(String(cursor)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfo: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContactInfo', 'id', id)
            const localVarPath = `/api/profile/{id}/contact-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeepWeb: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDeepWeb', 'id', id)
            const localVarPath = `/api/profile/{id}/deep-web`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFriends: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFriends', 'id', id)
            const localVarPath = `/api/profile/{id}/friends`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullTreeProfile: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFullTreeProfile', 'id', id)
            const localVarPath = `/api/profile/{id}/full`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralStat: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGeneralStat', 'id', id)
            const localVarPath = `/api/profile/{id}/general-stat`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isExport] 
         * @param {'jpg' | 'png' | 'webp'} [ext] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageSearchResult: async (id: number, isExport?: boolean, ext?: 'jpg' | 'png' | 'webp', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImageSearchResult', 'id', id)
            const localVarPath = `/api/profile/{id}/image-search-result`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isExport !== undefined) {
                localVarQueryParameter['isExport'] = isExport;
            }

            if (ext !== undefined) {
                localVarQueryParameter['ext'] = ext;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalInformation: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonalInformation', 'id', id)
            const localVarPath = `/api/profile/{id}/personal-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPhotos', 'id', id)
            const localVarPath = `/api/profile/{id}/photos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPreferences', 'id', id)
            const localVarPath = `/api/profile/{id}/preferences`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProfile', 'id', id)
            const localVarPath = `/api/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST'} [socialNetwork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileActivityStat: async (id: number, socialNetwork?: 'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProfileActivityStat', 'id', id)
            const localVarPath = `/api/profile/{id}/activity-stat`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (socialNetwork !== undefined) {
                localVarQueryParameter['socialNetwork'] = socialNetwork;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileLocationStat: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProfileLocationStat', 'id', id)
            const localVarPath = `/api/profile/{id}/location-stat`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {DateRangeDTO} dateRangeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePostStat: async (id: number, dateRangeDTO: DateRangeDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProfilePostStat', 'id', id)
            // verify required parameter 'dateRangeDTO' is not null or undefined
            assertParamExists('getProfilePostStat', 'dateRangeDTO', dateRangeDTO)
            const localVarPath = `/api/profile/{id}/post-stat`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dateRangeDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPsychoProfile: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPsychoProfile', 'id', id)
            const localVarPath = `/api/profile/{id}/psycho-profile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynopsis: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSynopsis', 'id', id)
            const localVarPath = `/api/profile/{id}/synopsis`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebResults: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWebResults', 'id', id)
            const localVarPath = `/api/profile/{id}/web-results`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageInSize: async (id: number, imageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('imageInSize', 'id', id)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('imageInSize', 'imageId', imageId)
            const localVarPath = `/api/profile/{id}/insize/{imageId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {SocialProfileData} [socialProfileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        incrementalSearchSocialProfile: async (id: number, lri: number, socialProfileData?: SocialProfileData, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('incrementalSearchSocialProfile', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('incrementalSearchSocialProfile', 'lri', lri)
            const localVarPath = `/api/profile/{id}/social-profile-incremental/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialProfileData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} profileItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileAssignProfileDataItem: async (id: number, profileItemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('profileAssignProfileDataItem', 'id', id)
            // verify required parameter 'profileItemId' is not null or undefined
            assertParamExists('profileAssignProfileDataItem', 'profileItemId', profileItemId)
            const localVarPath = `/api/profile/{id}/assignProfileDataItem/{profileItemId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"profileItemId"}}`, encodeURIComponent(String(profileItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {PostFilterDTO} postFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileGetPosts: async (id: number, postFilterDTO: PostFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('profileGetPosts', 'id', id)
            // verify required parameter 'postFilterDTO' is not null or undefined
            assertParamExists('profileGetPosts', 'postFilterDTO', postFilterDTO)
            const localVarPath = `/api/profile/{id}/posts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileGetSearchProgress: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('profileGetSearchProgress', 'id', id)
            const localVarPath = `/api/profile/{id}/search-progress`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileAnalyzeRequest} profileAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileOpenAIAnalyse: async (id: number, profileAnalyzeRequest: ProfileAnalyzeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('profileOpenAIAnalyse', 'id', id)
            // verify required parameter 'profileAnalyzeRequest' is not null or undefined
            assertParamExists('profileOpenAIAnalyse', 'profileAnalyzeRequest', profileAnalyzeRequest)
            const localVarPath = `/api/profile/{id}/analyzer`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileAnalyzeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilePing: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/profile/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilePostAnalyze: async (id: string, postId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('profilePostAnalyze', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('profilePostAnalyze', 'postId', postId)
            const localVarPath = `/api/profile/{id}/post/{postId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"postId"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reRunLookup: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reRunLookup', 'id', id)
            const localVarPath = `/api/profile/{id}/run-lookup`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reRunSearchCrawler: async (id: number, lri: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reRunSearchCrawler', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('reRunSearchCrawler', 'lri', lri)
            const localVarPath = `/api/profile/{id}/reRunSearchCrawler/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeHydraItemToProfileInfo: async (id: number, lri: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeHydraItemToProfileInfo', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('removeHydraItemToProfileInfo', 'lri', lri)
            const localVarPath = `/api/profile/{id}/hydra-item-data/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProfileItemFromProfile: async (id: number, lri: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeProfileItemFromProfile', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('removeProfileItemFromProfile', 'lri', lri)
            const localVarPath = `/api/profile/{id}/profile-item-data/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runGetContactLookup: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runGetContactLookup', 'id', id)
            const localVarPath = `/api/profile/{id}/runGetContactLookup`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runLookup: async (id: number, lri: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runLookup', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('runLookup', 'lri', lri)
            const localVarPath = `/api/profile/{id}/runLookup/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runTelegramLookup: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runTelegramLookup', 'id', id)
            const localVarPath = `/api/profile/{id}/runTelegramLookup`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHistory: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('searchHistory', 'id', id)
            const localVarPath = `/api/profile/{id}/search-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ChatMessageAssistantReqDTO} chatMessageAssistantReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToChatMessagesAssistant: async (id: number, chatMessageAssistantReqDTO: ChatMessageAssistantReqDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendToChatMessagesAssistant', 'id', id)
            // verify required parameter 'chatMessageAssistantReqDTO' is not null or undefined
            assertParamExists('sendToChatMessagesAssistant', 'chatMessageAssistantReqDTO', chatMessageAssistantReqDTO)
            const localVarPath = `/api/profile/{id}/chat`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessageAssistantReqDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {PostPsychoFilterDTO} postPsychoFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPsychoProfileAnalyze: async (id: number, postPsychoFilterDTO: PostPsychoFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startPsychoProfileAnalyze', 'id', id)
            // verify required parameter 'postPsychoFilterDTO' is not null or undefined
            assertParamExists('startPsychoProfileAnalyze', 'postPsychoFilterDTO', postPsychoFilterDTO)
            const localVarPath = `/api/profile/{id}/psycho-profile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPsychoFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerson: async (id: number, name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePerson', 'id', id)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('updatePerson', 'name', name)
            const localVarPath = `/api/profile/{id}/updatePerson`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSniperItem: async (id: string, value: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSniperItem', 'id', id)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('updateSniperItem', 'value', value)
            const localVarPath = `/api/profile/{id}/sniper`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {SocialProfileData} [socialProfileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSocialProfile: async (id: number, lri: number, socialProfileData?: SocialProfileData, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSocialProfile', 'id', id)
            // verify required parameter 'lri' is not null or undefined
            assertParamExists('updateSocialProfile', 'lri', lri)
            const localVarPath = `/api/profile/{id}/social-profile/{lri}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lri"}}`, encodeURIComponent(String(lri)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialProfileData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SynopsisDTO} synopsisDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynopsis: async (id: number, synopsisDTO: SynopsisDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSynopsis', 'id', id)
            // verify required parameter 'synopsisDTO' is not null or undefined
            assertParamExists('updateSynopsis', 'synopsisDTO', synopsisDTO)
            const localVarPath = `/api/profile/{id}/synopsis`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(synopsisDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithProfileApi - functional programming interface
 * @export
 */
export const ApiToWorkWithProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmail(id: number, profileModificationDTO: ProfileModificationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEmail(id, profileModificationDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addHydraItemToProfileInfo(id: number, lri: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addHydraItemToProfileInfo(id, lri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {InlineObject3} [inlineObject3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addImage(id: number, inlineObject3?: InlineObject3, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addImage(id, inlineObject3, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addName(id: number, profileModificationDTO: ProfileModificationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addName(id, profileModificationDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPassword(id: number, profileModificationDTO: ProfileModificationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPassword(id, profileModificationDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPhone(id: number, profileModificationDTO: ProfileModificationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPhone(id, profileModificationDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProfileItemToProfile(id: number, lri: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProfileItemToProfile(id, lri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {SocialProfileData} socialProfileData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSocialProfile(id: number, socialProfileData: SocialProfileData, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSocialProfile(id, socialProfileData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeEntities(body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeEntities(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileAnalyzeAssistantReqDTO} profileAnalyzeAssistantReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantProfileAnalyse(id: number, profileAnalyzeAssistantReqDTO: ProfileAnalyzeAssistantReqDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantProfileAnalyse(id, profileAnalyzeAssistantReqDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProfileTarget(inlineObject4?: InlineObject4, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProfileTarget(inlineObject4, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProfileTargetDefCase(phoneNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProfileTargetDefCase(phoneNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteLookupRequestDTO} deleteLookupRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLookupRequest(id: number, deleteLookupRequestDTO: DeleteLookupRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLookupRequest(id, deleteLookupRequestDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProfile(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProfile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSocialProfile(id: number, lri: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSocialProfile(id, lri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {FetchMoreReq} fetchMoreReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMoreFriends(id: number, fetchMoreReq: FetchMoreReq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LookupResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMoreFriends(id, fetchMoreReq, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {FetchMoreReq} fetchMoreReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMorePosts(id: number, fetchMoreReq: FetchMoreReq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LookupResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMorePosts(id, fetchMoreReq, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdditionalFriends(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalFriendsResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdditionalFriends(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvataTaskCountInQueue(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvataTaskCountInQueue(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {SimplePageFilter} simplePageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatMessagesAssistant(id: number, simplePageFilter: SimplePageFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageChatMessageUserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatMessagesAssistant(id, simplePageFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} size 
         * @param {string} cursor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatMessagesAssistantByCursor(id: number, size: number, cursor: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageChatMessageUserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatMessagesAssistantByCursor(id, size, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactInfo(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileContactInfoDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactInfo(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeepWeb(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeepWebDTOView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeepWeb(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFriends(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFriends(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFullTreeProfile(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFullTreeProfile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralStat(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileGeneralStatDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralStat(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isExport] 
         * @param {'jpg' | 'png' | 'webp'} [ext] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageSearchResult(id: number, isExport?: boolean, ext?: 'jpg' | 'png' | 'webp', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImageSearchResultDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageSearchResult(id, isExport, ext, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonalInformation(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonalInformation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhotos(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhotoDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhotos(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferences(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfilePreferenceDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferences(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST'} [socialNetwork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileActivityStat(id: number, socialNetwork?: 'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileActivityStatDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileActivityStat(id, socialNetwork, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileLocationStat(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<ProfileLocationStatDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileLocationStat(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {DateRangeDTO} dateRangeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfilePostStat(id: number, dateRangeDTO: DateRangeDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfilePostStat(id, dateRangeDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPsychoProfile(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPsychoProfile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynopsis(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSynopsis(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebResults(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebResults(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imageInSize(id: number, imageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IrbisSceneCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imageInSize(id, imageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {SocialProfileData} [socialProfileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async incrementalSearchSocialProfile(id: number, lri: number, socialProfileData?: SocialProfileData, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.incrementalSearchSocialProfile(id, lri, socialProfileData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} profileItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileAssignProfileDataItem(id: number, profileItemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileAssignProfileDataItem(id, profileItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {PostFilterDTO} postFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileGetPosts(id: number, postFilterDTO: PostFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileGetPosts(id, postFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileGetSearchProgress(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileSearchProgressDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileGetSearchProgress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileAnalyzeRequest} profileAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileOpenAIAnalyse(id: number, profileAnalyzeRequest: ProfileAnalyzeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileOpenAIAnalyse(id, profileAnalyzeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilePing(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilePing(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilePostAnalyze(id: string, postId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilePostAnalyze(id, postId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reRunLookup(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reRunLookup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reRunSearchCrawler(id: number, lri: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RerunSearchCrawlerStatusDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reRunSearchCrawler(id, lri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeHydraItemToProfileInfo(id: number, lri: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeHydraItemToProfileInfo(id, lri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeProfileItemFromProfile(id: number, lri: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeProfileItemFromProfile(id, lri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runGetContactLookup(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LookupResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runGetContactLookup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runLookup(id: number, lri: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runLookup(id, lri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runTelegramLookup(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LookupResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runTelegramLookup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchHistory(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchHistoryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchHistory(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ChatMessageAssistantReqDTO} chatMessageAssistantReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendToChatMessagesAssistant(id: number, chatMessageAssistantReqDTO: ChatMessageAssistantReqDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageUserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendToChatMessagesAssistant(id, chatMessageAssistantReqDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {PostPsychoFilterDTO} postPsychoFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startPsychoProfileAnalyze(id: number, postPsychoFilterDTO: PostPsychoFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startPsychoProfileAnalyze(id, postPsychoFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePerson(id: number, name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePerson(id, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSniperItem(id: string, value: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSniperItem(id, value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {SocialProfileData} [socialProfileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSocialProfile(id: number, lri: number, socialProfileData?: SocialProfileData, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSocialProfile(id, lri, socialProfileData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {SynopsisDTO} synopsisDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynopsis(id: number, synopsisDTO: SynopsisDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSynopsis(id, synopsisDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithProfileApi - factory interface
 * @export
 */
export const ApiToWorkWithProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithProfileApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmail(id: number, profileModificationDTO: ProfileModificationDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.addEmail(id, profileModificationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHydraItemToProfileInfo(id: number, lri: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.addHydraItemToProfileInfo(id, lri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {InlineObject3} [inlineObject3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addImage(id: number, inlineObject3?: InlineObject3, options?: any): AxiosPromise<boolean> {
            return localVarFp.addImage(id, inlineObject3, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addName(id: number, profileModificationDTO: ProfileModificationDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.addName(id, profileModificationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPassword(id: number, profileModificationDTO: ProfileModificationDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.addPassword(id, profileModificationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileModificationDTO} profileModificationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPhone(id: number, profileModificationDTO: ProfileModificationDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.addPhone(id, profileModificationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProfileItemToProfile(id: number, lri: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.addProfileItemToProfile(id, lri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {SocialProfileData} socialProfileData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSocialProfile(id: number, socialProfileData: SocialProfileData, options?: any): AxiosPromise<boolean> {
            return localVarFp.addSocialProfile(id, socialProfileData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeEntities(body: string, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.analyzeEntities(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileAnalyzeAssistantReqDTO} profileAnalyzeAssistantReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantProfileAnalyse(id: number, profileAnalyzeAssistantReqDTO: ProfileAnalyzeAssistantReqDTO, options?: any): AxiosPromise<AssistantResponseDTO> {
            return localVarFp.assistantProfileAnalyse(id, profileAnalyzeAssistantReqDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfileTarget(inlineObject4?: InlineObject4, options?: any): AxiosPromise<Array<ProfileInfo>> {
            return localVarFp.createProfileTarget(inlineObject4, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfileTargetDefCase(phoneNumber: string, options?: any): AxiosPromise<Array<ProfileInfo>> {
            return localVarFp.createProfileTargetDefCase(phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteLookupRequestDTO} deleteLookupRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLookupRequest(id: number, deleteLookupRequestDTO: DeleteLookupRequestDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteLookupRequest(id, deleteLookupRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteProfile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSocialProfile(id: number, lri: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteSocialProfile(id, lri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {FetchMoreReq} fetchMoreReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMoreFriends(id: number, fetchMoreReq: FetchMoreReq, options?: any): AxiosPromise<LookupResponseDTO> {
            return localVarFp.fetchMoreFriends(id, fetchMoreReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {FetchMoreReq} fetchMoreReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMorePosts(id: number, fetchMoreReq: FetchMoreReq, options?: any): AxiosPromise<LookupResponseDTO> {
            return localVarFp.fetchMorePosts(id, fetchMoreReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalFriends(id: number, options?: any): AxiosPromise<AdditionalFriendsResp> {
            return localVarFp.getAdditionalFriends(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvataTaskCountInQueue(options?: any): AxiosPromise<object> {
            return localVarFp.getAvataTaskCountInQueue(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {SimplePageFilter} simplePageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessagesAssistant(id: number, simplePageFilter: SimplePageFilter, options?: any): AxiosPromise<PageChatMessageUserDTO> {
            return localVarFp.getChatMessagesAssistant(id, simplePageFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} size 
         * @param {string} cursor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessagesAssistantByCursor(id: number, size: number, cursor: string, options?: any): AxiosPromise<PageChatMessageUserDTO> {
            return localVarFp.getChatMessagesAssistantByCursor(id, size, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactInfo(id: number, options?: any): AxiosPromise<Array<ProfileContactInfoDTO>> {
            return localVarFp.getContactInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeepWeb(id: number, options?: any): AxiosPromise<DeepWebDTOView> {
            return localVarFp.getDeepWeb(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFriends(id: number, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.getFriends(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullTreeProfile(id: number, options?: any): AxiosPromise<object> {
            return localVarFp.getFullTreeProfile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralStat(id: number, options?: any): AxiosPromise<ProfileGeneralStatDTO> {
            return localVarFp.getGeneralStat(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isExport] 
         * @param {'jpg' | 'png' | 'webp'} [ext] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageSearchResult(id: number, isExport?: boolean, ext?: 'jpg' | 'png' | 'webp', options?: any): AxiosPromise<Array<ImageSearchResultDTO>> {
            return localVarFp.getImageSearchResult(id, isExport, ext, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalInformation(id: number, options?: any): AxiosPromise<PersonalInfoDTO> {
            return localVarFp.getPersonalInformation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos(id: number, options?: any): AxiosPromise<Array<PhotoDTO>> {
            return localVarFp.getPhotos(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences(id: number, options?: any): AxiosPromise<Array<ProfilePreferenceDTO>> {
            return localVarFp.getPreferences(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(id: number, options?: any): AxiosPromise<ProfileInfo> {
            return localVarFp.getProfile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST'} [socialNetwork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileActivityStat(id: number, socialNetwork?: 'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST', options?: any): AxiosPromise<ProfileActivityStatDTO> {
            return localVarFp.getProfileActivityStat(id, socialNetwork, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileLocationStat(id: number, options?: any): AxiosPromise<Set<ProfileLocationStatDTO>> {
            return localVarFp.getProfileLocationStat(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {DateRangeDTO} dateRangeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePostStat(id: number, dateRangeDTO: DateRangeDTO, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getProfilePostStat(id, dateRangeDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPsychoProfile(id: number, options?: any): AxiosPromise<object> {
            return localVarFp.getPsychoProfile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynopsis(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.getSynopsis(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebResults(id: number, options?: any): AxiosPromise<object> {
            return localVarFp.getWebResults(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageInSize(id: number, imageId: string, options?: any): AxiosPromise<IrbisSceneCheckResponse> {
            return localVarFp.imageInSize(id, imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {SocialProfileData} [socialProfileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        incrementalSearchSocialProfile(id: number, lri: number, socialProfileData?: SocialProfileData, options?: any): AxiosPromise<boolean> {
            return localVarFp.incrementalSearchSocialProfile(id, lri, socialProfileData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} profileItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileAssignProfileDataItem(id: number, profileItemId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.profileAssignProfileDataItem(id, profileItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {PostFilterDTO} postFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileGetPosts(id: number, postFilterDTO: PostFilterDTO, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.profileGetPosts(id, postFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileGetSearchProgress(id: number, options?: any): AxiosPromise<ProfileSearchProgressDTO> {
            return localVarFp.profileGetSearchProgress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProfileAnalyzeRequest} profileAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileOpenAIAnalyse(id: number, profileAnalyzeRequest: ProfileAnalyzeRequest, options?: any): AxiosPromise<object> {
            return localVarFp.profileOpenAIAnalyse(id, profileAnalyzeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilePing(options?: any): AxiosPromise<string> {
            return localVarFp.profilePing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilePostAnalyze(id: string, postId: string, options?: any): AxiosPromise<object> {
            return localVarFp.profilePostAnalyze(id, postId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reRunLookup(id: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.reRunLookup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reRunSearchCrawler(id: number, lri: number, options?: any): AxiosPromise<RerunSearchCrawlerStatusDTO> {
            return localVarFp.reRunSearchCrawler(id, lri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeHydraItemToProfileInfo(id: number, lri: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeHydraItemToProfileInfo(id, lri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProfileItemFromProfile(id: number, lri: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeProfileItemFromProfile(id, lri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runGetContactLookup(id: number, options?: any): AxiosPromise<LookupResponseDTO> {
            return localVarFp.runGetContactLookup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runLookup(id: number, lri: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.runLookup(id, lri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runTelegramLookup(id: number, options?: any): AxiosPromise<LookupResponseDTO> {
            return localVarFp.runTelegramLookup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHistory(id: number, options?: any): AxiosPromise<Array<SearchHistoryDTO>> {
            return localVarFp.searchHistory(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ChatMessageAssistantReqDTO} chatMessageAssistantReqDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToChatMessagesAssistant(id: number, chatMessageAssistantReqDTO: ChatMessageAssistantReqDTO, options?: any): AxiosPromise<ChatMessageUserDTO> {
            return localVarFp.sendToChatMessagesAssistant(id, chatMessageAssistantReqDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {PostPsychoFilterDTO} postPsychoFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPsychoProfileAnalyze(id: number, postPsychoFilterDTO: PostPsychoFilterDTO, options?: any): AxiosPromise<object> {
            return localVarFp.startPsychoProfileAnalyze(id, postPsychoFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerson(id: number, name: string, options?: any): AxiosPromise<void> {
            return localVarFp.updatePerson(id, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSniperItem(id: string, value: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.updateSniperItem(id, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} lri 
         * @param {SocialProfileData} [socialProfileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSocialProfile(id: number, lri: number, socialProfileData?: SocialProfileData, options?: any): AxiosPromise<boolean> {
            return localVarFp.updateSocialProfile(id, lri, socialProfileData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {SynopsisDTO} synopsisDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynopsis(id: number, synopsisDTO: SynopsisDTO, options?: any): AxiosPromise<string> {
            return localVarFp.updateSynopsis(id, synopsisDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithProfileApi - object-oriented interface
 * @export
 * @class ApiToWorkWithProfileApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithProfileApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {ProfileModificationDTO} profileModificationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public addEmail(id: number, profileModificationDTO: ProfileModificationDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).addEmail(id, profileModificationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} lri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public addHydraItemToProfileInfo(id: number, lri: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).addHydraItemToProfileInfo(id, lri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {InlineObject3} [inlineObject3] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public addImage(id: number, inlineObject3?: InlineObject3, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).addImage(id, inlineObject3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProfileModificationDTO} profileModificationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public addName(id: number, profileModificationDTO: ProfileModificationDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).addName(id, profileModificationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProfileModificationDTO} profileModificationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public addPassword(id: number, profileModificationDTO: ProfileModificationDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).addPassword(id, profileModificationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProfileModificationDTO} profileModificationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public addPhone(id: number, profileModificationDTO: ProfileModificationDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).addPhone(id, profileModificationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} lri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public addProfileItemToProfile(id: number, lri: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).addProfileItemToProfile(id, lri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {SocialProfileData} socialProfileData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public addSocialProfile(id: number, socialProfileData: SocialProfileData, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).addSocialProfile(id, socialProfileData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public analyzeEntities(body: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).analyzeEntities(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProfileAnalyzeAssistantReqDTO} profileAnalyzeAssistantReqDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public assistantProfileAnalyse(id: number, profileAnalyzeAssistantReqDTO: ProfileAnalyzeAssistantReqDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).assistantProfileAnalyse(id, profileAnalyzeAssistantReqDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InlineObject4} [inlineObject4] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public createProfileTarget(inlineObject4?: InlineObject4, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).createProfileTarget(inlineObject4, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public createProfileTargetDefCase(phoneNumber: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).createProfileTargetDefCase(phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {DeleteLookupRequestDTO} deleteLookupRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public deleteLookupRequest(id: number, deleteLookupRequestDTO: DeleteLookupRequestDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).deleteLookupRequest(id, deleteLookupRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public deleteProfile(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).deleteProfile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} lri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public deleteSocialProfile(id: number, lri: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).deleteSocialProfile(id, lri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {FetchMoreReq} fetchMoreReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public fetchMoreFriends(id: number, fetchMoreReq: FetchMoreReq, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).fetchMoreFriends(id, fetchMoreReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {FetchMoreReq} fetchMoreReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public fetchMorePosts(id: number, fetchMoreReq: FetchMoreReq, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).fetchMorePosts(id, fetchMoreReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getAdditionalFriends(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getAdditionalFriends(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getAvataTaskCountInQueue(options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getAvataTaskCountInQueue(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {SimplePageFilter} simplePageFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getChatMessagesAssistant(id: number, simplePageFilter: SimplePageFilter, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getChatMessagesAssistant(id, simplePageFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} size 
     * @param {string} cursor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getChatMessagesAssistantByCursor(id: number, size: number, cursor: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getChatMessagesAssistantByCursor(id, size, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getContactInfo(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getContactInfo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getDeepWeb(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getDeepWeb(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getFriends(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getFriends(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getFullTreeProfile(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getFullTreeProfile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getGeneralStat(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getGeneralStat(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [isExport] 
     * @param {'jpg' | 'png' | 'webp'} [ext] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getImageSearchResult(id: number, isExport?: boolean, ext?: 'jpg' | 'png' | 'webp', options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getImageSearchResult(id, isExport, ext, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getPersonalInformation(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getPersonalInformation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getPhotos(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getPhotos(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getPreferences(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getPreferences(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getProfile(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getProfile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST'} [socialNetwork] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getProfileActivityStat(id: number, socialNetwork?: 'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST', options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getProfileActivityStat(id, socialNetwork, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getProfileLocationStat(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getProfileLocationStat(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {DateRangeDTO} dateRangeDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getProfilePostStat(id: number, dateRangeDTO: DateRangeDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getProfilePostStat(id, dateRangeDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getPsychoProfile(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getPsychoProfile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getSynopsis(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getSynopsis(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public getWebResults(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).getWebResults(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public imageInSize(id: number, imageId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).imageInSize(id, imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} lri 
     * @param {SocialProfileData} [socialProfileData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public incrementalSearchSocialProfile(id: number, lri: number, socialProfileData?: SocialProfileData, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).incrementalSearchSocialProfile(id, lri, socialProfileData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} profileItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public profileAssignProfileDataItem(id: number, profileItemId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).profileAssignProfileDataItem(id, profileItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {PostFilterDTO} postFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public profileGetPosts(id: number, postFilterDTO: PostFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).profileGetPosts(id, postFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public profileGetSearchProgress(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).profileGetSearchProgress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProfileAnalyzeRequest} profileAnalyzeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public profileOpenAIAnalyse(id: number, profileAnalyzeRequest: ProfileAnalyzeRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).profileOpenAIAnalyse(id, profileAnalyzeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public profilePing(options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).profilePing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} postId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public profilePostAnalyze(id: string, postId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).profilePostAnalyze(id, postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public reRunLookup(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).reRunLookup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} lri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public reRunSearchCrawler(id: number, lri: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).reRunSearchCrawler(id, lri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} lri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public removeHydraItemToProfileInfo(id: number, lri: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).removeHydraItemToProfileInfo(id, lri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} lri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public removeProfileItemFromProfile(id: number, lri: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).removeProfileItemFromProfile(id, lri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public runGetContactLookup(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).runGetContactLookup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} lri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public runLookup(id: number, lri: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).runLookup(id, lri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public runTelegramLookup(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).runTelegramLookup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public searchHistory(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).searchHistory(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ChatMessageAssistantReqDTO} chatMessageAssistantReqDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public sendToChatMessagesAssistant(id: number, chatMessageAssistantReqDTO: ChatMessageAssistantReqDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).sendToChatMessagesAssistant(id, chatMessageAssistantReqDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {PostPsychoFilterDTO} postPsychoFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public startPsychoProfileAnalyze(id: number, postPsychoFilterDTO: PostPsychoFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).startPsychoProfileAnalyze(id, postPsychoFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public updatePerson(id: number, name: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).updatePerson(id, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {boolean} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public updateSniperItem(id: string, value: boolean, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).updateSniperItem(id, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} lri 
     * @param {SocialProfileData} [socialProfileData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public updateSocialProfile(id: number, lri: number, socialProfileData?: SocialProfileData, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).updateSocialProfile(id, lri, socialProfileData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {SynopsisDTO} synopsisDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProfileApi
     */
    public updateSynopsis(id: number, synopsisDTO: SynopsisDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProfileApiFp(this.configuration).updateSynopsis(id, synopsisDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithProxiesApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithProxiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ProxyServerDTO} proxyServerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProxyServer: async (proxyServerDTO: ProxyServerDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyServerDTO' is not null or undefined
            assertParamExists('createProxyServer', 'proxyServerDTO', proxyServerDTO)
            const localVarPath = `/api/proxies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxyServerDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProxyServer: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProxyServer', 'id', id)
            const localVarPath = `/api/proxies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNum] 
         * @param {string} [sort] 
         * @param {string} [property] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProxiesListPaged: async (pageSize?: number, pageNum?: number, sort?: string, property?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/proxies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (property !== undefined) {
                localVarQueryParameter['property'] = property;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProxyById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProxyById', 'id', id)
            const localVarPath = `/api/proxies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProxyServerDTO} proxyServerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProxyServer: async (proxyServerDTO: ProxyServerDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyServerDTO' is not null or undefined
            assertParamExists('updateProxyServer', 'proxyServerDTO', proxyServerDTO)
            const localVarPath = `/api/proxies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxyServerDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithProxiesApi - functional programming interface
 * @export
 */
export const ApiToWorkWithProxiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithProxiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ProxyServerDTO} proxyServerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProxyServer(proxyServerDTO: ProxyServerDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProxyServer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProxyServer(proxyServerDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProxyServer(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProxyServer(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNum] 
         * @param {string} [sort] 
         * @param {string} [property] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProxiesListPaged(pageSize?: number, pageNum?: number, sort?: string, property?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProxyServer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProxiesListPaged(pageSize, pageNum, sort, property, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProxyById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProxyServer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProxyById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProxyServerDTO} proxyServerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProxyServer(proxyServerDTO: ProxyServerDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProxyServer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProxyServer(proxyServerDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithProxiesApi - factory interface
 * @export
 */
export const ApiToWorkWithProxiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithProxiesApiFp(configuration)
    return {
        /**
         * 
         * @param {ProxyServerDTO} proxyServerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProxyServer(proxyServerDTO: ProxyServerDTO, options?: any): AxiosPromise<ProxyServer> {
            return localVarFp.createProxyServer(proxyServerDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProxyServer(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteProxyServer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNum] 
         * @param {string} [sort] 
         * @param {string} [property] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProxiesListPaged(pageSize?: number, pageNum?: number, sort?: string, property?: string, options?: any): AxiosPromise<PageProxyServer> {
            return localVarFp.getProxiesListPaged(pageSize, pageNum, sort, property, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProxyById(id: string, options?: any): AxiosPromise<ProxyServer> {
            return localVarFp.getProxyById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProxyServerDTO} proxyServerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProxyServer(proxyServerDTO: ProxyServerDTO, options?: any): AxiosPromise<ProxyServer> {
            return localVarFp.updateProxyServer(proxyServerDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithProxiesApi - object-oriented interface
 * @export
 * @class ApiToWorkWithProxiesApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithProxiesApi extends BaseAPI {
    /**
     * 
     * @param {ProxyServerDTO} proxyServerDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProxiesApi
     */
    public createProxyServer(proxyServerDTO: ProxyServerDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProxiesApiFp(this.configuration).createProxyServer(proxyServerDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProxiesApi
     */
    public deleteProxyServer(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProxiesApiFp(this.configuration).deleteProxyServer(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageSize] 
     * @param {number} [pageNum] 
     * @param {string} [sort] 
     * @param {string} [property] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProxiesApi
     */
    public getProxiesListPaged(pageSize?: number, pageNum?: number, sort?: string, property?: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProxiesApiFp(this.configuration).getProxiesListPaged(pageSize, pageNum, sort, property, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProxiesApi
     */
    public getProxyById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithProxiesApiFp(this.configuration).getProxyById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProxyServerDTO} proxyServerDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithProxiesApi
     */
    public updateProxyServer(proxyServerDTO: ProxyServerDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithProxiesApiFp(this.configuration).updateProxyServer(proxyServerDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithQuotaApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithQuotaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testQ: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quota/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithQuotaApi - functional programming interface
 * @export
 */
export const ApiToWorkWithQuotaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithQuotaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testQ(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testQ(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithQuotaApi - factory interface
 * @export
 */
export const ApiToWorkWithQuotaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithQuotaApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testQ(options?: any): AxiosPromise<string> {
            return localVarFp.testQ(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithQuotaApi - object-oriented interface
 * @export
 * @class ApiToWorkWithQuotaApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithQuotaApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithQuotaApi
     */
    public testQ(options?: AxiosRequestConfig) {
        return ApiToWorkWithQuotaApiFp(this.configuration).testQ(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithRekognitionApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithRekognitionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeOptional: async (profileId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('analyzeOptional', 'profileId', profileId)
            const localVarPath = `/api/rekognition/analyzeOptional/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RekognitionImageEnroll} rekognitionImageEnroll 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImageRecognition: async (rekognitionImageEnroll: RekognitionImageEnroll, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rekognitionImageEnroll' is not null or undefined
            assertParamExists('deleteImageRecognition', 'rekognitionImageEnroll', rekognitionImageEnroll)
            const localVarPath = `/api/rekognition/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rekognitionImageEnroll, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detectFace: async (rekognitionDetectRequest: RekognitionDetectRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rekognitionDetectRequest' is not null or undefined
            assertParamExists('detectFace', 'rekognitionDetectRequest', rekognitionDetectRequest)
            const localVarPath = `/api/rekognition/detect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rekognitionDetectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RekognitionImageEnroll} rekognitionImageEnroll 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enroll: async (rekognitionImageEnroll: RekognitionImageEnroll, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rekognitionImageEnroll' is not null or undefined
            assertParamExists('enroll', 'rekognitionImageEnroll', rekognitionImageEnroll)
            const localVarPath = `/api/rekognition/enroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rekognitionImageEnroll, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaceById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFaceById', 'id', id)
            const localVarPath = `/api/rekognition/face/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacesByIds: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getFacesByIds', 'requestBody', requestBody)
            const localVarPath = `/api/rekognition/faces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rekognitionPing: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rekognition/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rekognitionSearch: async (rekognitionDetectRequest: RekognitionDetectRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rekognitionDetectRequest' is not null or undefined
            assertParamExists('rekognitionSearch', 'rekognitionDetectRequest', rekognitionDetectRequest)
            const localVarPath = `/api/rekognition/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rekognitionDetectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfiles: async (rekognitionDetectRequest: RekognitionDetectRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rekognitionDetectRequest' is not null or undefined
            assertParamExists('searchProfiles', 'rekognitionDetectRequest', rekognitionDetectRequest)
            const localVarPath = `/api/rekognition/searchProfiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rekognitionDetectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithRekognitionApi - functional programming interface
 * @export
 */
export const ApiToWorkWithRekognitionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithRekognitionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeOptional(profileId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeOptional(profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RekognitionImageEnroll} rekognitionImageEnroll 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteImageRecognition(rekognitionImageEnroll: RekognitionImageEnroll, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteImageRecognition(rekognitionImageEnroll, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detectFace(rekognitionDetectRequest: RekognitionDetectRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: object; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detectFace(rekognitionDetectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RekognitionImageEnroll} rekognitionImageEnroll 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enroll(rekognitionImageEnroll: RekognitionImageEnroll, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: object; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enroll(rekognitionImageEnroll, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaceById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaceById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacesByIds(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: object; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacesByIds(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rekognitionPing(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rekognitionPing(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rekognitionSearch(rekognitionDetectRequest: RekognitionDetectRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rekognitionSearch(rekognitionDetectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProfiles(rekognitionDetectRequest: RekognitionDetectRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: object; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProfiles(rekognitionDetectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithRekognitionApi - factory interface
 * @export
 */
export const ApiToWorkWithRekognitionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithRekognitionApiFp(configuration)
    return {
        /**
         * 
         * @param {number} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeOptional(profileId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.analyzeOptional(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RekognitionImageEnroll} rekognitionImageEnroll 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImageRecognition(rekognitionImageEnroll: RekognitionImageEnroll, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteImageRecognition(rekognitionImageEnroll, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detectFace(rekognitionDetectRequest: RekognitionDetectRequest, options?: any): AxiosPromise<Array<{ [key: string]: object; }>> {
            return localVarFp.detectFace(rekognitionDetectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RekognitionImageEnroll} rekognitionImageEnroll 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enroll(rekognitionImageEnroll: RekognitionImageEnroll, options?: any): AxiosPromise<Array<{ [key: string]: object; }>> {
            return localVarFp.enroll(rekognitionImageEnroll, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaceById(id: string, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getFaceById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacesByIds(requestBody: Array<string>, options?: any): AxiosPromise<Array<{ [key: string]: object; }>> {
            return localVarFp.getFacesByIds(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rekognitionPing(options?: any): AxiosPromise<string> {
            return localVarFp.rekognitionPing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rekognitionSearch(rekognitionDetectRequest: RekognitionDetectRequest, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.rekognitionSearch(rekognitionDetectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RekognitionDetectRequest} rekognitionDetectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfiles(rekognitionDetectRequest: RekognitionDetectRequest, options?: any): AxiosPromise<Array<{ [key: string]: object; }>> {
            return localVarFp.searchProfiles(rekognitionDetectRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithRekognitionApi - object-oriented interface
 * @export
 * @class ApiToWorkWithRekognitionApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithRekognitionApi extends BaseAPI {
    /**
     * 
     * @param {number} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public analyzeOptional(profileId: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).analyzeOptional(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RekognitionImageEnroll} rekognitionImageEnroll 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public deleteImageRecognition(rekognitionImageEnroll: RekognitionImageEnroll, options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).deleteImageRecognition(rekognitionImageEnroll, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RekognitionDetectRequest} rekognitionDetectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public detectFace(rekognitionDetectRequest: RekognitionDetectRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).detectFace(rekognitionDetectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RekognitionImageEnroll} rekognitionImageEnroll 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public enroll(rekognitionImageEnroll: RekognitionImageEnroll, options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).enroll(rekognitionImageEnroll, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public getFaceById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).getFaceById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public getFacesByIds(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).getFacesByIds(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public rekognitionPing(options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).rekognitionPing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RekognitionDetectRequest} rekognitionDetectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public rekognitionSearch(rekognitionDetectRequest: RekognitionDetectRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).rekognitionSearch(rekognitionDetectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RekognitionDetectRequest} rekognitionDetectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithRekognitionApi
     */
    public searchProfiles(rekognitionDetectRequest: RekognitionDetectRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithRekognitionApiFp(this.configuration).searchProfiles(rekognitionDetectRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithSpeechRecognizeAndAnalyticApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithSpeechRecognizeAndAnalyticApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromtById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePromtById', 'id', id)
            const localVarPath = `/api/speech/promt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSpeechRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSpeechRequest', 'id', id)
            const localVarPath = `/api/speech/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPromt: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/speech/promt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileByName: async (fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getFileByName', 'fileName', fileName)
            const localVarPath = `/api/speech/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileTextByName: async (fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getFileTextByName', 'fileName', fileName)
            const localVarPath = `/api/speech/file/text`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromtById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPromtById', 'id', id)
            const localVarPath = `/api/speech/promt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpeechById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSpeechById', 'id', id)
            const localVarPath = `/api/speech/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SpeechSearchFilter} speechSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpeechRequests: async (speechSearchFilter: SpeechSearchFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'speechSearchFilter' is not null or undefined
            assertParamExists('getSpeechRequests', 'speechSearchFilter', speechSearchFilter)
            const localVarPath = `/api/speech/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(speechSearchFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedLanguage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/speech/lang`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PromtAnalyzeRequest} promtAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promtAnalyze: async (promtAnalyzeRequest: PromtAnalyzeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promtAnalyzeRequest' is not null or undefined
            assertParamExists('promtAnalyze', 'promtAnalyzeRequest', promtAnalyzeRequest)
            const localVarPath = `/api/speech/custom/ai`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promtAnalyzeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActivePromtById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setActivePromtById', 'id', id)
            const localVarPath = `/api/speech/promt/{id}/active`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setVisiblePromtById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setVisiblePromtById', 'id', id)
            const localVarPath = `/api/speech/promt/{id}/visible`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        speechAnalyze: async (inlineObject6?: InlineObject6, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/speech/stt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject6, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textAnalyze: async (inlineObject?: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/speech/text`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} model 
         * @param {string} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAIRequest: async (id: string, model: string, lang: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAIRequest', 'id', id)
            // verify required parameter 'model' is not null or undefined
            assertParamExists('updateAIRequest', 'model', model)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('updateAIRequest', 'lang', lang)
            const localVarPath = `/api/speech/response/{id}/model/{model}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"model"}}`, encodeURIComponent(String(model)))
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromtById: async (id: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePromtById', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updatePromtById', 'body', body)
            const localVarPath = `/api/speech/promt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithSpeechRecognizeAndAnalyticApi - functional programming interface
 * @export
 */
export const ApiToWorkWithSpeechRecognizeAndAnalyticApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithSpeechRecognizeAndAnalyticApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePromtById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePromtById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSpeechRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSpeechRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPromt(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPromt(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileByName(fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileByName(fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileTextByName(fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileTextByName(fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromtById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromtById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpeechById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpeechById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SpeechSearchFilter} speechSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpeechRequests(speechSearchFilter: SpeechSearchFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpeechRequests(speechSearchFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedLanguage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedLanguage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PromtAnalyzeRequest} promtAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promtAnalyze(promtAnalyzeRequest: PromtAnalyzeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promtAnalyze(promtAnalyzeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setActivePromtById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setActivePromtById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setVisiblePromtById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setVisiblePromtById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async speechAnalyze(inlineObject6?: InlineObject6, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.speechAnalyze(inlineObject6, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async textAnalyze(inlineObject?: InlineObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.textAnalyze(inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} model 
         * @param {string} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAIRequest(id: string, model: string, lang: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAIRequest(id, model, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromtById(id: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromtById(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithSpeechRecognizeAndAnalyticApi - factory interface
 * @export
 */
export const ApiToWorkWithSpeechRecognizeAndAnalyticApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromtById(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePromtById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSpeechRequest(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteSpeechRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPromt(options?: any): AxiosPromise<object> {
            return localVarFp.getAllPromt(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileByName(fileName: string, options?: any): AxiosPromise<object> {
            return localVarFp.getFileByName(fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileTextByName(fileName: string, options?: any): AxiosPromise<object> {
            return localVarFp.getFileTextByName(fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromtById(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.getPromtById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpeechById(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.getSpeechById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpeechSearchFilter} speechSearchFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpeechRequests(speechSearchFilter: SpeechSearchFilter, options?: any): AxiosPromise<object> {
            return localVarFp.getSpeechRequests(speechSearchFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedLanguage(options?: any): AxiosPromise<Array<LanguageDTO>> {
            return localVarFp.getSupportedLanguage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PromtAnalyzeRequest} promtAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promtAnalyze(promtAnalyzeRequest: PromtAnalyzeRequest, options?: any): AxiosPromise<object> {
            return localVarFp.promtAnalyze(promtAnalyzeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActivePromtById(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.setActivePromtById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setVisiblePromtById(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.setVisiblePromtById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        speechAnalyze(inlineObject6?: InlineObject6, options?: any): AxiosPromise<object> {
            return localVarFp.speechAnalyze(inlineObject6, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textAnalyze(inlineObject?: InlineObject, options?: any): AxiosPromise<object> {
            return localVarFp.textAnalyze(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} model 
         * @param {string} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAIRequest(id: string, model: string, lang: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateAIRequest(id, model, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromtById(id: string, body: string, options?: any): AxiosPromise<object> {
            return localVarFp.updatePromtById(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithSpeechRecognizeAndAnalyticApi - object-oriented interface
 * @export
 * @class ApiToWorkWithSpeechRecognizeAndAnalyticApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithSpeechRecognizeAndAnalyticApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public deletePromtById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).deletePromtById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public deleteSpeechRequest(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).deleteSpeechRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public getAllPromt(options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).getAllPromt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public getFileByName(fileName: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).getFileByName(fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public getFileTextByName(fileName: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).getFileTextByName(fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public getPromtById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).getPromtById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public getSpeechById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).getSpeechById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpeechSearchFilter} speechSearchFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public getSpeechRequests(speechSearchFilter: SpeechSearchFilter, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).getSpeechRequests(speechSearchFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public getSupportedLanguage(options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).getSupportedLanguage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PromtAnalyzeRequest} promtAnalyzeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public promtAnalyze(promtAnalyzeRequest: PromtAnalyzeRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).promtAnalyze(promtAnalyzeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public setActivePromtById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).setActivePromtById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public setVisiblePromtById(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).setVisiblePromtById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InlineObject6} [inlineObject6] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public speechAnalyze(inlineObject6?: InlineObject6, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).speechAnalyze(inlineObject6, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InlineObject} [inlineObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public textAnalyze(inlineObject?: InlineObject, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).textAnalyze(inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} model 
     * @param {string} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public updateAIRequest(id: string, model: string, lang: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).updateAIRequest(id, model, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithSpeechRecognizeAndAnalyticApi
     */
    public updatePromtById(id: string, body: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithSpeechRecognizeAndAnalyticApiFp(this.configuration).updatePromtById(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiToWorkWithWebintApi - axios parameter creator
 * @export
 */
export const ApiToWorkWithWebintApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {WebintGroupDTO} webintGroupDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup: async (id: string, webintGroupDTO: WebintGroupDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addGroup', 'id', id)
            // verify required parameter 'webintGroupDTO' is not null or undefined
            assertParamExists('addGroup', 'webintGroupDTO', webintGroupDTO)
            const localVarPath = `/api/webint/{id}/add-group`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webintGroupDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebintById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWebintById', 'id', id)
            const localVarPath = `/api/webint/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {GroupActivityFilterDTO} groupActivityFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupActivity: async (invNumber: number, groupActivityFilterDTO: GroupActivityFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('getGroupActivity', 'invNumber', invNumber)
            // verify required parameter 'groupActivityFilterDTO' is not null or undefined
            assertParamExists('getGroupActivity', 'groupActivityFilterDTO', groupActivityFilterDTO)
            const localVarPath = `/api/webint/inv/{invNumber}/group-activity`
                .replace(`{${"invNumber"}}`, encodeURIComponent(String(invNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupActivityFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: async (id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGroups', 'id', id)
            // verify required parameter 'crawlerItemFilterDTO' is not null or undefined
            assertParamExists('getGroups', 'crawlerItemFilterDTO', crawlerItemFilterDTO)
            const localVarPath = `/api/webint/{id}/groups`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crawlerItemFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages: async (id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImages', 'id', id)
            // verify required parameter 'crawlerItemFilterDTO' is not null or undefined
            assertParamExists('getImages', 'crawlerItemFilterDTO', crawlerItemFilterDTO)
            const localVarPath = `/api/webint/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crawlerItemFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvGroups: async (invNumber: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invNumber' is not null or undefined
            assertParamExists('getInvGroups', 'invNumber', invNumber)
            const localVarPath = `/api/webint/inv/{invNumber}/groups`
                .replace(`{${"invNumber"}}`, encodeURIComponent(String(invNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostAvatar: async (postId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('getPostAvatar', 'postId', postId)
            const localVarPath = `/api/webint/post/{postId}/avatar`
                .replace(`{${"postId"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostHistory: async (id: string, postId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPostHistory', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('getPostHistory', 'postId', postId)
            const localVarPath = `/api/webint/{id}/post-history/{postId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"postId"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargets: async (id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTargets', 'id', id)
            // verify required parameter 'crawlerItemFilterDTO' is not null or undefined
            assertParamExists('getTargets', 'crawlerItemFilterDTO', crawlerItemFilterDTO)
            const localVarPath = `/api/webint/{id}/targets`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crawlerItemFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [from] 
         * @param {number} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopPosts: async (from?: number, to?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/webint/post/top`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrends: async (keyword: string, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('getTrends', 'keyword', keyword)
            const localVarPath = `/api/webint/trend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} isMulti 
         * @param {string} keyword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrendsSerpApi: async (isMulti: boolean, keyword: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isMulti' is not null or undefined
            assertParamExists('getTrendsSerpApi', 'isMulti', isMulti)
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('getTrendsSerpApi', 'keyword', keyword)
            const localVarPath = `/api/webint/trend-serpapi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isMulti !== undefined) {
                localVarQueryParameter['isMulti'] = isMulti;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebintUserStatFilterDTO} webintUserStatFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStat: async (webintUserStatFilterDTO: WebintUserStatFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webintUserStatFilterDTO' is not null or undefined
            assertParamExists('getUserStat', 'webintUserStatFilterDTO', webintUserStatFilterDTO)
            const localVarPath = `/api/webint/user-stat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webintUserStatFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideos: async (id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVideos', 'id', id)
            // verify required parameter 'crawlerItemFilterDTO' is not null or undefined
            assertParamExists('getVideos', 'crawlerItemFilterDTO', crawlerItemFilterDTO)
            const localVarPath = `/api/webint/{id}/videos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crawlerItemFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebintById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWebintById', 'id', id)
            const localVarPath = `/api/webint/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {DateRangeDTO} dateRangeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebintPostStat: async (id: string, dateRangeDTO: DateRangeDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWebintPostStat', 'id', id)
            // verify required parameter 'dateRangeDTO' is not null or undefined
            assertParamExists('getWebintPostStat', 'dateRangeDTO', dateRangeDTO)
            const localVarPath = `/api/webint/{id}/post-stat`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dateRangeDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebintStat: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/webint/stat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runCrawler: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runCrawler', 'id', id)
            const localVarPath = `/api/webint/{id}/manual-run-crawler`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} profileItemId 
         * @param {number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintAssignProfileDataItem: async (id: number, profileItemId: string, number: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webintAssignProfileDataItem', 'id', id)
            // verify required parameter 'profileItemId' is not null or undefined
            assertParamExists('webintAssignProfileDataItem', 'profileItemId', profileItemId)
            // verify required parameter 'number' is not null or undefined
            assertParamExists('webintAssignProfileDataItem', 'number', number)
            const localVarPath = `/api/webint/profile/{id}/assignProfileDataItem/{profileItemId}/case/{number}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"profileItemId"}}`, encodeURIComponent(String(profileItemId)))
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {WebintDTO} webintDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintCreateTarget1: async (id: string, webintDTO: WebintDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webintCreateTarget1', 'id', id)
            // verify required parameter 'webintDTO' is not null or undefined
            assertParamExists('webintCreateTarget1', 'webintDTO', webintDTO)
            const localVarPath = `/api/webint/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webintDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PostFilterDTO} postFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintGetPosts: async (id: string, postFilterDTO: PostFilterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webintGetPosts', 'id', id)
            // verify required parameter 'postFilterDTO' is not null or undefined
            assertParamExists('webintGetPosts', 'postFilterDTO', postFilterDTO)
            const localVarPath = `/api/webint/{id}/posts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintGetSearchProgress: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webintGetSearchProgress', 'id', id)
            const localVarPath = `/api/webint/{id}/search-progress`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {WebintAnalyzeRequest} webintAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintOpenAIAnalyse: async (id: number, webintAnalyzeRequest: WebintAnalyzeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webintOpenAIAnalyse', 'id', id)
            // verify required parameter 'webintAnalyzeRequest' is not null or undefined
            assertParamExists('webintOpenAIAnalyse', 'webintAnalyzeRequest', webintAnalyzeRequest)
            const localVarPath = `/api/webint/{id}/analyzer`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webintAnalyzeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintPostAnalyze: async (id: string, postId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('webintPostAnalyze', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('webintPostAnalyze', 'postId', postId)
            const localVarPath = `/api/webint/{id}/post/{postId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"postId"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiToWorkWithWebintApi - functional programming interface
 * @export
 */
export const ApiToWorkWithWebintApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiToWorkWithWebintApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {WebintGroupDTO} webintGroupDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGroup(id: string, webintGroupDTO: WebintGroupDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addGroup(id, webintGroupDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWebintById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWebintById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {GroupActivityFilterDTO} groupActivityFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupActivity(invNumber: number, groupActivityFilterDTO: GroupActivityFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupActivity(invNumber, groupActivityFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroups(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroups(id, crawlerItemFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImages(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImages(id, crawlerItemFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvGroups(invNumber: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebintInfoDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvGroups(invNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostAvatar(postId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostAvatar(postId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostHistory(id: string, postId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostHistory(id, postId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTargets(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTargets(id, crawlerItemFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [from] 
         * @param {number} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopPosts(from?: number, to?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopPosts(from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrends(keyword: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrends(keyword, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} isMulti 
         * @param {string} keyword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrendsSerpApi(isMulti: boolean, keyword: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrendsSerpApi(isMulti, keyword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WebintUserStatFilterDTO} webintUserStatFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserStat(webintUserStatFilterDTO: WebintUserStatFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserStat(webintUserStatFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVideos(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVideos(id, crawlerItemFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebintById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebintDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebintById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {DateRangeDTO} dateRangeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebintPostStat(id: string, dateRangeDTO: DateRangeDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebintPostStat(id, dateRangeDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebintStat(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebintGeneralStatDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebintStat(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runCrawler(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runCrawler(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} profileItemId 
         * @param {number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webintAssignProfileDataItem(id: number, profileItemId: string, number: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webintAssignProfileDataItem(id, profileItemId, number, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {WebintDTO} webintDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webintCreateTarget1(id: string, webintDTO: WebintDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webintCreateTarget1(id, webintDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PostFilterDTO} postFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webintGetPosts(id: string, postFilterDTO: PostFilterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webintGetPosts(id, postFilterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webintGetSearchProgress(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrawlerProgressDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webintGetSearchProgress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {WebintAnalyzeRequest} webintAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webintOpenAIAnalyse(id: number, webintAnalyzeRequest: WebintAnalyzeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webintOpenAIAnalyse(id, webintAnalyzeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webintPostAnalyze(id: string, postId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webintPostAnalyze(id, postId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiToWorkWithWebintApi - factory interface
 * @export
 */
export const ApiToWorkWithWebintApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiToWorkWithWebintApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {WebintGroupDTO} webintGroupDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup(id: string, webintGroupDTO: WebintGroupDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.addGroup(id, webintGroupDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebintById(id: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteWebintById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {GroupActivityFilterDTO} groupActivityFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupActivity(invNumber: number, groupActivityFilterDTO: GroupActivityFilterDTO, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getGroupActivity(invNumber, groupActivityFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.getGroups(id, crawlerItemFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.getImages(id, crawlerItemFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} invNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvGroups(invNumber: number, options?: any): AxiosPromise<Array<WebintInfoDTO>> {
            return localVarFp.getInvGroups(invNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostAvatar(postId: string, options?: any): AxiosPromise<AvatarDto> {
            return localVarFp.getPostAvatar(postId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostHistory(id: string, postId: string, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.getPostHistory(id, postId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargets(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.getTargets(id, crawlerItemFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [from] 
         * @param {number} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopPosts(from?: number, to?: number, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.getTopPosts(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrends(keyword: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<object> {
            return localVarFp.getTrends(keyword, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} isMulti 
         * @param {string} keyword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrendsSerpApi(isMulti: boolean, keyword: string, options?: any): AxiosPromise<object> {
            return localVarFp.getTrendsSerpApi(isMulti, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebintUserStatFilterDTO} webintUserStatFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStat(webintUserStatFilterDTO: WebintUserStatFilterDTO, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getUserStat(webintUserStatFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideos(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.getVideos(id, crawlerItemFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebintById(id: number, options?: any): AxiosPromise<WebintDTO> {
            return localVarFp.getWebintById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {DateRangeDTO} dateRangeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebintPostStat(id: string, dateRangeDTO: DateRangeDTO, options?: any): AxiosPromise<object> {
            return localVarFp.getWebintPostStat(id, dateRangeDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebintStat(options?: any): AxiosPromise<WebintGeneralStatDTO> {
            return localVarFp.getWebintStat(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runCrawler(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.runCrawler(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} profileItemId 
         * @param {number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintAssignProfileDataItem(id: number, profileItemId: string, number: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.webintAssignProfileDataItem(id, profileItemId, number, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {WebintDTO} webintDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintCreateTarget1(id: string, webintDTO: WebintDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.webintCreateTarget1(id, webintDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PostFilterDTO} postFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintGetPosts(id: string, postFilterDTO: PostFilterDTO, options?: any): AxiosPromise<Array<CrawlerResponseDTO>> {
            return localVarFp.webintGetPosts(id, postFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintGetSearchProgress(id: string, options?: any): AxiosPromise<Array<CrawlerProgressDTO>> {
            return localVarFp.webintGetSearchProgress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {WebintAnalyzeRequest} webintAnalyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintOpenAIAnalyse(id: number, webintAnalyzeRequest: WebintAnalyzeRequest, options?: any): AxiosPromise<object> {
            return localVarFp.webintOpenAIAnalyse(id, webintAnalyzeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webintPostAnalyze(id: string, postId: string, options?: any): AxiosPromise<object> {
            return localVarFp.webintPostAnalyze(id, postId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiToWorkWithWebintApi - object-oriented interface
 * @export
 * @class ApiToWorkWithWebintApi
 * @extends {BaseAPI}
 */
export class ApiToWorkWithWebintApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {WebintGroupDTO} webintGroupDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public addGroup(id: string, webintGroupDTO: WebintGroupDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).addGroup(id, webintGroupDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public deleteWebintById(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).deleteWebintById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {GroupActivityFilterDTO} groupActivityFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getGroupActivity(invNumber: number, groupActivityFilterDTO: GroupActivityFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getGroupActivity(invNumber, groupActivityFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getGroups(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getGroups(id, crawlerItemFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getImages(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getImages(id, crawlerItemFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} invNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getInvGroups(invNumber: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getInvGroups(invNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} postId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getPostAvatar(postId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getPostAvatar(postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} postId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getPostHistory(id: string, postId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getPostHistory(id, postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getTargets(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getTargets(id, crawlerItemFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [from] 
     * @param {number} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getTopPosts(from?: number, to?: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getTopPosts(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} keyword 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getTrends(keyword: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getTrends(keyword, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} isMulti 
     * @param {string} keyword 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getTrendsSerpApi(isMulti: boolean, keyword: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getTrendsSerpApi(isMulti, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebintUserStatFilterDTO} webintUserStatFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getUserStat(webintUserStatFilterDTO: WebintUserStatFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getUserStat(webintUserStatFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CrawlerItemFilterDTO} crawlerItemFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getVideos(id: string, crawlerItemFilterDTO: CrawlerItemFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getVideos(id, crawlerItemFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getWebintById(id: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getWebintById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {DateRangeDTO} dateRangeDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getWebintPostStat(id: string, dateRangeDTO: DateRangeDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getWebintPostStat(id, dateRangeDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public getWebintStat(options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).getWebintStat(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public runCrawler(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).runCrawler(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} profileItemId 
     * @param {number} number 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public webintAssignProfileDataItem(id: number, profileItemId: string, number: number, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).webintAssignProfileDataItem(id, profileItemId, number, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {WebintDTO} webintDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public webintCreateTarget1(id: string, webintDTO: WebintDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).webintCreateTarget1(id, webintDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {PostFilterDTO} postFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public webintGetPosts(id: string, postFilterDTO: PostFilterDTO, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).webintGetPosts(id, postFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public webintGetSearchProgress(id: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).webintGetSearchProgress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {WebintAnalyzeRequest} webintAnalyzeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public webintOpenAIAnalyse(id: number, webintAnalyzeRequest: WebintAnalyzeRequest, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).webintOpenAIAnalyse(id, webintAnalyzeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} postId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToWorkWithWebintApi
     */
    public webintPostAnalyze(id: string, postId: string, options?: AxiosRequestConfig) {
        return ApiToWorkWithWebintApiFp(this.configuration).webintPostAnalyze(id, postId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthControllerApi - axios parameter creator
 * @export
 */
export const AuthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser: async (loginDto: LoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('authenticateUser', 'loginDto', loginDto)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('logout', 'username', username)
            const localVarPath = `/api/auth/logout/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthControllerApi - functional programming interface
 * @export
 */
export const AuthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateUser(loginDto: LoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JwtAuthenticationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateUser(loginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthControllerApi - factory interface
 * @export
 */
export const AuthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser(loginDto: LoginDto, options?: any): AxiosPromise<JwtAuthenticationDto> {
            return localVarFp.authenticateUser(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(username: string, options?: any): AxiosPromise<void> {
            return localVarFp.logout(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthControllerApi - object-oriented interface
 * @export
 * @class AuthControllerApi
 * @extends {BaseAPI}
 */
export class AuthControllerApi extends BaseAPI {
    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    public authenticateUser(loginDto: LoginDto, options?: AxiosRequestConfig) {
        return AuthControllerApiFp(this.configuration).authenticateUser(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    public logout(username: string, options?: AxiosRequestConfig) {
        return AuthControllerApiFp(this.configuration).logout(username, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupAPIApi - axios parameter creator
 * @export
 */
export const GroupAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GroupCreateDTO} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: async (groupCreateDTO: GroupCreateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupCreateDTO' is not null or undefined
            assertParamExists('createGroup', 'groupCreateDTO', groupCreateDTO)
            const localVarPath = `/api/group/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<GroupCreateDTO>} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroups: async (groupCreateDTO: Array<GroupCreateDTO>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupCreateDTO' is not null or undefined
            assertParamExists('createGroups', 'groupCreateDTO', groupCreateDTO)
            const localVarPath = `/api/group/createArray`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        croloApiControl: async (id: string, flag: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('croloApiControl', 'id', id)
            // verify required parameter 'flag' is not null or undefined
            assertParamExists('croloApiControl', 'flag', flag)
            const localVarPath = `/api/group/{id}/crolo-api/{flag}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"flag"}}`, encodeURIComponent(String(flag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFullGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFullGroup', 'id', id)
            const localVarPath = `/api/group/{id}/full`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteGroup', 'id', id)
            const localVarPath = `/api/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckList: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCheckList', 'id', id)
            const localVarPath = `/api/group/{id}/check-list`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GroupFilter} groupFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersGroups: async (groupFilter: GroupFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupFilter' is not null or undefined
            assertParamExists('getUsersGroups', 'groupFilter', groupFilter)
            const localVarPath = `/api/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualCheckMaturity: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('manualCheckMaturity', 'id', id)
            const localVarPath = `/api/group/{id}/run-manual-check-maturity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maturityGroupDisable: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('maturityGroupDisable', 'id', id)
            const localVarPath = `/api/group/{id}/maturity-disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maturityGroupEnable: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('maturityGroupEnable', 'id', id)
            const localVarPath = `/api/group/{id}/maturity-enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoveryGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('recoveryGroup', 'id', id)
            const localVarPath = `/api/group/{id}/recovery`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: Array<string>; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupToUser: async (requestBody: { [key: string]: Array<string>; }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('setGroupToUser', 'requestBody', requestBody)
            const localVarPath = `/api/group/setGroupsToUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CheckListUpdateRequest} checkListUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCheckList: async (id: string, checkListUpdateRequest: CheckListUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCheckList', 'id', id)
            // verify required parameter 'checkListUpdateRequest' is not null or undefined
            assertParamExists('updateCheckList', 'checkListUpdateRequest', checkListUpdateRequest)
            const localVarPath = `/api/group/{id}/check-list`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkListUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {GroupCreateDTO} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: async (id: string, groupCreateDTO: GroupCreateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateGroup', 'id', id)
            // verify required parameter 'groupCreateDTO' is not null or undefined
            assertParamExists('updateGroup', 'groupCreateDTO', groupCreateDTO)
            const localVarPath = `/api/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupAPIApi - functional programming interface
 * @export
 */
export const GroupAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GroupCreateDTO} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroup(groupCreateDTO: GroupCreateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroup(groupCreateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<GroupCreateDTO>} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroups(groupCreateDTO: Array<GroupCreateDTO>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroups(groupCreateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async croloApiControl(id: string, flag: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.croloApiControl(id, flag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFullGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFullGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckList(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GroupFilter} groupFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersGroups(groupFilter: GroupFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersGroups(groupFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manualCheckMaturity(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manualCheckMaturity(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async maturityGroupDisable(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.maturityGroupDisable(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async maturityGroupEnable(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.maturityGroupEnable(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recoveryGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recoveryGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {{ [key: string]: Array<string>; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setGroupToUser(requestBody: { [key: string]: Array<string>; }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setGroupToUser(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CheckListUpdateRequest} checkListUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCheckList(id: string, checkListUpdateRequest: CheckListUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCheckList(id, checkListUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {GroupCreateDTO} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroup(id: string, groupCreateDTO: GroupCreateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroup(id, groupCreateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupAPIApi - factory interface
 * @export
 */
export const GroupAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {GroupCreateDTO} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(groupCreateDTO: GroupCreateDTO, options?: any): AxiosPromise<GroupResponseDTO> {
            return localVarFp.createGroup(groupCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<GroupCreateDTO>} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroups(groupCreateDTO: Array<GroupCreateDTO>, options?: any): AxiosPromise<object> {
            return localVarFp.createGroups(groupCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        croloApiControl(id: string, flag: boolean, options?: any): AxiosPromise<GroupResponseDTO> {
            return localVarFp.croloApiControl(id, flag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFullGroup(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteFullGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckList(id: string, options?: any): AxiosPromise<CheckListDTO> {
            return localVarFp.getCheckList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GroupFilter} groupFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersGroups(groupFilter: GroupFilter, options?: any): AxiosPromise<Array<GroupResponseDTO>> {
            return localVarFp.getUsersGroups(groupFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualCheckMaturity(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.manualCheckMaturity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maturityGroupDisable(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.maturityGroupDisable(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maturityGroupEnable(id: string, options?: any): AxiosPromise<CheckListDTO> {
            return localVarFp.maturityGroupEnable(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoveryGroup(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.recoveryGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {{ [key: string]: Array<string>; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupToUser(requestBody: { [key: string]: Array<string>; }, options?: any): AxiosPromise<object> {
            return localVarFp.setGroupToUser(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CheckListUpdateRequest} checkListUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCheckList(id: string, checkListUpdateRequest: CheckListUpdateRequest, options?: any): AxiosPromise<CheckListDTO> {
            return localVarFp.updateCheckList(id, checkListUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {GroupCreateDTO} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(id: string, groupCreateDTO: GroupCreateDTO, options?: any): AxiosPromise<GroupResponseDTO> {
            return localVarFp.updateGroup(id, groupCreateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupAPIApi - object-oriented interface
 * @export
 * @class GroupAPIApi
 * @extends {BaseAPI}
 */
export class GroupAPIApi extends BaseAPI {
    /**
     * 
     * @param {GroupCreateDTO} groupCreateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public createGroup(groupCreateDTO: GroupCreateDTO, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).createGroup(groupCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<GroupCreateDTO>} groupCreateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public createGroups(groupCreateDTO: Array<GroupCreateDTO>, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).createGroups(groupCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {boolean} flag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public croloApiControl(id: string, flag: boolean, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).croloApiControl(id, flag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public deleteFullGroup(id: string, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).deleteFullGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public deleteGroup(id: string, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).deleteGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public getCheckList(id: string, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).getCheckList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupFilter} groupFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public getUsersGroups(groupFilter: GroupFilter, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).getUsersGroups(groupFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public manualCheckMaturity(id: string, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).manualCheckMaturity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public maturityGroupDisable(id: string, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).maturityGroupDisable(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public maturityGroupEnable(id: string, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).maturityGroupEnable(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public recoveryGroup(id: string, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).recoveryGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {{ [key: string]: Array<string>; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public setGroupToUser(requestBody: { [key: string]: Array<string>; }, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).setGroupToUser(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CheckListUpdateRequest} checkListUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public updateCheckList(id: string, checkListUpdateRequest: CheckListUpdateRequest, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).updateCheckList(id, checkListUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {GroupCreateDTO} groupCreateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupAPIApi
     */
    public updateGroup(id: string, groupCreateDTO: GroupCreateDTO, options?: AxiosRequestConfig) {
        return GroupAPIApiFp(this.configuration).updateGroup(id, groupCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobsAPIApi - axios parameter creator
 * @export
 */
export const JobsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsyncJobStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAsyncJobStatus', 'id', id)
            const localVarPath = `/api/jobs/task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsAPIApi - functional programming interface
 * @export
 */
export const JobsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsyncJobStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsyncTaskDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsyncJobStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobsAPIApi - factory interface
 * @export
 */
export const JobsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsyncJobStatus(id: string, options?: any): AxiosPromise<AsyncTaskDTO> {
            return localVarFp.getAsyncJobStatus(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsAPIApi - object-oriented interface
 * @export
 * @class JobsAPIApi
 * @extends {BaseAPI}
 */
export class JobsAPIApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsAPIApi
     */
    public getAsyncJobStatus(id: string, options?: AxiosRequestConfig) {
        return JobsAPIApiFp(this.configuration).getAsyncJobStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PermissionAPIApi - axios parameter creator
 * @export
 */
export const PermissionAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPermissions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupPermissions: async (groupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getGroupPermissions', 'groupId', groupId)
            const localVarPath = `/api/permission/group/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions: async (userName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('getUserPermissions', 'userName', userName)
            const localVarPath = `/api/permission/user/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionAPIApi - functional programming interface
 * @export
 */
export const PermissionAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPermissions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPermissions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupPermissions(groupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupPermissions(groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPermissions(userName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPermissions(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PermissionAPIApi - factory interface
 * @export
 */
export const PermissionAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPermissions(options?: any): AxiosPromise<Array<PermissionDTO>> {
            return localVarFp.getAllPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupPermissions(groupId: string, options?: any): AxiosPromise<Array<PermissionDTO>> {
            return localVarFp.getGroupPermissions(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions(userName: string, options?: any): AxiosPromise<Array<PermissionDTO>> {
            return localVarFp.getUserPermissions(userName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionAPIApi - object-oriented interface
 * @export
 * @class PermissionAPIApi
 * @extends {BaseAPI}
 */
export class PermissionAPIApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAPIApi
     */
    public getAllPermissions(options?: AxiosRequestConfig) {
        return PermissionAPIApiFp(this.configuration).getAllPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAPIApi
     */
    public getGroupPermissions(groupId: string, options?: AxiosRequestConfig) {
        return PermissionAPIApiFp(this.configuration).getGroupPermissions(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAPIApi
     */
    public getUserPermissions(userName: string, options?: AxiosRequestConfig) {
        return PermissionAPIApiFp(this.configuration).getUserPermissions(userName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SystemAPIApi - axios parameter creator
 * @export
 */
export const SystemAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST'} sn 
         * @param {'PROFILER' | 'WEBINT'} module 
         * @param {InlineObject2} [inlineObject2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAvatars: async (sn: 'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST', module: 'PROFILER' | 'WEBINT', inlineObject2?: InlineObject2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sn' is not null or undefined
            assertParamExists('uploadAvatars', 'sn', sn)
            // verify required parameter 'module' is not null or undefined
            assertParamExists('uploadAvatars', 'module', module)
            const localVarPath = `/api/system/avatar/upload/csv/1to1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sn !== undefined) {
                localVarQueryParameter['sn'] = sn;
            }

            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemAPIApi - functional programming interface
 * @export
 */
export const SystemAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST'} sn 
         * @param {'PROFILER' | 'WEBINT'} module 
         * @param {InlineObject2} [inlineObject2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAvatars(sn: 'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST', module: 'PROFILER' | 'WEBINT', inlineObject2?: InlineObject2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAvatarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAvatars(sn, module, inlineObject2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemAPIApi - factory interface
 * @export
 */
export const SystemAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST'} sn 
         * @param {'PROFILER' | 'WEBINT'} module 
         * @param {InlineObject2} [inlineObject2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAvatars(sn: 'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST', module: 'PROFILER' | 'WEBINT', inlineObject2?: InlineObject2, options?: any): AxiosPromise<MetaAvatarResponse> {
            return localVarFp.uploadAvatars(sn, module, inlineObject2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemAPIApi - object-oriented interface
 * @export
 * @class SystemAPIApi
 * @extends {BaseAPI}
 */
export class SystemAPIApi extends BaseAPI {
    /**
     * 
     * @param {'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST'} sn 
     * @param {'PROFILER' | 'WEBINT'} module 
     * @param {InlineObject2} [inlineObject2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAPIApi
     */
    public uploadAvatars(sn: 'FB' | 'FACEBOOK' | 'VK' | 'VKONTAKTE' | 'OK' | 'ODNOKLASSNIKI' | 'LINKEDIN' | 'TUMBLR' | 'YOUTUBE' | 'JOBZELLA' | 'TWITTER' | 'X' | 'FOURSQUARE' | 'ANGELLIST' | 'INSTAGRAM' | 'MY_MAIL_RU' | 'GPLUS' | 'GOOGLE_PLUS' | 'GAB' | 'SNAPCHAT' | 'BADOO' | 'FLING' | 'TPERSONA' | 'PH_NEW_ID' | 'BLACKHATWORLD' | 'DUBSMASH' | 'GEORGIA_CITIZENSHIP' | 'TELEGRAM' | 'SEARCH4FACES' | 'FINDCLONE' | 'WEBVS_PRIMARY' | 'BAIDU' | 'GOOGLESEARCH' | 'MYMAIL' | 'YANDEX' | 'YAHOO' | 'SKYPE' | 'MASSMAPPER' | 'MM' | 'PROFILER' | 'PIPL' | 'HYDRA' | 'TIKTOK' | 'INSTANAVIGATION' | 'SNIPER' | 'PSYCHOPROFILE' | 'IRBISNAMELOOKUP' | 'PINTEREST', module: 'PROFILER' | 'WEBINT', inlineObject2?: InlineObject2, options?: AxiosRequestConfig) {
        return SystemAPIApiFp(this.configuration).uploadAvatars(sn, module, inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestApiGrpcExceptionApi - axios parameter creator
 * @export
 */
export const TestApiGrpcExceptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testGRPCException: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grpc/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestApiGrpcExceptionApi - functional programming interface
 * @export
 */
export const TestApiGrpcExceptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestApiGrpcExceptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testGRPCException(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testGRPCException(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestApiGrpcExceptionApi - factory interface
 * @export
 */
export const TestApiGrpcExceptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestApiGrpcExceptionApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testGRPCException(options?: any): AxiosPromise<string> {
            return localVarFp.testGRPCException(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestApiGrpcExceptionApi - object-oriented interface
 * @export
 * @class TestApiGrpcExceptionApi
 * @extends {BaseAPI}
 */
export class TestApiGrpcExceptionApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApiGrpcExceptionApi
     */
    public testGRPCException(options?: AxiosRequestConfig) {
        return TestApiGrpcExceptionApiFp(this.configuration).testGRPCException(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAPIApi - axios parameter creator
 * @export
 */
export const UserAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUser', 'id', id)
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fullDeleteUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fullDeleteUser', 'id', id)
            const localVarPath = `/api/user/{id}/full`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserFilter} userFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmin: async (userFilter: UserFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userFilter' is not null or undefined
            assertParamExists('getAdmin', 'userFilter', userFilter)
            const localVarPath = `/api/user/adm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/userInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoByUserName: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getUserInfoByUserName', 'name', name)
            const localVarPath = `/api/user/userInfo/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserFilter} userFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (userFilter: UserFilter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userFilter' is not null or undefined
            assertParamExists('getUsers', 'userFilter', userFilter)
            const localVarPath = `/api/user/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserCreateDTO} userCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser: async (userCreateDTO: UserCreateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCreateDTO' is not null or undefined
            assertParamExists('registerUser', 'userCreateDTO', userCreateDTO)
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UserNameDTO} userNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameUser: async (id: string, userNameDTO: UserNameDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('renameUser', 'id', id)
            // verify required parameter 'userNameDTO' is not null or undefined
            assertParamExists('renameUser', 'userNameDTO', userNameDTO)
            const localVarPath = `/api/user/{id}/rename`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userNameDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UserUpdateDTO} userUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id: string, userUpdateDTO: UserUpdateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id)
            // verify required parameter 'userUpdateDTO' is not null or undefined
            assertParamExists('updateUser', 'userUpdateDTO', userUpdateDTO)
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAPIApi - functional programming interface
 * @export
 */
export const UserAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fullDeleteUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fullDeleteUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserFilter} userFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdmin(userFilter: UserFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUserResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdmin(userFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfoByUserName(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfoByUserName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserFilter} userFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(userFilter: UserFilter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUserResponseSessionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(userFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserCreateDTO} userCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerUser(userCreateDTO: UserCreateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerUser(userCreateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UserNameDTO} userNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameUser(id: string, userNameDTO: UserNameDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameUser(id, userNameDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UserUpdateDTO} userUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id: string, userUpdateDTO: UserUpdateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(id, userUpdateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAPIApi - factory interface
 * @export
 */
export const UserAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fullDeleteUser(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.fullDeleteUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserFilter} userFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmin(userFilter: UserFilter, options?: any): AxiosPromise<PageUserResponseDTO> {
            return localVarFp.getAdmin(userFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo(options?: any): AxiosPromise<UserInfo> {
            return localVarFp.getUserInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoByUserName(name: string, options?: any): AxiosPromise<UserDetails> {
            return localVarFp.getUserInfoByUserName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserFilter} userFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(userFilter: UserFilter, options?: any): AxiosPromise<PageUserResponseSessionDTO> {
            return localVarFp.getUsers(userFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserCreateDTO} userCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser(userCreateDTO: UserCreateDTO, options?: any): AxiosPromise<UserResponseDTO> {
            return localVarFp.registerUser(userCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UserNameDTO} userNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameUser(id: string, userNameDTO: UserNameDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.renameUser(id, userNameDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UserUpdateDTO} userUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id: string, userUpdateDTO: UserUpdateDTO, options?: any): AxiosPromise<UserResponseDTO> {
            return localVarFp.updateUser(id, userUpdateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAPIApi - object-oriented interface
 * @export
 * @class UserAPIApi
 * @extends {BaseAPI}
 */
export class UserAPIApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public deleteUser(id: string, options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).deleteUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public fullDeleteUser(id: string, options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).fullDeleteUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserFilter} userFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public getAdmin(userFilter: UserFilter, options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).getAdmin(userFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public getUserInfo(options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).getUserInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public getUserInfoByUserName(name: string, options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).getUserInfoByUserName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserFilter} userFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public getUsers(userFilter: UserFilter, options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).getUsers(userFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserCreateDTO} userCreateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public registerUser(userCreateDTO: UserCreateDTO, options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).registerUser(userCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UserNameDTO} userNameDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public renameUser(id: string, userNameDTO: UserNameDTO, options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).renameUser(id, userNameDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UserUpdateDTO} userUpdateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    public updateUser(id: string, userUpdateDTO: UserUpdateDTO, options?: AxiosRequestConfig) {
        return UserAPIApiFp(this.configuration).updateUser(id, userUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebhookToGetSmsApi - axios parameter creator
 * @export
 */
export const WebhookToGetSmsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SmsDinstarDTO} smsDinstarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDinstarSms: async (smsDinstarDTO: SmsDinstarDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'smsDinstarDTO' is not null or undefined
            assertParamExists('addDinstarSms', 'smsDinstarDTO', smsDinstarDTO)
            const localVarPath = `/rest-api/sms/webhook/dinstar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smsDinstarDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SmsDTO} smsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHg7000Sms: async (smsDTO: SmsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'smsDTO' is not null or undefined
            assertParamExists('addHg7000Sms', 'smsDTO', smsDTO)
            const localVarPath = `/rest-api/sms/webhook/hg7000`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookToGetSmsApi - functional programming interface
 * @export
 */
export const WebhookToGetSmsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookToGetSmsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SmsDinstarDTO} smsDinstarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDinstarSms(smsDinstarDTO: SmsDinstarDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDinstarSms(smsDinstarDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SmsDTO} smsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addHg7000Sms(smsDTO: SmsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addHg7000Sms(smsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebhookToGetSmsApi - factory interface
 * @export
 */
export const WebhookToGetSmsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookToGetSmsApiFp(configuration)
    return {
        /**
         * 
         * @param {SmsDinstarDTO} smsDinstarDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDinstarSms(smsDinstarDTO: SmsDinstarDTO, options?: any): AxiosPromise<boolean> {
            return localVarFp.addDinstarSms(smsDinstarDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SmsDTO} smsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHg7000Sms(smsDTO: SmsDTO, options?: any): AxiosPromise<SmsDTO> {
            return localVarFp.addHg7000Sms(smsDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookToGetSmsApi - object-oriented interface
 * @export
 * @class WebhookToGetSmsApi
 * @extends {BaseAPI}
 */
export class WebhookToGetSmsApi extends BaseAPI {
    /**
     * 
     * @param {SmsDinstarDTO} smsDinstarDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookToGetSmsApi
     */
    public addDinstarSms(smsDinstarDTO: SmsDinstarDTO, options?: AxiosRequestConfig) {
        return WebhookToGetSmsApiFp(this.configuration).addDinstarSms(smsDinstarDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SmsDTO} smsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookToGetSmsApi
     */
    public addHg7000Sms(smsDTO: SmsDTO, options?: AxiosRequestConfig) {
        return WebhookToGetSmsApiFp(this.configuration).addHg7000Sms(smsDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


